const GameControllerLight = () => (
  <svg
    fill="none"
    height="22"
    viewBox="0 0 25 22"
    width="25"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      height="5"
      id="mask0_253_19555"
      maskUnits="userSpaceOnUse"
      style={{ maskType: 'luminance' }}
      width="13"
      x="4"
      y="1"
    >
      <path
        d="M16.4659 2.30356L16.5783 2.7813C15.9526 2.90745 4.7959 5.17 4.54791 5.221H4.5335L4.42104 4.74594C4.29127 4.19305 4.66903 3.64553 5.26305 3.52475L15.1538 1.51985C15.7479 1.39908 16.3361 1.75067 16.4659 2.30356Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_253_19555)">
      <path
        d="M4.28955 4.19043L4.52873 5.22374H4.28955V4.19043Z"
        fill="url(#paint0_linear_253_19555)"
      />
      <path
        d="M4.28955 3.28906L4.74196 5.22418H4.52873L4.28955 4.19086V3.28906Z"
        fill="url(#paint1_linear_253_19555)"
      />
      <path
        d="M4.28955 3.17063L4.46245 3.13574L4.95232 5.22384H4.74196L4.28955 3.28873V3.17063Z"
        fill="url(#paint2_linear_253_19555)"
      />
      <path
        d="M4.46045 3.13596L4.66216 3.0957L5.16068 5.22406H4.95032L4.46045 3.13596Z"
        fill="url(#paint3_linear_253_19555)"
      />
      <path
        d="M4.66357 3.09592L4.86529 3.05566L5.37245 5.22428H5.16209L4.66357 3.09592Z"
        fill="url(#paint4_linear_253_19555)"
      />
      <path
        d="M4.86523 3.05491L5.06695 3.01465L5.58276 5.22353H5.3724L4.86523 3.05491Z"
        fill="url(#paint5_linear_253_19555)"
      />
      <path
        d="M5.06689 3.0156L5.26861 2.97266L5.79306 5.22448H5.5827L5.06689 3.0156Z"
        fill="url(#paint6_linear_253_19555)"
      />
      <path
        d="M5.26855 2.9719L5.47027 2.93164L6.00625 5.22372H5.79301L5.26855 2.9719Z"
        fill="url(#paint7_linear_253_19555)"
      />
      <path
        d="M5.47217 2.93186L5.67388 2.8916L6.21851 5.22394H6.00815L5.47217 2.93186Z"
        fill="url(#paint8_linear_253_19555)"
      />
      <path
        d="M5.67383 2.89182L5.87266 2.85156L6.42881 5.22416H6.21845L5.67383 2.89182Z"
        fill="url(#paint9_linear_253_19555)"
      />
      <path
        d="M5.87354 2.85154L6.07525 2.80859L6.64005 5.22413H6.42969L5.87354 2.85154Z"
        fill="url(#paint10_linear_253_19555)"
      />
      <path
        d="M6.07373 2.80881L6.27544 2.76855L6.84889 5.22435H6.63853L6.07373 2.80881Z"
        fill="url(#paint11_linear_253_19555)"
      />
      <path
        d="M6.27539 2.7678L6.4771 2.72754L7.05919 5.2236H6.84883L6.27539 2.7678Z"
        fill="url(#paint12_linear_253_19555)"
      />
      <path
        d="M6.47852 2.72776L6.68023 2.6875L7.27096 5.21577L7.23926 5.22382H7.0606L6.47852 2.72776Z"
        fill="url(#paint13_linear_253_19555)"
      />
      <path
        d="M6.88351 2.64599L6.68359 2.68652L7.27528 5.21446L7.47519 5.17393L6.88351 2.64599Z"
        fill="url(#paint14_linear_253_19555)"
      />
      <path
        d="M7.08175 2.60693L6.88184 2.64746L7.47353 5.1754L7.67344 5.13486L7.08175 2.60693Z"
        fill="url(#paint15_linear_253_19555)"
      />
      <path
        d="M7.27853 2.56591L7.07861 2.60645L7.6703 5.13438L7.87021 5.09385L7.27853 2.56591Z"
        fill="url(#paint16_linear_253_19555)"
      />
      <path
        d="M7.4836 2.52685L7.28369 2.56738L7.87538 5.09532L8.07529 5.05479L7.4836 2.52685Z"
        fill="url(#paint17_linear_253_19555)"
      />
      <path
        d="M7.68331 2.48193L7.4834 2.52246L8.07509 5.0504L8.275 5.00986L7.68331 2.48193Z"
        fill="url(#paint18_linear_253_19555)"
      />
      <path
        d="M7.88692 2.44286L7.68701 2.4834L8.2787 5.01134L8.47861 4.9708L7.88692 2.44286Z"
        fill="url(#paint19_linear_253_19555)"
      />
      <path
        d="M8.08858 2.40087L7.88867 2.44141L8.48036 4.96935L8.68027 4.92881L8.08858 2.40087Z"
        fill="url(#paint20_linear_253_19555)"
      />
      <path
        d="M8.29024 2.36181L8.09033 2.40234L8.68202 4.93028L8.88193 4.88975L8.29024 2.36181Z"
        fill="url(#paint21_linear_253_19555)"
      />
      <path
        d="M8.48995 2.31786L8.29004 2.3584L8.88173 4.88634L9.08164 4.8458L8.48995 2.31786Z"
        fill="url(#paint22_linear_253_19555)"
      />
      <path
        d="M8.69161 2.27978L8.4917 2.32031L9.08339 4.84825L9.2833 4.80772L8.69161 2.27978Z"
        fill="url(#paint23_linear_253_19555)"
      />
      <path
        d="M8.89327 2.23778L8.69336 2.27832L9.28505 4.80626L9.48496 4.76572L8.89327 2.23778Z"
        fill="url(#paint24_linear_253_19555)"
      />
      <path
        d="M9.09688 2.19872L8.89697 2.23926L9.48866 4.7672L9.68857 4.72666L9.09688 2.19872Z"
        fill="url(#paint25_linear_253_19555)"
      />
      <path
        d="M9.29854 2.15673L9.09863 2.19727L9.69032 4.72521L9.89023 4.68467L9.29854 2.15673Z"
        fill="url(#paint26_linear_253_19555)"
      />
      <path
        d="M9.50167 2.11474L9.30176 2.15527L9.89345 4.68321L10.0934 4.64268L9.50167 2.11474Z"
        fill="url(#paint27_linear_253_19555)"
      />
      <path
        d="M9.69991 2.07372L9.5 2.11426L10.0917 4.6422L10.2916 4.60166L9.69991 2.07372Z"
        fill="url(#paint28_linear_253_19555)"
      />
      <path
        d="M9.90157 2.03466L9.70166 2.0752L10.2933 4.60313L10.4933 4.5626L9.90157 2.03466Z"
        fill="url(#paint29_linear_253_19555)"
      />
      <path
        d="M10.1018 1.99267L9.90186 2.0332L10.4935 4.56114L10.6935 4.52061L10.1018 1.99267Z"
        fill="url(#paint30_linear_253_19555)"
      />
      <path
        d="M10.3015 1.95165L10.1016 1.99219L10.6933 4.52013L10.8932 4.47959L10.3015 1.95165Z"
        fill="url(#paint31_linear_253_19555)"
      />
      <path
        d="M10.5051 1.90966L10.3052 1.9502L10.8969 4.47813L11.0968 4.4376L10.5051 1.90966Z"
        fill="url(#paint32_linear_253_19555)"
      />
      <path
        d="M10.7067 1.8706L10.5068 1.91113L11.0985 4.43907L11.2984 4.39854L10.7067 1.8706Z"
        fill="url(#paint33_linear_253_19555)"
      />
      <path
        d="M10.9084 1.8286L10.7085 1.86914L11.3002 4.39708L11.5001 4.35654L10.9084 1.8286Z"
        fill="url(#paint34_linear_253_19555)"
      />
      <path
        d="M11.1101 1.78954L10.9102 1.83008L11.5018 4.35802L11.7018 4.31748L11.1101 1.78954Z"
        fill="url(#paint35_linear_253_19555)"
      />
      <path
        d="M11.3132 1.7456L11.1133 1.78613L11.705 4.31407L11.9049 4.27354L11.3132 1.7456Z"
        fill="url(#paint36_linear_253_19555)"
      />
      <path
        d="M11.5114 1.70653L11.3115 1.74707L11.9032 4.27501L12.1031 4.23447L11.5114 1.70653Z"
        fill="url(#paint37_linear_253_19555)"
      />
      <path
        d="M11.715 1.66552L11.5151 1.70605L12.1068 4.23399L12.3067 4.19346L11.715 1.66552Z"
        fill="url(#paint38_linear_253_19555)"
      />
      <path
        d="M11.9167 1.62646L11.7168 1.66699L12.3085 4.19493L12.5084 4.1544L11.9167 1.62646Z"
        fill="url(#paint39_linear_253_19555)"
      />
      <path
        d="M12.115 1.58739L11.915 1.62793L12.5067 4.15587L12.7066 4.11533L12.115 1.58739Z"
        fill="url(#paint40_linear_253_19555)"
      />
      <path
        d="M12.3181 1.54247L12.1182 1.58301L12.7099 4.11095L12.9098 4.07041L12.3181 1.54247Z"
        fill="url(#paint41_linear_253_19555)"
      />
      <path
        d="M12.5197 1.50341L12.3198 1.54395L12.9115 4.07188L13.1114 4.03135L12.5197 1.50341Z"
        fill="url(#paint42_linear_253_19555)"
      />
      <path
        d="M12.7214 1.46142L12.5215 1.50195L13.1132 4.02989L13.3131 3.98936L12.7214 1.46142Z"
        fill="url(#paint43_linear_253_19555)"
      />
      <path
        d="M12.9216 1.42333L12.7217 1.46387L13.3134 3.99181L13.5133 3.95127L12.9216 1.42333Z"
        fill="url(#paint44_linear_253_19555)"
      />
      <path
        d="M12.9233 1.42089L13.0358 1.39941H16.574V3.32916L13.5174 3.94915L12.9233 1.42089Z"
        fill="url(#paint45_linear_253_19555)"
      />
    </g>
    <path
      d="M22.4322 6.67092L23.9043 13.9429C24.28 15.7971 23.2173 17.6573 21.5013 18.0854C19.76 18.5195 18.016 17.3286 17.6375 15.4594C17.4973 14.766 17.1075 14.1992 16.5944 13.8464C16.0813 13.4907 15.442 13.3459 14.797 13.4967L11.0874 14.365C9.80039 14.6665 8.98444 16.0352 9.26483 17.4191C9.64056 19.2733 8.8162 20.0965 7.09176 20.5005L6.81137 21.0662C5.08413 21.446 3.35409 20.6993 2.97836 18.8451L1.54834 11.7902C2.33345 14.2173 4.69718 15.6885 7.09176 15.1278C9.67701 14.5218 11.3173 11.7782 10.7537 8.99542C10.2014 6.27295 7.74228 4.52429 5.21311 5.02477L16.4766 2.38672C13.9811 3.06508 12.4221 5.75137 12.9745 8.47685C13.5381 11.2566 16.0897 13.0203 18.6777 12.4143C21.2405 11.8144 22.8752 9.113 22.3537 6.35736C22.3846 6.45987 22.4098 6.56238 22.4322 6.67092Z"
      fill="url(#paint46_linear_253_19555)"
    />
    <path
      d="M22.3453 6.393C22.3453 6.393 22.3453 6.43978 22.3567 6.46317C22.3567 6.43978 22.3453 6.41639 22.3338 6.393C22.3338 6.33453 22.3108 6.27606 22.2993 6.22928C22.2993 6.19419 22.2878 6.15911 22.2764 6.12402C22.2993 6.21758 22.3223 6.31114 22.3453 6.4047V6.393Z"
      fill="white"
    />
    <path
      d="M16.6719 2.54567C19.1861 1.98432 21.6774 3.58651 22.2744 6.12429C21.5971 3.65668 19.1517 2.11296 16.6604 2.62753V2.55737H16.6489H16.6719V2.54567Z"
      fill="white"
    />
    <path
      d="M16.6613 2.61621L16.4316 2.67469C16.489 2.66299 16.535 2.6513 16.5924 2.6396C16.6153 2.6396 16.6383 2.6396 16.6613 2.62791V2.61621Z"
      fill="white"
    />
    <path
      d="M16.6485 2.5459V2.61607C16.6485 2.61607 16.6141 2.61607 16.5911 2.62776C16.5337 2.63946 16.4878 2.65115 16.4304 2.66285L5.06457 5.18893C5.06457 5.18893 4.96125 5.21232 4.90385 5.22401C4.88088 5.22401 4.8694 5.22401 4.84644 5.23571V5.16554C5.08754 5.10707 16.0401 2.67454 16.6485 2.5459Z"
      fill="white"
    />
    <path
      d="M5.06676 5.18848L4.84863 5.23447C4.84863 5.23447 4.88307 5.22297 4.90604 5.22297C4.96344 5.21147 5.00936 5.19998 5.06676 5.18848Z"
      fill="white"
    />
    <path
      d="M4.82494 5.16504V5.23521C2.85026 5.703 1.42666 7.36367 1.13965 9.30501C1.36926 7.32858 2.80434 5.62114 4.82494 5.16504Z"
      fill="white"
    />
    <path
      d="M2.58176 9.07227C2.53256 9.51333 2.55224 9.97444 2.65065 10.4355C2.66049 10.4857 2.67033 10.5358 2.68017 10.5759C2.69001 10.6862 2.70969 10.7964 2.72937 10.9067L2.76874 11.0871C2.70969 10.9267 2.67033 10.7663 2.63097 10.5959C2.52272 10.0847 2.51288 9.56345 2.58176 9.07227Z"
      fill="white"
    />
    <mask
      height="11"
      id="mask1_253_19555"
      maskUnits="userSpaceOnUse"
      style={{ maskType: 'luminance' }}
      width="11"
      x="12"
      y="2"
    >
      <path
        d="M22.3765 6.37223C22.3853 6.39874 22.3941 6.41935 22.3999 6.44586C22.9456 9.13804 21.2353 11.7772 18.5539 12.3634C15.8491 12.9554 13.1765 11.2323 12.5869 8.51654C12.0089 5.85677 13.643 3.22939 16.251 2.56666L16.4945 2.51364C19.079 1.9864 21.6137 3.56223 22.3149 6.08946C22.3237 6.12775 22.3325 6.1631 22.3413 6.20139C22.353 6.25735 22.3647 6.31626 22.3765 6.37517V6.37223ZM20.3405 6.817C20.2349 6.3251 19.7479 6.01288 19.2609 6.12186C18.771 6.2279 18.46 6.71685 18.5686 7.2058C18.6771 7.69475 19.1612 8.00992 19.6482 7.90388C20.1381 7.79784 20.4491 7.30889 20.3405 6.817ZM17.9437 5.27061C17.8381 4.77872 17.3511 4.4665 16.8641 4.57548C16.562 4.64323 16.3273 4.8553 16.2187 5.12629C16.1542 5.29123 16.1337 5.47385 16.1747 5.66236C16.2803 6.15426 16.7673 6.46648 17.2543 6.36045C17.7442 6.25441 18.0552 5.76546 17.9467 5.27356L17.9437 5.27061ZM18.8004 9.22641C18.6947 8.73451 18.2078 8.42229 17.7208 8.53127C17.2308 8.63731 16.9199 9.12626 17.0284 9.61521C17.134 10.1071 17.621 10.4193 18.108 10.3133C18.5979 10.2073 18.9089 9.7183 18.8004 9.22641ZM16.4036 7.68002C16.2979 7.18813 15.811 6.87591 15.324 6.98489C14.8341 7.09093 14.5231 7.57988 14.6316 8.06883C14.7372 8.56073 15.2242 8.87295 15.7112 8.76691C16.1982 8.66087 16.5121 8.17192 16.4036 7.68002Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask1_253_19555)">
      <path
        d="M14.5215 8.80176L14.5358 8.87245H14.5215V8.80176Z"
        fill="url(#paint47_linear_253_19555)"
      />
      <path
        d="M14.5215 8.34863L14.6358 8.87293H14.5361L14.5215 8.80224V8.34863Z"
        fill="url(#paint48_linear_253_19555)"
      />
      <path
        d="M14.5215 7.8916L14.7355 8.87245H14.6358L14.5215 8.34815V7.8916Z"
        fill="url(#paint49_linear_253_19555)"
      />
      <path
        d="M14.5215 7.43848L14.8322 8.87293H14.7355L14.5215 7.89208V7.43848Z"
        fill="url(#paint50_linear_253_19555)"
      />
      <path
        d="M14.5215 6.98145L14.9319 8.87245H14.8322L14.5215 7.438V6.98145Z"
        fill="url(#paint51_linear_253_19555)"
      />
      <path
        d="M14.5977 6.87598L15.0287 8.87302H14.9319L14.5215 6.98201V6.87598H14.5977Z"
        fill="url(#paint52_linear_253_19555)"
      />
      <path
        d="M14.6968 6.87598L15.1307 8.87302H15.031L14.6001 6.87598H14.6968Z"
        fill="url(#paint53_linear_253_19555)"
      />
      <path
        d="M14.7955 6.87598L15.2294 8.87302H15.1297L14.6958 6.87598H14.7955Z"
        fill="url(#paint54_linear_253_19555)"
      />
      <path
        d="M14.8946 6.87598L15.3255 8.87302H15.2288L14.7949 6.87598H14.8946Z"
        fill="url(#paint55_linear_253_19555)"
      />
      <path
        d="M14.9923 6.87598L15.4261 8.87302H15.3265L14.8955 6.87598H14.9923Z"
        fill="url(#paint56_linear_253_19555)"
      />
      <path
        d="M15.0909 6.87598L15.5248 8.87302H15.4251L14.9912 6.87598H15.0909Z"
        fill="url(#paint57_linear_253_19555)"
      />
      <path
        d="M15.192 6.87598L15.6229 8.87302H15.5262L15.0923 6.87598H15.192Z"
        fill="url(#paint58_linear_253_19555)"
      />
      <path
        d="M15.2881 6.87598L15.722 8.87302H15.6224L15.1914 6.87598H15.2881Z"
        fill="url(#paint59_linear_253_19555)"
      />
      <path
        d="M15.3882 6.87598L15.8221 8.87302H15.7225L15.2886 6.87598H15.3882Z"
        fill="url(#paint60_linear_253_19555)"
      />
      <path
        d="M15.4893 6.87598L15.9203 8.87302H15.8235L15.3896 6.87598H15.4893Z"
        fill="url(#paint61_linear_253_19555)"
      />
      <path
        d="M15.587 6.87598L16.0209 8.87302H15.9212L15.4902 6.87598H15.587Z"
        fill="url(#paint62_linear_253_19555)"
      />
      <path
        d="M15.6856 6.87598L16.1166 8.87302H16.0198L15.5859 6.87598H15.6856Z"
        fill="url(#paint63_linear_253_19555)"
      />
      <path
        d="M15.7818 6.87598L16.2157 8.87302H16.116L15.6851 6.87598H15.7818Z"
        fill="url(#paint64_linear_253_19555)"
      />
      <path
        d="M15.8824 6.87598L16.3163 8.87302H16.2166L15.7827 6.87598H15.8824Z"
        fill="url(#paint65_linear_253_19555)"
      />
      <path
        d="M15.9815 6.87598L16.4125 8.87302H16.3157L15.8818 6.87598H15.9815Z"
        fill="url(#paint66_linear_253_19555)"
      />
      <path
        d="M16.0792 6.87598L16.5101 8.86418V8.87302H16.4134L15.9824 6.87598H16.0792Z"
        fill="url(#paint67_linear_253_19555)"
      />
      <path
        d="M16.1778 6.87598L16.5091 8.41058V8.86418L16.0781 6.87598H16.1778Z"
        fill="url(#paint68_linear_253_19555)"
      />
      <path
        d="M16.2789 6.87598L16.5105 7.95697V8.41058L16.1792 6.87598H16.2789Z"
        fill="url(#paint69_linear_253_19555)"
      />
      <path
        d="M16.3751 6.87598L16.5099 7.50042V7.95697L16.2783 6.87598H16.3751Z"
        fill="url(#paint70_linear_253_19555)"
      />
      <path
        d="M16.4737 6.87598L16.5089 7.04681V7.50042L16.374 6.87598H16.4737Z"
        fill="url(#paint71_linear_253_19555)"
      />
      <path
        d="M16.5089 7.04681L16.4746 6.87598H16.5089V7.04681Z"
        fill="url(#paint72_linear_253_19555)"
      />
      <path
        d="M16.9209 10.3047L16.9466 10.4196H16.9209V10.3047Z"
        fill="url(#paint73_linear_253_19555)"
      />
      <path
        d="M16.9209 9.84766L17.047 10.4191H16.9473L16.9209 10.3042V9.84766Z"
        fill="url(#paint74_linear_253_19555)"
      />
      <path
        d="M16.9209 9.39453L17.1437 10.4196H17.047L16.9209 9.84814V9.39453Z"
        fill="url(#paint75_linear_253_19555)"
      />
      <path
        d="M16.9209 8.9375L17.2434 10.4191H17.1437L16.9209 9.39405V8.9375Z"
        fill="url(#paint76_linear_253_19555)"
      />
      <path
        d="M16.9209 8.48438L17.3401 10.4196H17.2434L16.9209 8.93798V8.48438Z"
        fill="url(#paint77_linear_253_19555)"
      />
      <path
        d="M17.0059 8.42188L17.4398 10.4189H17.3401L16.9209 8.48373V8.42188H17.0059Z"
        fill="url(#paint78_linear_253_19555)"
      />
      <path
        d="M17.106 8.42188L17.5399 10.4189H17.4402L17.0063 8.42188H17.106Z"
        fill="url(#paint79_linear_253_19555)"
      />
      <path
        d="M17.2051 8.42188L17.6361 10.4189H17.5394L17.1055 8.42188H17.2051Z"
        fill="url(#paint80_linear_253_19555)"
      />
      <path
        d="M17.2994 8.42188L17.7333 10.4189H17.6336L17.2026 8.42188H17.2994Z"
        fill="url(#paint81_linear_253_19555)"
      />
      <path
        d="M17.4014 8.42188L17.8353 10.4189H17.7356L17.3018 8.42188H17.4014Z"
        fill="url(#paint82_linear_253_19555)"
      />
      <path
        d="M17.4991 8.42188L17.93 10.4189H17.8333L17.3994 8.42188H17.4991Z"
        fill="url(#paint83_linear_253_19555)"
      />
      <path
        d="M17.5967 8.42188L18.0306 10.4189H17.9309L17.5 8.42188H17.5967Z"
        fill="url(#paint84_linear_253_19555)"
      />
      <path
        d="M17.6973 8.42188L18.1312 10.4189H18.0315L17.5977 8.42188H17.6973Z"
        fill="url(#paint85_linear_253_19555)"
      />
      <path
        d="M17.7935 8.42188L18.2274 10.4189H18.1307L17.6968 8.42188H17.7935Z"
        fill="url(#paint86_linear_253_19555)"
      />
      <path
        d="M17.8936 8.42188L18.3275 10.4189H18.2278L17.7939 8.42188H17.8936Z"
        fill="url(#paint87_linear_253_19555)"
      />
      <path
        d="M17.9927 8.42188L18.4237 10.4189H18.3269L17.8931 8.42188H17.9927Z"
        fill="url(#paint88_linear_253_19555)"
      />
      <path
        d="M18.0889 8.42188L18.5228 10.4189H18.4231L17.9922 8.42188H18.0889Z"
        fill="url(#paint89_linear_253_19555)"
      />
      <path
        d="M18.1895 8.42188L18.6234 10.4189H18.5237L18.0898 8.42188H18.1895Z"
        fill="url(#paint90_linear_253_19555)"
      />
      <path
        d="M18.2921 8.42188L18.723 10.4189H18.6263L18.1924 8.42188H18.2921Z"
        fill="url(#paint91_linear_253_19555)"
      />
      <path
        d="M18.3863 8.42188L18.8202 10.4189H18.7205L18.2896 8.42188H18.3863Z"
        fill="url(#paint92_linear_253_19555)"
      />
      <path
        d="M18.4883 8.42188L18.9105 10.3659V10.4189H18.8226L18.3887 8.42188H18.4883Z"
        fill="url(#paint93_linear_253_19555)"
      />
      <path
        d="M18.5875 8.42188L18.9099 9.91229V10.3659L18.4878 8.42188H18.5875Z"
        fill="url(#paint94_linear_253_19555)"
      />
      <path
        d="M18.6822 8.42188L18.9079 9.45574V9.91229L18.5854 8.42188H18.6822Z"
        fill="url(#paint95_linear_253_19555)"
      />
      <path
        d="M18.7842 8.42188L18.9103 9.00214V9.45574L18.6846 8.42188H18.7842Z"
        fill="url(#paint96_linear_253_19555)"
      />
      <path
        d="M18.8785 8.42188L18.9078 8.54559V9.00214L18.7817 8.42188H18.8785Z"
        fill="url(#paint97_linear_253_19555)"
      />
      <path
        d="M18.9094 8.54559L18.8809 8.42188H18.9094V8.54559Z"
        fill="url(#paint98_linear_253_19555)"
      />
      <path
        d="M16.1313 6.19824L16.187 6.46628H16.1313V6.19824Z"
        fill="url(#paint99_linear_253_19555)"
      />
      <path
        d="M16.1313 5.74512L16.2867 6.46676H16.187L16.1313 6.19872V5.74512Z"
        fill="url(#paint100_linear_253_19555)"
      />
      <path
        d="M16.1313 5.29102L16.3835 6.46627H16.2867L16.1313 5.74462V5.29102Z"
        fill="url(#paint101_linear_253_19555)"
      />
      <path
        d="M16.1313 4.83496L16.4831 6.46676H16.3835L16.1313 5.29151V4.83496Z"
        fill="url(#paint102_linear_253_19555)"
      />
      <path
        d="M16.1489 4.46973L16.5828 6.46677H16.4831L16.1313 4.83497V4.46973H16.1489Z"
        fill="url(#paint103_linear_253_19555)"
      />
      <path
        d="M16.2481 4.46973L16.6791 6.46677H16.5823L16.1484 4.46973H16.2481Z"
        fill="url(#paint104_linear_253_19555)"
      />
      <path
        d="M16.3443 4.46973L16.7782 6.46677H16.6785L16.2476 4.46973H16.3443Z"
        fill="url(#paint105_linear_253_19555)"
      />
      <path
        d="M16.4444 4.46973L16.8783 6.46677H16.7786L16.3447 4.46973H16.4444Z"
        fill="url(#paint106_linear_253_19555)"
      />
      <path
        d="M16.5435 4.46973L16.9745 6.46677H16.8777L16.4438 4.46973H16.5435Z"
        fill="url(#paint107_linear_253_19555)"
      />
      <path
        d="M16.6397 4.46973L17.0736 6.46677H16.9739L16.543 4.46973H16.6397Z"
        fill="url(#paint108_linear_253_19555)"
      />
      <path
        d="M16.7403 4.46973L17.1742 6.46677H17.0745L16.6406 4.46973H16.7403Z"
        fill="url(#paint109_linear_253_19555)"
      />
      <path
        d="M16.8394 4.46973L17.2704 6.46677H17.1736L16.7397 4.46973H16.8394Z"
        fill="url(#paint110_linear_253_19555)"
      />
      <path
        d="M16.9371 4.46973L17.371 6.46677H17.2713L16.8403 4.46973H16.9371Z"
        fill="url(#paint111_linear_253_19555)"
      />
      <path
        d="M17.0391 4.46973L17.4701 6.46677H17.3733L16.9395 4.46973H17.0391Z"
        fill="url(#paint112_linear_253_19555)"
      />
      <path
        d="M17.1339 4.46973L17.5677 6.46677H17.4681L17.0371 4.46973H17.1339Z"
        fill="url(#paint113_linear_253_19555)"
      />
      <path
        d="M17.234 4.46973L17.6678 6.46677H17.5682L17.1343 4.46973H17.234Z"
        fill="url(#paint114_linear_253_19555)"
      />
      <path
        d="M17.335 4.46973L17.766 6.46677H17.6692L17.2354 4.46973H17.335Z"
        fill="url(#paint115_linear_253_19555)"
      />
      <path
        d="M17.4293 4.46973L17.8631 6.46677H17.7635L17.3325 4.46973H17.4293Z"
        fill="url(#paint116_linear_253_19555)"
      />
      <path
        d="M17.5313 4.46973L17.9652 6.46677H17.8655L17.4316 4.46973H17.5313Z"
        fill="url(#paint117_linear_253_19555)"
      />
      <path
        d="M17.6304 4.46973L18.0497 6.41375V6.46677H17.9646L17.5308 4.46973H17.6304Z"
        fill="url(#paint118_linear_253_19555)"
      />
      <path
        d="M17.7266 4.46973L18.0491 5.9572V6.41375L17.6299 4.46973H17.7266Z"
        fill="url(#paint119_linear_253_19555)"
      />
      <path
        d="M17.8272 4.46973L18.05 5.50359V5.9572L17.7275 4.46973H17.8272Z"
        fill="url(#paint120_linear_253_19555)"
      />
      <path
        d="M17.9234 4.46973L18.0495 5.04999V5.50359L17.8267 4.46973H17.9234Z"
        fill="url(#paint121_linear_253_19555)"
      />
      <path
        d="M18.0235 4.46973L18.0499 4.59344V5.04999L17.9238 4.46973H18.0235Z"
        fill="url(#paint122_linear_253_19555)"
      />
      <path
        d="M18.0487 4.59344L18.0229 4.46973H18.0487V4.59344Z"
        fill="url(#paint123_linear_253_19555)"
      />
      <path
        d="M18.4604 7.85059L18.4948 8.00964H18.4604V7.85059Z"
        fill="url(#paint124_linear_253_19555)"
      />
      <path
        d="M18.4604 7.39746L18.5953 8.01012H18.4956L18.4604 7.85107V7.39746Z"
        fill="url(#paint125_linear_253_19555)"
      />
      <path
        d="M18.4604 6.94043L18.692 8.00964H18.5953L18.4604 7.39698V6.94043Z"
        fill="url(#paint126_linear_253_19555)"
      />
      <path
        d="M18.4604 6.4873L18.7917 8.01012H18.692L18.4604 6.94091V6.4873Z"
        fill="url(#paint127_linear_253_19555)"
      />
      <path
        d="M18.4604 6.03027L18.8914 8.00964H18.7917L18.4604 6.48682V6.03027Z"
        fill="url(#paint128_linear_253_19555)"
      />
      <path
        d="M18.5572 6.01562L18.9881 8.00972H18.8914L18.4604 6.03035V6.01562H18.5572Z"
        fill="url(#paint129_linear_253_19555)"
      />
      <path
        d="M18.6529 6.01562L19.0868 8.00972H18.9871L18.5562 6.01562H18.6529Z"
        fill="url(#paint130_linear_253_19555)"
      />
      <path
        d="M18.7515 6.01562L19.1854 8.00972H19.0857L18.6519 6.01562H18.7515Z"
        fill="url(#paint131_linear_253_19555)"
      />
      <path
        d="M18.8526 6.01562L19.2836 8.00972H19.1868L18.7529 6.01562H18.8526Z"
        fill="url(#paint132_linear_253_19555)"
      />
      <path
        d="M18.9488 6.01562L19.3827 8.00972H19.283L18.8521 6.01562H18.9488Z"
        fill="url(#paint133_linear_253_19555)"
      />
      <path
        d="M19.0489 6.01562L19.4798 8.00972H19.3831L18.9492 6.01562H19.0489Z"
        fill="url(#paint134_linear_253_19555)"
      />
      <path
        d="M19.1451 6.01562L19.579 8.00972H19.4793L19.0483 6.01562H19.1451Z"
        fill="url(#paint135_linear_253_19555)"
      />
      <path
        d="M19.2457 6.01562L19.6796 8.00972H19.5799L19.146 6.01562H19.2457Z"
        fill="url(#paint136_linear_253_19555)"
      />
      <path
        d="M19.3448 6.01562L19.7757 8.00972H19.679L19.2451 6.01562H19.3448Z"
        fill="url(#paint137_linear_253_19555)"
      />
      <path
        d="M19.441 6.01562L19.8749 8.00972H19.7752L19.3442 6.01562H19.441Z"
        fill="url(#paint138_linear_253_19555)"
      />
      <path
        d="M19.5411 6.01562L19.975 8.00972H19.8753L19.4414 6.01562H19.5411Z"
        fill="url(#paint139_linear_253_19555)"
      />
      <path
        d="M19.6422 6.01562L20.0731 8.00972H19.9764L19.5425 6.01562H19.6422Z"
        fill="url(#paint140_linear_253_19555)"
      />
      <path
        d="M19.7398 6.01562L20.1737 8.00972H20.074L19.6431 6.01562H19.7398Z"
        fill="url(#paint141_linear_253_19555)"
      />
      <path
        d="M19.8384 6.01562L20.2723 8.00972H20.1726L19.7388 6.01562H19.8384Z"
        fill="url(#paint142_linear_253_19555)"
      />
      <path
        d="M19.9395 6.01562L20.3705 8.00972H20.2737L19.8398 6.01562H19.9395Z"
        fill="url(#paint143_linear_253_19555)"
      />
      <path
        d="M20.0357 6.01562L20.4491 7.91252V8.00972H20.3699L19.939 6.01562H20.0357Z"
        fill="url(#paint144_linear_253_19555)"
      />
      <path
        d="M20.1343 6.01562L20.448 7.45891V7.91252L20.0347 6.01562H20.1343Z"
        fill="url(#paint145_linear_253_19555)"
      />
      <path
        d="M20.232 6.01562L20.4489 7.00531V7.45891L20.1353 6.01562H20.232Z"
        fill="url(#paint146_linear_253_19555)"
      />
      <path
        d="M20.3306 6.01562L20.4479 6.54876V7.00531L20.231 6.01562H20.3306Z"
        fill="url(#paint147_linear_253_19555)"
      />
      <path
        d="M20.4317 6.01562L20.4493 6.09515V6.54876L20.332 6.01562H20.4317Z"
        fill="url(#paint148_linear_253_19555)"
      />
      <path
        d="M20.4483 6.09515L20.4312 6.01562H20.4483V6.09515Z"
        fill="url(#paint149_linear_253_19555)"
      />
      <path
        d="M12.0093 5.85352L13.5494 12.9521H12.0093V5.85352Z"
        fill="url(#paint150_linear_253_19555)"
      />
      <path
        d="M12.0093 5.39746L13.6492 12.9526H13.5494L12.0093 5.85401V5.39746Z"
        fill="url(#paint151_linear_253_19555)"
      />
      <path
        d="M12.0093 4.94336L13.746 12.9521H13.6492L12.0093 5.39696V4.94336Z"
        fill="url(#paint152_linear_253_19555)"
      />
      <path
        d="M12.0093 4.4873L13.8457 12.9526H13.746L12.0093 4.94386V4.4873Z"
        fill="url(#paint153_linear_253_19555)"
      />
      <path
        d="M12.0093 4.0332L13.9455 12.9521H13.8457L12.0093 4.48681V4.0332Z"
        fill="url(#paint154_linear_253_19555)"
      />
      <path
        d="M12.0093 3.58008L14.0423 12.9526H13.9455L12.0093 4.03368V3.58008Z"
        fill="url(#paint155_linear_253_19555)"
      />
      <path
        d="M12.0093 3.12305L14.142 12.9521H14.0423L12.0093 3.5796V3.12305Z"
        fill="url(#paint156_linear_253_19555)"
      />
      <path
        d="M12.0093 2.88774L12.0533 2.87891L14.2418 12.9525H14.142L12.0093 3.12338V2.88774Z"
        fill="url(#paint157_linear_253_19555)"
      />
      <path
        d="M12.0537 2.87902L12.1505 2.8584L14.339 12.9526H14.2422L12.0537 2.87902Z"
        fill="url(#paint158_linear_253_19555)"
      />
      <path
        d="M12.1494 2.85851L12.2433 2.83789L14.4377 12.9527H14.3379L12.1494 2.85851Z"
        fill="url(#paint159_linear_253_19555)"
      />
      <path
        d="M12.2432 2.838L12.337 2.81738L14.5343 12.9528H14.4375L12.2432 2.838Z"
        fill="url(#paint160_linear_253_19555)"
      />
      <path
        d="M12.3389 2.81652L12.4327 2.7959L14.6359 12.9519H14.5362L12.3389 2.81652Z"
        fill="url(#paint161_linear_253_19555)"
      />
      <path
        d="M12.4312 2.79601L12.525 2.77539L14.7341 12.9521H14.6343L12.4312 2.79601Z"
        fill="url(#paint162_linear_253_19555)"
      />
      <path
        d="M12.5234 2.7755L12.6173 2.75488L14.8293 12.9522H14.7325L12.5234 2.7755Z"
        fill="url(#paint163_linear_253_19555)"
      />
      <path
        d="M12.6191 2.75499L12.713 2.73438L14.9309 12.9523H14.8311L12.6191 2.75499Z"
        fill="url(#paint164_linear_253_19555)"
      />
      <path
        d="M12.7134 2.73449L12.8073 2.71387L15.031 12.9524H14.9312L12.7134 2.73449Z"
        fill="url(#paint165_linear_253_19555)"
      />
      <path
        d="M12.8071 2.71398L12.901 2.69336L15.1276 12.9525H15.0308L12.8071 2.71398Z"
        fill="url(#paint166_linear_253_19555)"
      />
      <path
        d="M12.8994 2.69347L12.9933 2.67285L15.2258 12.9526H15.1261L12.8994 2.69347Z"
        fill="url(#paint167_linear_253_19555)"
      />
      <path
        d="M12.9937 2.67296L13.0905 2.65234L15.323 12.9527H15.2262L12.9937 2.67296Z"
        fill="url(#paint168_linear_253_19555)"
      />
      <path
        d="M13.0908 2.65245L13.1847 2.63184L15.4231 12.9528H15.3233L13.0908 2.65245Z"
        fill="url(#paint169_linear_253_19555)"
      />
      <path
        d="M13.1851 2.63097L13.2789 2.61035L15.5232 12.952H15.4234L13.1851 2.63097Z"
        fill="url(#paint170_linear_253_19555)"
      />
      <path
        d="M13.2788 2.61046L13.3727 2.58984L15.6199 12.9521H15.5231L13.2788 2.61046Z"
        fill="url(#paint171_linear_253_19555)"
      />
      <path
        d="M13.3745 2.58995L13.4684 2.56934L15.7214 12.9522H15.6217L13.3745 2.58995Z"
        fill="url(#paint172_linear_253_19555)"
      />
      <path
        d="M13.4653 2.56945L13.5592 2.54883L15.8181 12.9523H15.7184L13.4653 2.56945Z"
        fill="url(#paint173_linear_253_19555)"
      />
      <path
        d="M13.561 2.54894L13.6549 2.52832L15.9168 12.9524H15.8199L13.561 2.54894Z"
        fill="url(#paint174_linear_253_19555)"
      />
      <path
        d="M13.6548 2.52843L13.7487 2.50781L16.0164 12.9525H15.9166L13.6548 2.52843Z"
        fill="url(#paint175_linear_253_19555)"
      />
      <path
        d="M13.749 2.50792L13.8429 2.4873L16.1165 12.9526H16.0167L13.749 2.50792Z"
        fill="url(#paint176_linear_253_19555)"
      />
      <path
        d="M13.8428 2.48742L13.9396 2.4668L16.2132 12.9527H16.1164L13.8428 2.48742Z"
        fill="url(#paint177_linear_253_19555)"
      />
      <path
        d="M13.9404 2.46691L14.0343 2.44629L16.3138 12.9528H16.214L13.9404 2.46691Z"
        fill="url(#paint178_linear_253_19555)"
      />
      <path
        d="M14.0327 2.44542L14.1266 2.4248L16.409 12.952H16.3122L14.0327 2.44542Z"
        fill="url(#paint179_linear_253_19555)"
      />
      <path
        d="M14.1265 2.42492L14.2203 2.4043L16.5086 12.9521H16.4088L14.1265 2.42492Z"
        fill="url(#paint180_linear_253_19555)"
      />
      <path
        d="M14.2207 2.40441L14.3146 2.38379L16.6087 12.9522H16.509L14.2207 2.40441Z"
        fill="url(#paint181_linear_253_19555)"
      />
      <path
        d="M14.3145 2.3839L14.4083 2.36328L16.7054 12.9523H16.6086L14.3145 2.3839Z"
        fill="url(#paint182_linear_253_19555)"
      />
      <path
        d="M14.4102 2.36339L14.504 2.34277L16.807 12.9524H16.7072L14.4102 2.36339Z"
        fill="url(#paint183_linear_253_19555)"
      />
      <path
        d="M14.5024 2.34288L14.5963 2.32227L16.9051 12.9525H16.8054L14.5024 2.34288Z"
        fill="url(#paint184_linear_253_19555)"
      />
      <path
        d="M14.5967 2.32238L14.6906 2.30176L17.0023 12.9526H16.9055L14.5967 2.32238Z"
        fill="url(#paint185_linear_253_19555)"
      />
      <path
        d="M14.6904 2.30187L14.7872 2.28125L17.1019 12.9528H17.0021L14.6904 2.30187Z"
        fill="url(#paint186_linear_253_19555)"
      />
      <path
        d="M14.7861 2.28038L14.88 2.25977L17.1976 12.9519H17.1008L14.7861 2.28038Z"
        fill="url(#paint187_linear_253_19555)"
      />
      <path
        d="M14.8818 2.25988L14.9757 2.23926L17.2992 12.952H17.1994L14.8818 2.25988Z"
        fill="url(#paint188_linear_253_19555)"
      />
      <path
        d="M14.9741 2.23937L15.068 2.21875L17.3973 12.9521H17.2976L14.9741 2.23937Z"
        fill="url(#paint189_linear_253_19555)"
      />
      <path
        d="M15.0684 2.21886L15.1622 2.19824L17.4945 12.9522H17.3977L15.0684 2.21886Z"
        fill="url(#paint190_linear_253_19555)"
      />
      <path
        d="M15.1621 2.19835L15.256 2.17773L17.5941 12.9523H17.4944L15.1621 2.19835Z"
        fill="url(#paint191_linear_253_19555)"
      />
      <path
        d="M15.2563 2.17784L15.3502 2.15723L17.6942 12.9524H17.5945L15.2563 2.17784Z"
        fill="url(#paint192_linear_253_19555)"
      />
      <path
        d="M15.3521 2.15734L15.4459 2.13672L17.7929 12.9526H17.696L15.3521 2.15734Z"
        fill="url(#paint193_linear_253_19555)"
      />
      <path
        d="M15.4443 2.13683L15.5382 2.11621L17.891 12.9527H17.7913L15.4443 2.13683Z"
        fill="url(#paint194_linear_253_19555)"
      />
      <path
        d="M15.5381 2.11632L15.6349 2.0957L17.9906 12.9528H17.8909L15.5381 2.11632Z"
        fill="url(#paint195_linear_253_19555)"
      />
      <path
        d="M15.6357 2.09484L15.7296 2.07422L18.0883 12.9519H17.9915L15.6357 2.09484Z"
        fill="url(#paint196_linear_253_19555)"
      />
      <path
        d="M15.7295 2.07433L15.8234 2.05371L18.1879 12.952H18.0882L15.7295 2.07433Z"
        fill="url(#paint197_linear_253_19555)"
      />
      <path
        d="M15.8237 2.05382L15.9176 2.0332L18.2851 12.9521H18.1883L15.8237 2.05382Z"
        fill="url(#paint198_linear_253_19555)"
      />
      <path
        d="M15.916 2.03331L16.0099 2.0127L18.3832 12.9522H18.2835L15.916 2.03331Z"
        fill="url(#paint199_linear_253_19555)"
      />
      <path
        d="M16.0098 2.01281L16.1036 1.99219L18.4828 12.9523H18.3831L16.0098 2.01281Z"
        fill="url(#paint200_linear_253_19555)"
      />
      <path
        d="M16.104 1.99223L16.1392 1.9834H16.2008L18.58 12.9524H18.4832L16.104 1.99223Z"
        fill="url(#paint201_linear_253_19555)"
      />
      <path
        d="M16.3009 1.9834L18.6772 12.9377L18.6038 12.9524H18.5804L16.2012 1.9834H16.3009Z"
        fill="url(#paint202_linear_253_19555)"
      />
      <path
        d="M16.3971 1.9834L18.7704 12.9171L18.6766 12.9377L16.3003 1.9834H16.3971Z"
        fill="url(#paint203_linear_253_19555)"
      />
      <path
        d="M16.4977 1.9834L18.8652 12.8964L18.7713 12.9171L16.3979 1.9834H16.4977Z"
        fill="url(#paint204_linear_253_19555)"
      />
      <path
        d="M16.5968 1.9834L18.9584 12.8758L18.8645 12.8964L16.4971 1.9834H16.5968Z"
        fill="url(#paint205_linear_253_19555)"
      />
      <path
        d="M16.6945 1.9834L19.0531 12.8552L18.9592 12.8758L16.5977 1.9834H16.6945Z"
        fill="url(#paint206_linear_253_19555)"
      />
      <path
        d="M16.7931 1.9834L19.1459 12.8346L19.052 12.8552L16.6934 1.9834H16.7931Z"
        fill="url(#paint207_linear_253_19555)"
      />
      <path
        d="M16.8922 1.9834L19.2391 12.814L19.1453 12.8346L16.7925 1.9834H16.8922Z"
        fill="url(#paint208_linear_253_19555)"
      />
      <path
        d="M16.9899 1.9834L19.3368 12.7933L19.24 12.814L16.8931 1.9834H16.9899Z"
        fill="url(#paint209_linear_253_19555)"
      />
      <path
        d="M17.089 1.9834L19.4301 12.7727L19.3362 12.7933L16.9893 1.9834H17.089Z"
        fill="url(#paint210_linear_253_19555)"
      />
      <path
        d="M17.1867 1.9834L19.5248 12.7521L19.4309 12.7727L17.0898 1.9834H17.1867Z"
        fill="url(#paint211_linear_253_19555)"
      />
      <path
        d="M17.2853 1.9834L19.6175 12.7315L19.5237 12.7521L17.1855 1.9834H17.2853Z"
        fill="url(#paint212_linear_253_19555)"
      />
      <path
        d="M17.3864 1.9834L19.7128 12.7109L19.6189 12.7315L17.2866 1.9834H17.3864Z"
        fill="url(#paint213_linear_253_19555)"
      />
      <path
        d="M17.4826 1.9834L19.806 12.6902L19.7121 12.7109L17.3857 1.9834H17.4826Z"
        fill="url(#paint214_linear_253_19555)"
      />
      <path
        d="M17.5812 1.9834L19.8988 12.6696L19.8049 12.6902L17.4814 1.9834H17.5812Z"
        fill="url(#paint215_linear_253_19555)"
      />
      <path
        d="M17.6832 1.9834L19.995 12.649L19.9011 12.6696L17.5835 1.9834H17.6832Z"
        fill="url(#paint216_linear_253_19555)"
      />
      <path
        d="M17.7799 1.9834L20.0887 12.6284L19.9948 12.649L17.6831 1.9834H17.7799Z"
        fill="url(#paint217_linear_253_19555)"
      />
      <path
        d="M17.88 1.9834L20.1859 12.6078L20.0891 12.6284L17.7803 1.9834H17.88Z"
        fill="url(#paint218_linear_253_19555)"
      />
      <path
        d="M17.9762 1.9834L20.2791 12.5872L20.1852 12.6078L17.8794 1.9834H17.9762Z"
        fill="url(#paint219_linear_253_19555)"
      />
      <path
        d="M18.0768 1.9834L20.3738 12.5665L20.28 12.5872L17.9771 1.9834H18.0768Z"
        fill="url(#paint220_linear_253_19555)"
      />
      <path
        d="M18.1759 1.9834L20.4671 12.5459L20.3732 12.5665L18.0762 1.9834H18.1759Z"
        fill="url(#paint221_linear_253_19555)"
      />
      <path
        d="M18.2736 1.9834L20.5618 12.5253L20.4679 12.5459L18.1768 1.9834H18.2736Z"
        fill="url(#paint222_linear_253_19555)"
      />
      <path
        d="M18.3722 1.9834L20.6546 12.5047L20.5607 12.5253L18.2725 1.9834H18.3722Z"
        fill="url(#paint223_linear_253_19555)"
      />
      <path
        d="M18.4713 1.9834L20.7478 12.4841L20.654 12.5047L18.3716 1.9834H18.4713Z"
        fill="url(#paint224_linear_253_19555)"
      />
      <path
        d="M18.5695 1.9834L20.843 12.4634L20.7492 12.4841L18.4727 1.9834H18.5695Z"
        fill="url(#paint225_linear_253_19555)"
      />
      <path
        d="M18.6681 1.9834L20.9358 12.4428L20.8419 12.4634L18.5684 1.9834H18.6681Z"
        fill="url(#paint226_linear_253_19555)"
      />
      <path
        d="M18.7687 1.9834L21.0305 12.4222L20.9367 12.4428L18.6689 1.9834H18.7687Z"
        fill="url(#paint227_linear_253_19555)"
      />
      <path
        d="M18.8654 1.9834L21.1272 12.4016L21.0304 12.4222L18.7686 1.9834H18.8654Z"
        fill="url(#paint228_linear_253_19555)"
      />
      <path
        d="M18.9655 1.9834L21.2214 12.381L21.1276 12.4016L18.8657 1.9834H18.9655Z"
        fill="url(#paint229_linear_253_19555)"
      />
      <path
        d="M19.0617 1.9834L21.3147 12.3604L21.2208 12.381L18.9648 1.9834H19.0617Z"
        fill="url(#paint230_linear_253_19555)"
      />
      <path
        d="M19.1603 1.9834L21.4075 12.3397L21.3136 12.3604L19.0605 1.9834H19.1603Z"
        fill="url(#paint231_linear_253_19555)"
      />
      <path
        d="M19.2609 1.9834L21.5022 12.3191L21.4083 12.3397L19.1611 1.9834H19.2609Z"
        fill="url(#paint232_linear_253_19555)"
      />
      <path
        d="M19.3571 1.9834L21.5954 12.2985L21.5016 12.3191L19.2603 1.9834H19.3571Z"
        fill="url(#paint233_linear_253_19555)"
      />
      <path
        d="M19.4577 1.9834L21.6902 12.2779L21.5963 12.2985L19.3579 1.9834H19.4577Z"
        fill="url(#paint234_linear_253_19555)"
      />
      <path
        d="M19.5568 1.9834L21.7834 12.2573L21.6895 12.2779L19.457 1.9834H19.5568Z"
        fill="url(#paint235_linear_253_19555)"
      />
      <path
        d="M19.6544 1.9834L21.8781 12.2366L21.7843 12.2573L19.5576 1.9834H19.6544Z"
        fill="url(#paint236_linear_253_19555)"
      />
      <path
        d="M19.7531 1.9834L21.9738 12.216L21.877 12.2366L19.6533 1.9834H19.7531Z"
        fill="url(#paint237_linear_253_19555)"
      />
      <path
        d="M19.8493 1.9834L22.0671 12.1954L21.9732 12.216L19.7524 1.9834H19.8493Z"
        fill="url(#paint238_linear_253_19555)"
      />
      <path
        d="M19.9498 1.9834L22.1618 12.1748L22.0679 12.1954L19.8501 1.9834H19.9498Z"
        fill="url(#paint239_linear_253_19555)"
      />
      <path
        d="M20.049 1.9834L22.2551 12.1542L22.1612 12.1748L19.9492 1.9834H20.049Z"
        fill="url(#paint240_linear_253_19555)"
      />
      <path
        d="M20.1466 1.9834L22.3498 12.1335L22.2559 12.1542L20.0498 1.9834H20.1466Z"
        fill="url(#paint241_linear_253_19555)"
      />
      <path
        d="M20.2457 1.9834L22.443 12.1129L22.3492 12.1335L20.146 1.9834H20.2457Z"
        fill="url(#paint242_linear_253_19555)"
      />
      <path
        d="M20.3463 1.9834L22.5378 12.0923L22.4439 12.1129L20.2466 1.9834H20.3463Z"
        fill="url(#paint243_linear_253_19555)"
      />
      <path
        d="M20.444 1.9834L22.6325 12.0717L22.5386 12.0923L20.3472 1.9834H20.444Z"
        fill="url(#paint244_linear_253_19555)"
      />
      <path
        d="M20.5411 1.9834L22.7238 12.0511L22.6299 12.0717L20.4414 1.9834H20.5411Z"
        fill="url(#paint245_linear_253_19555)"
      />
      <path
        d="M20.6437 1.9834L22.8234 12.0305L22.7266 12.0511L20.5439 1.9834H20.6437Z"
        fill="url(#paint246_linear_253_19555)"
      />
      <path
        d="M20.7399 1.9834L22.9166 12.0098L22.8228 12.0305L20.6431 1.9834H20.7399Z"
        fill="url(#paint247_linear_253_19555)"
      />
      <path
        d="M20.84 1.9834L22.9434 11.6829V12.004L22.917 12.0098L20.7402 1.9834H20.84Z"
        fill="url(#paint248_linear_253_19555)"
      />
      <path
        d="M20.9362 1.9834L22.9428 11.2293V11.6829L20.8394 1.9834H20.9362Z"
        fill="url(#paint249_linear_253_19555)"
      />
      <path
        d="M21.0368 1.9834L22.9436 10.7757V11.2293L20.937 1.9834H21.0368Z"
        fill="url(#paint250_linear_253_19555)"
      />
      <path
        d="M21.1359 1.9834L22.943 10.3191V10.7757L21.0361 1.9834H21.1359Z"
        fill="url(#paint251_linear_253_19555)"
      />
      <path
        d="M21.2321 1.9834L22.9424 9.86552V10.3191L21.1353 1.9834H21.2321Z"
        fill="url(#paint252_linear_253_19555)"
      />
      <path
        d="M21.3322 1.9834L22.9427 9.40897V9.86552L21.2324 1.9834H21.3322Z"
        fill="url(#paint253_linear_253_19555)"
      />
      <path
        d="M21.4313 1.9834L22.9421 8.95537V9.40897L21.3315 1.9834H21.4313Z"
        fill="url(#paint254_linear_253_19555)"
      />
      <path
        d="M22.9434 8.95537L21.4326 1.9834H22.9434V8.95537Z"
        fill="url(#paint255_linear_253_19555)"
      />
    </g>
    <mask
      height="2"
      id="mask2_253_19555"
      maskUnits="userSpaceOnUse"
      style={{ maskType: 'luminance' }}
      width="3"
      x="18"
      y="6"
    >
      <path
        d="M19.3982 6.09111C19.8443 5.99449 20.285 6.27899 20.3812 6.72452C20.4774 7.17005 20.1942 7.61827 19.7508 7.71489C19.3047 7.81151 18.8639 7.52702 18.7678 7.0788C18.6716 6.63058 18.9548 6.18773 19.3982 6.09111Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask2_253_19555)">
      <path
        d="M18.6704 6.62988L18.9267 7.81081H18.6704V6.62988Z"
        fill="url(#paint256_linear_253_19555)"
      />
      <path
        d="M18.6704 6.52539L18.9507 7.81099H18.9267L18.6704 6.63006V6.52539Z"
        fill="url(#paint257_linear_253_19555)"
      />
      <path
        d="M18.6704 6.41797L18.9721 7.81093H18.9507L18.6704 6.52533V6.41797Z"
        fill="url(#paint258_linear_253_19555)"
      />
      <path
        d="M18.6704 6.31348L18.9961 7.81111H18.9721L18.6704 6.41815V6.31348Z"
        fill="url(#paint259_linear_253_19555)"
      />
      <path
        d="M18.6704 6.20605L19.0201 7.81105H18.9961L18.6704 6.31341V6.20605Z"
        fill="url(#paint260_linear_253_19555)"
      />
      <path
        d="M18.6704 6.09863L19.0415 7.81098H19.0201L18.6704 6.20599V6.09863Z"
        fill="url(#paint261_linear_253_19555)"
      />
      <path
        d="M18.6704 5.99414L19.0655 7.81116H19.0415L18.6704 6.09881V5.99414Z"
        fill="url(#paint262_linear_253_19555)"
      />
      <path
        d="M18.6944 5.99414L19.0895 7.81116H19.0655L18.6704 5.99414H18.6944Z"
        fill="url(#paint263_linear_253_19555)"
      />
      <path
        d="M18.7184 5.99414L19.1108 7.81116H19.0894L18.6943 5.99414H18.7184Z"
        fill="url(#paint264_linear_253_19555)"
      />
      <path
        d="M18.7396 5.99414L19.1347 7.81116H19.1107L18.7183 5.99414H18.7396Z"
        fill="url(#paint265_linear_253_19555)"
      />
      <path
        d="M18.7643 5.99414L19.1567 7.81116H19.1353L18.7402 5.99414H18.7643Z"
        fill="url(#paint266_linear_253_19555)"
      />
      <path
        d="M18.7841 5.99414L19.1791 7.81116H19.1551L18.7627 5.99414H18.7841Z"
        fill="url(#paint267_linear_253_19555)"
      />
      <path
        d="M18.8087 5.99414L19.2038 7.81116H19.1797L18.7847 5.99414H18.8087Z"
        fill="url(#paint268_linear_253_19555)"
      />
      <path
        d="M18.8326 5.99414L19.225 7.81116H19.2037L18.8086 5.99414H18.8326Z"
        fill="url(#paint269_linear_253_19555)"
      />
      <path
        d="M18.8539 5.99414L19.2489 7.81116H19.2249L18.8325 5.99414H18.8539Z"
        fill="url(#paint270_linear_253_19555)"
      />
      <path
        d="M18.879 5.99414L19.2741 7.81116H19.25L18.855 5.99414H18.879Z"
        fill="url(#paint271_linear_253_19555)"
      />
      <path
        d="M18.9029 5.99414L19.2953 7.81116H19.274L18.8789 5.99414H18.9029Z"
        fill="url(#paint272_linear_253_19555)"
      />
      <path
        d="M18.9222 5.99414L19.3173 7.81116H19.2933L18.9009 5.99414H18.9222Z"
        fill="url(#paint273_linear_253_19555)"
      />
      <path
        d="M18.9488 5.99414L19.3412 7.81116H19.3199L18.9248 5.99414H18.9488Z"
        fill="url(#paint274_linear_253_19555)"
      />
      <path
        d="M18.9686 5.99414L19.3637 7.81116H19.3397L18.9473 5.99414H18.9686Z"
        fill="url(#paint275_linear_253_19555)"
      />
      <path
        d="M18.9933 5.99414L19.3883 7.81116H19.3643L18.9692 5.99414H18.9933Z"
        fill="url(#paint276_linear_253_19555)"
      />
      <path
        d="M19.0172 5.99414L19.4096 7.81116H19.3882L18.9932 5.99414H19.0172Z"
        fill="url(#paint277_linear_253_19555)"
      />
      <path
        d="M19.0384 5.99414L19.4335 7.81116H19.4095L19.0171 5.99414H19.0384Z"
        fill="url(#paint278_linear_253_19555)"
      />
      <path
        d="M19.0616 5.99414L19.4567 7.81116H19.4327L19.0376 5.99414H19.0616Z"
        fill="url(#paint279_linear_253_19555)"
      />
      <path
        d="M19.0848 5.99414L19.4799 7.81116H19.4585L19.0635 5.99414H19.0848Z"
        fill="url(#paint280_linear_253_19555)"
      />
      <path
        d="M19.108 5.99414L19.5031 7.81116H19.4791L19.084 5.99414H19.108Z"
        fill="url(#paint281_linear_253_19555)"
      />
      <path
        d="M19.1293 5.99414L19.5243 7.81116H19.503L19.1079 5.99414H19.1293Z"
        fill="url(#paint282_linear_253_19555)"
      />
      <path
        d="M19.1539 5.99414L19.549 7.81116H19.525L19.1299 5.99414H19.1539Z"
        fill="url(#paint283_linear_253_19555)"
      />
      <path
        d="M19.1752 5.99414L19.5702 7.81116H19.5489L19.1538 5.99414H19.1752Z"
        fill="url(#paint284_linear_253_19555)"
      />
      <path
        d="M19.1983 5.99414L19.5934 7.81116H19.5694L19.1743 5.99414H19.1983Z"
        fill="url(#paint285_linear_253_19555)"
      />
      <path
        d="M19.2242 5.99414L19.6166 7.81116H19.5953L19.2002 5.99414H19.2242Z"
        fill="url(#paint286_linear_253_19555)"
      />
      <path
        d="M19.2435 5.99414L19.6386 7.81116H19.6146L19.2222 5.99414H19.2435Z"
        fill="url(#paint287_linear_253_19555)"
      />
      <path
        d="M19.2667 5.99414L19.6591 7.81116H19.6377L19.2427 5.99414H19.2667Z"
        fill="url(#paint288_linear_253_19555)"
      />
      <path
        d="M19.2899 5.99414L19.685 7.81116H19.661L19.2686 5.99414H19.2899Z"
        fill="url(#paint289_linear_253_19555)"
      />
      <path
        d="M19.3146 5.99414L19.707 7.81116H19.6856L19.2905 5.99414H19.3146Z"
        fill="url(#paint290_linear_253_19555)"
      />
      <path
        d="M19.3343 5.99414L19.7294 7.81116H19.7054L19.313 5.99414H19.3343Z"
        fill="url(#paint291_linear_253_19555)"
      />
      <path
        d="M19.359 5.99414L19.7514 7.81116H19.73L19.335 5.99414H19.359Z"
        fill="url(#paint292_linear_253_19555)"
      />
      <path
        d="M19.3802 5.99414L19.7753 7.81116H19.7513L19.3589 5.99414H19.3802Z"
        fill="url(#paint293_linear_253_19555)"
      />
      <path
        d="M19.4034 5.99414L19.7958 7.81116H19.7745L19.3794 5.99414H19.4034Z"
        fill="url(#paint294_linear_253_19555)"
      />
      <path
        d="M19.4266 5.99414L19.8217 7.81116H19.7977L19.4053 5.99414H19.4266Z"
        fill="url(#paint295_linear_253_19555)"
      />
      <path
        d="M19.4498 5.99414L19.8422 7.81116H19.8208L19.4258 5.99414H19.4498Z"
        fill="url(#paint296_linear_253_19555)"
      />
      <path
        d="M19.4711 5.99414L19.8661 7.81116H19.8421L19.4497 5.99414H19.4711Z"
        fill="url(#paint297_linear_253_19555)"
      />
      <path
        d="M19.4957 5.99414L19.8908 7.81116H19.8667L19.4717 5.99414H19.4957Z"
        fill="url(#paint298_linear_253_19555)"
      />
      <path
        d="M19.517 5.99414L19.912 7.81116H19.8907L19.4956 5.99414H19.517Z"
        fill="url(#paint299_linear_253_19555)"
      />
      <path
        d="M19.5401 5.99414L19.9352 7.81116H19.9112L19.5161 5.99414H19.5401Z"
        fill="url(#paint300_linear_253_19555)"
      />
      <path
        d="M19.5633 5.99414L19.9584 7.81116H19.9371L19.542 5.99414H19.5633Z"
        fill="url(#paint301_linear_253_19555)"
      />
      <path
        d="M19.5865 5.99414L19.9816 7.81116H19.9576L19.5625 5.99414H19.5865Z"
        fill="url(#paint302_linear_253_19555)"
      />
      <path
        d="M19.6104 5.99414L20.0028 7.81116H19.9815L19.5864 5.99414H19.6104Z"
        fill="url(#paint303_linear_253_19555)"
      />
      <path
        d="M19.6317 5.99414L20.0268 7.81116H20.0028L19.6104 5.99414H19.6317Z"
        fill="url(#paint304_linear_253_19555)"
      />
      <path
        d="M19.6563 5.99414L20.0487 7.81116H20.0274L19.6323 5.99414H19.6563Z"
        fill="url(#paint305_linear_253_19555)"
      />
      <path
        d="M19.6761 5.99414L20.0712 7.81116H20.0472L19.6548 5.99414H19.6761Z"
        fill="url(#paint306_linear_253_19555)"
      />
      <path
        d="M19.7008 5.99414L20.0932 7.81116H20.0718L19.6768 5.99414H19.7008Z"
        fill="url(#paint307_linear_253_19555)"
      />
      <path
        d="M19.722 5.99414L20.1171 7.81116H20.0931L19.7007 5.99414H19.722Z"
        fill="url(#paint308_linear_253_19555)"
      />
      <path
        d="M19.7452 5.99414L20.1376 7.81116H20.1163L19.7212 5.99414H19.7452Z"
        fill="url(#paint309_linear_253_19555)"
      />
      <path
        d="M19.7684 5.99414L20.1635 7.81116H20.1395L19.7471 5.99414H19.7684Z"
        fill="url(#paint310_linear_253_19555)"
      />
      <path
        d="M19.7911 5.99414L20.1835 7.81116H20.1622L19.7671 5.99414H19.7911Z"
        fill="url(#paint311_linear_253_19555)"
      />
      <path
        d="M19.8129 5.99414L20.2079 7.81116H20.1839L19.7915 5.99414H19.8129Z"
        fill="url(#paint312_linear_253_19555)"
      />
      <path
        d="M19.8375 5.99414L20.2299 7.81116H20.2085L19.8135 5.99414H19.8375Z"
        fill="url(#paint313_linear_253_19555)"
      />
      <path
        d="M19.8588 5.99414L20.2538 7.81116H20.2298L19.8374 5.99414H19.8588Z"
        fill="url(#paint314_linear_253_19555)"
      />
      <path
        d="M19.8819 5.99414L20.2743 7.81116H20.253L19.8579 5.99414H19.8819Z"
        fill="url(#paint315_linear_253_19555)"
      />
      <path
        d="M19.9051 5.99414L20.3002 7.81116H20.2762L19.8838 5.99414H19.9051Z"
        fill="url(#paint316_linear_253_19555)"
      />
      <path
        d="M19.9278 5.99414L20.3229 7.81116H20.2989L19.9038 5.99414H19.9278Z"
        fill="url(#paint317_linear_253_19555)"
      />
      <path
        d="M19.9496 5.99414L20.3446 7.81116H20.3233L19.9282 5.99414H19.9496Z"
        fill="url(#paint318_linear_253_19555)"
      />
      <path
        d="M19.9742 5.99414L20.3693 7.81116H20.3453L19.9502 5.99414H19.9742Z"
        fill="url(#paint319_linear_253_19555)"
      />
      <path
        d="M19.9955 5.99414L20.3905 7.81116H20.3692L19.9741 5.99414H19.9955Z"
        fill="url(#paint320_linear_253_19555)"
      />
      <path
        d="M20.0187 5.99414L20.4137 7.81116H20.3897L19.9946 5.99414H20.0187Z"
        fill="url(#paint321_linear_253_19555)"
      />
      <path
        d="M20.0445 5.99414L20.4369 7.81116H20.4156L20.0205 5.99414H20.0445Z"
        fill="url(#paint322_linear_253_19555)"
      />
      <path
        d="M20.0638 5.99414L20.4589 7.81116H20.4349L20.0425 5.99414H20.0638Z"
        fill="url(#paint323_linear_253_19555)"
      />
      <path
        d="M20.089 5.99414L20.4814 7.8058V7.81116H20.46L20.0649 5.99414H20.089Z"
        fill="url(#paint324_linear_253_19555)"
      />
      <path
        d="M20.1102 5.99414L20.4813 7.69844V7.8058L20.0889 5.99414H20.1102Z"
        fill="url(#paint325_linear_253_19555)"
      />
      <path
        d="M20.1329 5.99414L20.4799 7.59377V7.69844L20.1089 5.99414H20.1329Z"
        fill="url(#paint326_linear_253_19555)"
      />
      <path
        d="M20.1547 5.99414L20.4803 7.48909V7.59377L20.1333 5.99414H20.1547Z"
        fill="url(#paint327_linear_253_19555)"
      />
      <path
        d="M20.1793 5.99414L20.4809 7.38442V7.48909L20.1553 5.99414H20.1793Z"
        fill="url(#paint328_linear_253_19555)"
      />
      <path
        d="M20.2006 5.99414L20.4808 7.27974V7.38442L20.1792 5.99414H20.2006Z"
        fill="url(#paint329_linear_253_19555)"
      />
      <path
        d="M20.2237 5.99414L20.48 7.17507V7.27974L20.1997 5.99414H20.2237Z"
        fill="url(#paint330_linear_253_19555)"
      />
      <path
        d="M20.4818 7.17507L20.2256 5.99414H20.4818V7.17507Z"
        fill="url(#paint331_linear_253_19555)"
      />
    </g>
    <mask
      height="3"
      id="mask3_253_19555"
      maskUnits="userSpaceOnUse"
      style={{ maskType: 'luminance' }}
      width="2"
      x="16"
      y="4"
    >
      <path
        d="M16.7636 4.26295C17.2483 4.1565 17.7273 4.46994 17.8317 4.9608C17.9362 5.45461 17.6286 5.94547 17.1468 6.05192C16.662 6.15838 16.1831 5.84494 16.0786 5.35112C16.038 5.16483 16.0583 4.97854 16.1222 4.81591C16.2296 4.54386 16.4618 4.33096 16.7607 4.26295H16.7636Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask3_253_19555)">
      <path
        d="M16.0386 5.16406L16.2503 6.16056H16.0386V5.16406Z"
        fill="url(#paint332_linear_253_19555)"
      />
      <path
        d="M16.0386 5.05176L16.2735 6.16063H16.2503L16.0386 5.16412V5.05176Z"
        fill="url(#paint333_linear_253_19555)"
      />
      <path
        d="M16.0386 4.94238L16.2967 6.16066H16.2735L16.0386 5.05179V4.94238Z"
        fill="url(#paint334_linear_253_19555)"
      />
      <path
        d="M16.0386 4.83008L16.3228 6.16072H16.2967L16.0386 4.94244V4.83008Z"
        fill="url(#paint335_linear_253_19555)"
      />
      <path
        d="M16.0386 4.71777L16.346 6.16078H16.3228L16.0386 4.83014V4.71777Z"
        fill="url(#paint336_linear_253_19555)"
      />
      <path
        d="M16.0386 4.60547L16.3692 6.16084H16.346L16.0386 4.71783V4.60547Z"
        fill="url(#paint337_linear_253_19555)"
      />
      <path
        d="M16.0386 4.49609L16.3924 6.16087H16.3692L16.0386 4.6055V4.49609Z"
        fill="url(#paint338_linear_253_19555)"
      />
      <path
        d="M16.0386 4.38379L16.4156 6.16093H16.3924L16.0386 4.49615V4.38379Z"
        fill="url(#paint339_linear_253_19555)"
      />
      <path
        d="M16.0386 4.27148L16.4417 6.161H16.4156L16.0386 4.38385V4.27148Z"
        fill="url(#paint340_linear_253_19555)"
      />
      <path
        d="M16.0386 4.15918L16.4649 6.16106H16.4417L16.0386 4.27155V4.15918Z"
        fill="url(#paint341_linear_253_19555)"
      />
      <path
        d="M16.0589 4.15625L16.4882 6.16108H16.4649L16.0386 4.15921V4.15625H16.0589Z"
        fill="url(#paint342_linear_253_19555)"
      />
      <path
        d="M16.0852 4.15625L16.5116 6.16108H16.4884L16.0591 4.15625H16.0852Z"
        fill="url(#paint343_linear_253_19555)"
      />
      <path
        d="M16.1077 4.15625L16.537 6.16108H16.5108L16.0845 4.15625H16.1077Z"
        fill="url(#paint344_linear_253_19555)"
      />
      <path
        d="M16.1316 4.15625L16.5609 6.16108H16.5377L16.1084 4.15625H16.1316Z"
        fill="url(#paint345_linear_253_19555)"
      />
      <path
        d="M16.1541 4.15625L16.5833 6.16108H16.5601L16.1309 4.15625H16.1541Z"
        fill="url(#paint346_linear_253_19555)"
      />
      <path
        d="M16.1809 4.15625L16.6073 6.16108H16.5841L16.1548 4.15625H16.1809Z"
        fill="url(#paint347_linear_253_19555)"
      />
      <path
        d="M16.2034 4.15625L16.6298 6.16108H16.6066L16.1802 4.15625H16.2034Z"
        fill="url(#paint348_linear_253_19555)"
      />
      <path
        d="M16.2273 4.15625L16.6566 6.16108H16.6305L16.2041 4.15625H16.2273Z"
        fill="url(#paint349_linear_253_19555)"
      />
      <path
        d="M16.2512 4.15625L16.6805 6.16108H16.6573L16.228 4.15625H16.2512Z"
        fill="url(#paint350_linear_253_19555)"
      />
      <path
        d="M16.2737 4.15625L16.703 6.16108H16.6798L16.2505 4.15625H16.2737Z"
        fill="url(#paint351_linear_253_19555)"
      />
      <path
        d="M16.2986 4.15625L16.7249 6.16108H16.7017L16.2725 4.15625H16.2986Z"
        fill="url(#paint352_linear_253_19555)"
      />
      <path
        d="M16.323 4.15625L16.7523 6.16108H16.7262L16.2998 4.15625H16.323Z"
        fill="url(#paint353_linear_253_19555)"
      />
      <path
        d="M16.3455 4.15625L16.7747 6.16108H16.7515L16.3223 4.15625H16.3455Z"
        fill="url(#paint354_linear_253_19555)"
      />
      <path
        d="M16.3674 4.15625L16.7967 6.16108H16.7735L16.3442 4.15625H16.3674Z"
        fill="url(#paint355_linear_253_19555)"
      />
      <path
        d="M16.3962 4.15625L16.8226 6.16108H16.7994L16.3701 4.15625H16.3962Z"
        fill="url(#paint356_linear_253_19555)"
      />
      <path
        d="M16.4172 4.15625L16.8436 6.16108H16.8204L16.394 4.15625H16.4172Z"
        fill="url(#paint357_linear_253_19555)"
      />
      <path
        d="M16.4426 4.15625L16.8719 6.16108H16.8458L16.4194 4.15625H16.4426Z"
        fill="url(#paint358_linear_253_19555)"
      />
      <path
        d="M16.4651 4.15625L16.8944 6.16108H16.8712L16.4419 4.15625H16.4651Z"
        fill="url(#paint359_linear_253_19555)"
      />
      <path
        d="M16.49 4.15625L16.9163 6.16108H16.8931L16.4639 4.15625H16.49Z"
        fill="url(#paint360_linear_253_19555)"
      />
      <path
        d="M16.5164 4.15625L16.9427 6.16108H16.9195L16.4932 4.15625H16.5164Z"
        fill="url(#paint361_linear_253_19555)"
      />
      <path
        d="M16.5383 4.15625L16.9676 6.16108H16.9415L16.5151 4.15625H16.5383Z"
        fill="url(#paint362_linear_253_19555)"
      />
      <path
        d="M16.5608 4.15625L16.9901 6.16108H16.9669L16.5376 4.15625H16.5608Z"
        fill="url(#paint363_linear_253_19555)"
      />
      <path
        d="M16.5847 4.15625L17.014 6.16108H16.9908L16.5615 4.15625H16.5847Z"
        fill="url(#paint364_linear_253_19555)"
      />
      <path
        d="M16.6111 4.15625L17.0374 6.16108H17.0142L16.585 4.15625H16.6111Z"
        fill="url(#paint365_linear_253_19555)"
      />
      <path
        d="M16.6326 4.15625L17.059 6.16108H17.0358L16.6094 4.15625H16.6326Z"
        fill="url(#paint366_linear_253_19555)"
      />
      <path
        d="M16.6565 4.15625L17.0858 6.16108H17.0597L16.6333 4.15625H16.6565Z"
        fill="url(#paint367_linear_253_19555)"
      />
      <path
        d="M16.6804 4.15625L17.1097 6.16108H17.0865L16.6572 4.15625H16.6804Z"
        fill="url(#paint368_linear_253_19555)"
      />
      <path
        d="M16.7053 4.15625L17.1317 6.16108H17.1085L16.6792 4.15625H16.7053Z"
        fill="url(#paint369_linear_253_19555)"
      />
      <path
        d="M16.7297 4.15625L17.1561 6.16108H17.1329L16.7065 4.15625H16.7297Z"
        fill="url(#paint370_linear_253_19555)"
      />
      <path
        d="M16.7522 4.15625L17.1815 6.16108H17.1554L16.729 4.15625H16.7522Z"
        fill="url(#paint371_linear_253_19555)"
      />
      <path
        d="M16.7742 4.15625L17.2035 6.16108H17.1803L16.751 4.15625H16.7742Z"
        fill="url(#paint372_linear_253_19555)"
      />
      <path
        d="M16.8001 4.15625L17.2293 6.16108H17.2061L16.7769 4.15625H16.8001Z"
        fill="url(#paint373_linear_253_19555)"
      />
      <path
        d="M16.8249 4.15625L17.2513 6.16108H17.2281L16.7988 4.15625H16.8249Z"
        fill="url(#paint374_linear_253_19555)"
      />
      <path
        d="M16.8479 4.15625L17.2772 6.16108H17.2511L16.8247 4.15625H16.8479Z"
        fill="url(#paint375_linear_253_19555)"
      />
      <path
        d="M16.8718 4.15625L17.3011 6.16108H17.2779L16.8486 4.15625H16.8718Z"
        fill="url(#paint376_linear_253_19555)"
      />
      <path
        d="M16.8943 4.15625L17.3236 6.16108H17.3004L16.8711 4.15625H16.8943Z"
        fill="url(#paint377_linear_253_19555)"
      />
      <path
        d="M16.9206 4.15625L17.347 6.16108H17.3238L16.8945 4.15625H16.9206Z"
        fill="url(#paint378_linear_253_19555)"
      />
      <path
        d="M16.9436 4.15625L17.37 6.16108H17.3468L16.9204 4.15625H16.9436Z"
        fill="url(#paint379_linear_253_19555)"
      />
      <path
        d="M16.9675 4.15625L17.3968 6.16108H17.3707L16.9443 4.15625H16.9675Z"
        fill="url(#paint380_linear_253_19555)"
      />
      <path
        d="M16.9895 4.15625L17.4188 6.16108H17.3956L16.9663 4.15625H16.9895Z"
        fill="url(#paint381_linear_253_19555)"
      />
      <path
        d="M17.0134 4.15625L17.4427 6.16108H17.4195L16.9902 4.15625H17.0134Z"
        fill="url(#paint382_linear_253_19555)"
      />
      <path
        d="M17.0388 4.15625L17.4652 6.16108H17.442L17.0127 4.15625H17.0388Z"
        fill="url(#paint383_linear_253_19555)"
      />
      <path
        d="M17.0647 4.15625L17.494 6.16108H17.4679L17.0415 4.15625H17.0647Z"
        fill="url(#paint384_linear_253_19555)"
      />
      <path
        d="M17.0867 4.15625L17.516 6.16108H17.4928L17.0635 4.15625H17.0867Z"
        fill="url(#paint385_linear_253_19555)"
      />
      <path
        d="M17.1091 4.15625L17.5384 6.16108H17.5152L17.0859 4.15625H17.1091Z"
        fill="url(#paint386_linear_253_19555)"
      />
      <path
        d="M17.136 4.15625L17.5623 6.16108H17.5391L17.1099 4.15625H17.136Z"
        fill="url(#paint387_linear_253_19555)"
      />
      <path
        d="M17.1585 4.15625L17.5848 6.16108H17.5616L17.1353 4.15625H17.1585Z"
        fill="url(#paint388_linear_253_19555)"
      />
      <path
        d="M17.1809 4.15625L17.6102 6.16108H17.5841L17.1577 4.15625H17.1809Z"
        fill="url(#paint389_linear_253_19555)"
      />
      <path
        d="M17.2068 4.15625L17.6361 6.16108H17.6129L17.1836 4.15625H17.2068Z"
        fill="url(#paint390_linear_253_19555)"
      />
      <path
        d="M17.2288 4.15625L17.658 6.16108H17.6348L17.2056 4.15625H17.2288Z"
        fill="url(#paint391_linear_253_19555)"
      />
      <path
        d="M17.2541 4.15625L17.6805 6.16108H17.6573L17.228 4.15625H17.2541Z"
        fill="url(#paint392_linear_253_19555)"
      />
      <path
        d="M17.2786 4.15625L17.7078 6.16108H17.6817L17.2554 4.15625H17.2786Z"
        fill="url(#paint393_linear_253_19555)"
      />
      <path
        d="M17.3005 4.15625L17.7298 6.16108H17.7066L17.2773 4.15625H17.3005Z"
        fill="url(#paint394_linear_253_19555)"
      />
      <path
        d="M17.323 4.15625L17.7523 6.16108H17.7291L17.2998 4.15625H17.323Z"
        fill="url(#paint395_linear_253_19555)"
      />
      <path
        d="M17.3498 4.15625L17.7762 6.16108H17.753L17.3237 4.15625H17.3498Z"
        fill="url(#paint396_linear_253_19555)"
      />
      <path
        d="M17.3743 4.15625L17.8007 6.16108H17.7774L17.3511 4.15625H17.3743Z"
        fill="url(#paint397_linear_253_19555)"
      />
      <path
        d="M17.3963 4.15625L17.8255 6.16108H17.7994L17.373 4.15625H17.3963Z"
        fill="url(#paint398_linear_253_19555)"
      />
      <path
        d="M17.4202 4.15625L17.8495 6.16108H17.8262L17.397 4.15625H17.4202Z"
        fill="url(#paint399_linear_253_19555)"
      />
      <path
        d="M17.4446 4.15625L17.8739 6.16108H17.8507L17.4214 4.15625H17.4446Z"
        fill="url(#paint400_linear_253_19555)"
      />
      <path
        d="M17.4695 4.15625L17.8958 6.16108H17.8726L17.4434 4.15625H17.4695Z"
        fill="url(#paint401_linear_253_19555)"
      />
      <path
        d="M17.492 4.15625L17.9212 6.16108H17.8951L17.4688 4.15625H17.492Z"
        fill="url(#paint402_linear_253_19555)"
      />
      <path
        d="M17.5164 4.15625L17.9369 6.1256V6.16108H17.9224L17.4932 4.15625H17.5164Z"
        fill="url(#paint403_linear_253_19555)"
      />
      <path
        d="M17.5383 4.15625L17.9357 6.01619V6.1256L17.5151 4.15625H17.5383Z"
        fill="url(#paint404_linear_253_19555)"
      />
      <path
        d="M17.5652 4.15625L17.9364 5.90383V6.01619L17.5391 4.15625H17.5652Z"
        fill="url(#paint405_linear_253_19555)"
      />
      <path
        d="M17.5877 4.15625L17.9357 5.79146V5.90383L17.5645 4.15625H17.5877Z"
        fill="url(#paint406_linear_253_19555)"
      />
      <path
        d="M17.6101 4.15625L17.935 5.6791V5.79146L17.5869 4.15625H17.6101Z"
        fill="url(#paint407_linear_253_19555)"
      />
      <path
        d="M17.6355 4.15625L17.9372 5.56969V5.6791L17.6123 4.15625H17.6355Z"
        fill="url(#paint408_linear_253_19555)"
      />
      <path
        d="M17.658 4.15625L17.9364 5.45732V5.56969L17.6348 4.15625H17.658Z"
        fill="url(#paint409_linear_253_19555)"
      />
      <path
        d="M17.9386 5.45732L17.6602 4.15625H17.9386V5.45732Z"
        fill="url(#paint410_linear_253_19555)"
      />
    </g>
    <mask
      height="3"
      id="mask4_253_19555"
      maskUnits="userSpaceOnUse"
      style={{ maskType: 'luminance' }}
      width="2"
      x="17"
      y="8"
    >
      <path
        d="M17.9475 8.63408C18.3936 8.53746 18.8344 8.82196 18.9305 9.26749C19.0267 9.71571 18.7435 10.1612 18.3001 10.2579C17.854 10.3545 17.4133 10.07 17.3171 9.62177C17.2209 9.17355 17.5041 8.7307 17.9475 8.63408Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask4_253_19555)">
      <path
        d="M17.2178 9.17578L17.474 10.3567H17.2178V9.17578Z"
        fill="url(#paint411_linear_253_19555)"
      />
      <path
        d="M17.2178 9.08203L17.4954 10.3569H17.474L17.2178 9.17597V9.08203Z"
        fill="url(#paint412_linear_253_19555)"
      />
      <path
        d="M17.2178 8.98828L17.5141 10.3571H17.4954L17.2178 9.08222V8.98828Z"
        fill="url(#paint413_linear_253_19555)"
      />
      <path
        d="M17.2178 8.89648L17.5354 10.3565H17.5141L17.2178 8.98774V8.89648Z"
        fill="url(#paint414_linear_253_19555)"
      />
      <path
        d="M17.2178 8.80273L17.5541 10.3567H17.5354L17.2178 8.89667V8.80273Z"
        fill="url(#paint415_linear_253_19555)"
      />
      <path
        d="M17.2178 8.71191L17.5755 10.3572H17.5541L17.2178 8.80317V8.71191Z"
        fill="url(#paint416_linear_253_19555)"
      />
      <path
        d="M17.2178 8.61719L17.5968 10.3564H17.5755L17.2178 8.71113V8.61719Z"
        fill="url(#paint417_linear_253_19555)"
      />
      <path
        d="M17.2204 8.53711L17.6155 10.3568H17.5968L17.2178 8.61763V8.53711H17.2204Z"
        fill="url(#paint418_linear_253_19555)"
      />
      <path
        d="M17.2406 8.53711L17.6357 10.3568H17.6143L17.2192 8.53711H17.2406Z"
        fill="url(#paint419_linear_253_19555)"
      />
      <path
        d="M17.2604 8.53711L17.6555 10.3568H17.6368L17.2417 8.53711H17.2604Z"
        fill="url(#paint420_linear_253_19555)"
      />
      <path
        d="M17.2816 8.53711L17.6767 10.3568H17.6553L17.2603 8.53711H17.2816Z"
        fill="url(#paint421_linear_253_19555)"
      />
      <path
        d="M17.3041 8.53711L17.6965 10.3568H17.6778L17.2827 8.53711H17.3041Z"
        fill="url(#paint422_linear_253_19555)"
      />
      <path
        d="M17.3219 8.53711L17.717 10.3568H17.6956L17.3032 8.53711H17.3219Z"
        fill="url(#paint423_linear_253_19555)"
      />
      <path
        d="M17.3431 8.53711L17.7355 10.3568H17.7168L17.3218 8.53711H17.3431Z"
        fill="url(#paint424_linear_253_19555)"
      />
      <path
        d="M17.3549 8.53711L17.7473 10.3568H17.7366L17.3442 8.53711H17.3549Z"
        fill="url(#paint425_linear_253_19555)"
      />
      <path
        d="M17.3652 8.53711L17.7576 10.3568H17.7469L17.3545 8.53711H17.3652Z"
        fill="url(#paint426_linear_253_19555)"
      />
      <path
        d="M17.3754 8.53711L17.7678 10.3568H17.7571L17.3647 8.53711H17.3754Z"
        fill="url(#paint427_linear_253_19555)"
      />
      <path
        d="M17.3857 8.53711L17.7781 10.3568H17.7674L17.375 8.53711H17.3857Z"
        fill="url(#paint428_linear_253_19555)"
      />
      <path
        d="M17.3959 8.53711L17.7883 10.3568H17.7777L17.3853 8.53711H17.3959Z"
        fill="url(#paint429_linear_253_19555)"
      />
      <path
        d="M17.4077 8.53711L17.8001 10.3568H17.7894L17.397 8.53711H17.4077Z"
        fill="url(#paint430_linear_253_19555)"
      />
      <path
        d="M17.4179 8.53711L17.8103 10.3568H17.7996L17.4072 8.53711H17.4179Z"
        fill="url(#paint431_linear_253_19555)"
      />
      <path
        d="M17.4282 8.53711L17.8206 10.3568H17.8099L17.4175 8.53711H17.4282Z"
        fill="url(#paint432_linear_253_19555)"
      />
      <path
        d="M17.4384 8.53711L17.8308 10.3568H17.8201L17.4277 8.53711H17.4384Z"
        fill="url(#paint433_linear_253_19555)"
      />
      <path
        d="M17.4487 8.53711L17.8411 10.3568H17.8304L17.438 8.53711H17.4487Z"
        fill="url(#paint434_linear_253_19555)"
      />
      <path
        d="M17.4609 8.53711L17.8533 10.3568H17.8426L17.4502 8.53711H17.4609Z"
        fill="url(#paint435_linear_253_19555)"
      />
      <path
        d="M17.4726 8.53711L17.865 10.3568H17.8543L17.4619 8.53711H17.4726Z"
        fill="url(#paint436_linear_253_19555)"
      />
      <path
        d="M17.4828 8.53711L17.8752 10.3568H17.8646L17.4722 8.53711H17.4828Z"
        fill="url(#paint437_linear_253_19555)"
      />
      <path
        d="M17.4931 8.53711L17.8855 10.3568H17.8748L17.4824 8.53711H17.4931Z"
        fill="url(#paint438_linear_253_19555)"
      />
      <path
        d="M17.5034 8.53711L17.8958 10.3568H17.8851L17.4927 8.53711H17.5034Z"
        fill="url(#paint439_linear_253_19555)"
      />
      <path
        d="M17.5136 8.53711L17.906 10.3568H17.8953L17.5029 8.53711H17.5136Z"
        fill="url(#paint440_linear_253_19555)"
      />
      <path
        d="M17.5239 8.53711L17.9163 10.3568H17.9056L17.5132 8.53711H17.5239Z"
        fill="url(#paint441_linear_253_19555)"
      />
      <path
        d="M17.5341 8.53711L17.9265 10.3568H17.9158L17.5234 8.53711H17.5341Z"
        fill="url(#paint442_linear_253_19555)"
      />
      <path
        d="M17.5463 8.53711L17.9387 10.3568H17.928L17.5356 8.53711H17.5463Z"
        fill="url(#paint443_linear_253_19555)"
      />
      <path
        d="M17.558 8.53711L17.9504 10.3568H17.9398L17.5474 8.53711H17.558Z"
        fill="url(#paint444_linear_253_19555)"
      />
      <path
        d="M17.5683 8.53711L17.9607 10.3568H17.95L17.5576 8.53711H17.5683Z"
        fill="url(#paint445_linear_253_19555)"
      />
      <path
        d="M17.5764 8.53711L17.9714 10.3568H17.9608L17.5684 8.53711H17.5764Z"
        fill="url(#paint446_linear_253_19555)"
      />
      <path
        d="M17.5854 8.53711L17.9805 10.3568H17.9698L17.5747 8.53711H17.5854Z"
        fill="url(#paint447_linear_253_19555)"
      />
      <path
        d="M17.5956 8.53711L17.9907 10.3568H17.98L17.585 8.53711H17.5956Z"
        fill="url(#paint448_linear_253_19555)"
      />
      <path
        d="M17.6093 8.53711L18.0044 10.3568H17.9937L17.5986 8.53711H17.6093Z"
        fill="url(#paint449_linear_253_19555)"
      />
      <path
        d="M17.6196 8.53711L18.0146 10.3568H18.004L17.6089 8.53711H17.6196Z"
        fill="url(#paint450_linear_253_19555)"
      />
      <path
        d="M17.6298 8.53711L18.0249 10.3568H18.0142L17.6191 8.53711H17.6298Z"
        fill="url(#paint451_linear_253_19555)"
      />
      <path
        d="M17.6401 8.53711L18.0351 10.3568H18.0245L17.6294 8.53711H17.6401Z"
        fill="url(#paint452_linear_253_19555)"
      />
      <path
        d="M17.6503 8.53711L18.0454 10.3568H18.0347L17.6396 8.53711H17.6503Z"
        fill="url(#paint453_linear_253_19555)"
      />
      <path
        d="M17.6606 8.53711L18.0556 10.3568H18.045L17.6499 8.53711H17.6606Z"
        fill="url(#paint454_linear_253_19555)"
      />
      <path
        d="M17.6708 8.53711L18.0659 10.3568H18.0552L17.6602 8.53711H17.6708Z"
        fill="url(#paint455_linear_253_19555)"
      />
      <path
        d="M17.683 8.53711L18.0781 10.3568H18.0674L17.6724 8.53711H17.683Z"
        fill="url(#paint456_linear_253_19555)"
      />
      <path
        d="M17.6933 8.53711L18.0884 10.3568H18.0777L17.6826 8.53711H17.6933Z"
        fill="url(#paint457_linear_253_19555)"
      />
      <path
        d="M17.7031 8.53711L18.0981 10.3568H18.0875L17.6924 8.53711H17.7031Z"
        fill="url(#paint458_linear_253_19555)"
      />
      <path
        d="M17.7138 8.53711L18.1089 10.3568H18.0982L17.7031 8.53711H17.7138Z"
        fill="url(#paint459_linear_253_19555)"
      />
      <path
        d="M17.7255 8.53711L18.1206 10.3568H18.1099L17.7148 8.53711H17.7255Z"
        fill="url(#paint460_linear_253_19555)"
      />
      <path
        d="M17.7358 8.53711L18.1308 10.3568H18.1202L17.7251 8.53711H17.7358Z"
        fill="url(#paint461_linear_253_19555)"
      />
      <path
        d="M17.748 8.53711L18.1431 10.3568H18.1324L17.7373 8.53711H17.748Z"
        fill="url(#paint462_linear_253_19555)"
      />
      <path
        d="M17.7582 8.53711L18.1533 10.3568H18.1426L17.7476 8.53711H17.7582Z"
        fill="url(#paint463_linear_253_19555)"
      />
      <path
        d="M17.7685 8.53711L18.1636 10.3568H18.1529L17.7578 8.53711H17.7685Z"
        fill="url(#paint464_linear_253_19555)"
      />
      <path
        d="M17.7787 8.53711L18.1738 10.3568H18.1631L17.7681 8.53711H17.7787Z"
        fill="url(#paint465_linear_253_19555)"
      />
      <path
        d="M17.789 8.53711L18.1841 10.3568H18.1734L17.7783 8.53711H17.789Z"
        fill="url(#paint466_linear_253_19555)"
      />
      <path
        d="M17.7993 8.53711L18.1943 10.3568H18.1836L17.7886 8.53711H17.7993Z"
        fill="url(#paint467_linear_253_19555)"
      />
      <path
        d="M17.8095 8.53711L18.2046 10.3568H18.1939L17.7988 8.53711H17.8095Z"
        fill="url(#paint468_linear_253_19555)"
      />
      <path
        d="M17.8212 8.53711L18.2163 10.3568H18.2056L17.8105 8.53711H17.8212Z"
        fill="url(#paint469_linear_253_19555)"
      />
      <path
        d="M17.8315 8.53711L18.2265 10.3568H18.2159L17.8208 8.53711H17.8315Z"
        fill="url(#paint470_linear_253_19555)"
      />
      <path
        d="M17.8432 8.53711L18.2383 10.3568H18.2276L17.8325 8.53711H17.8432Z"
        fill="url(#paint471_linear_253_19555)"
      />
      <path
        d="M17.8539 8.53711L18.249 10.3568H18.2383L17.8433 8.53711H17.8539Z"
        fill="url(#paint472_linear_253_19555)"
      />
      <path
        d="M17.8642 8.53711L18.2593 10.3568H18.2486L17.8535 8.53711H17.8642Z"
        fill="url(#paint473_linear_253_19555)"
      />
      <path
        d="M17.8744 8.53711L18.2695 10.3568H18.2588L17.8638 8.53711H17.8744Z"
        fill="url(#paint474_linear_253_19555)"
      />
      <path
        d="M17.8862 8.53711L18.2812 10.3568H18.2706L17.8755 8.53711H17.8862Z"
        fill="url(#paint475_linear_253_19555)"
      />
      <path
        d="M17.8964 8.53711L18.2915 10.3568H18.2808L17.8857 8.53711H17.8964Z"
        fill="url(#paint476_linear_253_19555)"
      />
      <path
        d="M17.9067 8.53711L18.3017 10.3568H18.2911L17.896 8.53711H17.9067Z"
        fill="url(#paint477_linear_253_19555)"
      />
      <path
        d="M17.9169 8.53711L18.312 10.3568H18.3013L17.9062 8.53711H17.9169Z"
        fill="url(#paint478_linear_253_19555)"
      />
      <path
        d="M17.9272 8.53711L18.3223 10.3568H18.3116L17.9165 8.53711H17.9272Z"
        fill="url(#paint479_linear_253_19555)"
      />
      <path
        d="M17.9374 8.53711L18.3325 10.3568H18.3218L17.9268 8.53711H17.9374Z"
        fill="url(#paint480_linear_253_19555)"
      />
      <path
        d="M17.9496 8.53711L18.3447 10.3568H18.334L17.939 8.53711H17.9496Z"
        fill="url(#paint481_linear_253_19555)"
      />
      <path
        d="M17.9614 8.53711L18.3564 10.3568H18.3458L17.9507 8.53711H17.9614Z"
        fill="url(#paint482_linear_253_19555)"
      />
      <path
        d="M17.9716 8.53711L18.3667 10.3568H18.356L17.9609 8.53711H17.9716Z"
        fill="url(#paint483_linear_253_19555)"
      />
      <path
        d="M17.9819 8.53711L18.3769 10.3568H18.3663L17.9712 8.53711H17.9819Z"
        fill="url(#paint484_linear_253_19555)"
      />
      <path
        d="M17.9926 8.53711L18.3877 10.3568H18.377L17.9819 8.53711H17.9926Z"
        fill="url(#paint485_linear_253_19555)"
      />
      <path
        d="M18.0024 8.53711L18.3974 10.3568H18.3868L17.9917 8.53711H18.0024Z"
        fill="url(#paint486_linear_253_19555)"
      />
      <path
        d="M18.0126 8.53711L18.4077 10.3568H18.397L18.002 8.53711H18.0126Z"
        fill="url(#paint487_linear_253_19555)"
      />
      <path
        d="M18.0248 8.53711L18.4199 10.3568H18.4092L18.0142 8.53711H18.0248Z"
        fill="url(#paint488_linear_253_19555)"
      />
      <path
        d="M18.0351 8.53711L18.4302 10.3568H18.4195L18.0244 8.53711H18.0351Z"
        fill="url(#paint489_linear_253_19555)"
      />
      <path
        d="M18.0453 8.53711L18.4404 10.3568H18.4297L18.0347 8.53711H18.0453Z"
        fill="url(#paint490_linear_253_19555)"
      />
      <path
        d="M18.0571 8.53711L18.4521 10.3568H18.4415L18.0464 8.53711H18.0571Z"
        fill="url(#paint491_linear_253_19555)"
      />
      <path
        d="M18.0673 8.53711L18.4624 10.3568H18.4517L18.0566 8.53711H18.0673Z"
        fill="url(#paint492_linear_253_19555)"
      />
      <path
        d="M18.0776 8.53711L18.4726 10.3568H18.462L18.0669 8.53711H18.0776Z"
        fill="url(#paint493_linear_253_19555)"
      />
      <path
        d="M18.0878 8.53711L18.4829 10.3568H18.4722L18.0771 8.53711H18.0878Z"
        fill="url(#paint494_linear_253_19555)"
      />
      <path
        d="M18.1 8.53711L18.4951 10.3568H18.4844L18.0894 8.53711H18.1Z"
        fill="url(#paint495_linear_253_19555)"
      />
      <path
        d="M18.1103 8.53711L18.5054 10.3568H18.4947L18.0996 8.53711H18.1103Z"
        fill="url(#paint496_linear_253_19555)"
      />
      <path
        d="M18.1205 8.53711L18.5156 10.3568H18.5049L18.1099 8.53711H18.1205Z"
        fill="url(#paint497_linear_253_19555)"
      />
      <path
        d="M18.1308 8.53711L18.5259 10.3568H18.5152L18.1201 8.53711H18.1308Z"
        fill="url(#paint498_linear_253_19555)"
      />
      <path
        d="M18.141 8.53711L18.5361 10.3568H18.5254L18.1304 8.53711H18.141Z"
        fill="url(#paint499_linear_253_19555)"
      />
      <path
        d="M18.1513 8.53711L18.5464 10.3568H18.5357L18.1406 8.53711H18.1513Z"
        fill="url(#paint500_linear_253_19555)"
      />
      <path
        d="M18.165 8.53711L18.56 10.3568H18.5494L18.1543 8.53711H18.165Z"
        fill="url(#paint501_linear_253_19555)"
      />
      <path
        d="M18.1752 8.53711L18.5703 10.3568H18.5596L18.1646 8.53711H18.1752Z"
        fill="url(#paint502_linear_253_19555)"
      />
      <path
        d="M18.185 8.53711L18.5801 10.3568H18.5694L18.1743 8.53711H18.185Z"
        fill="url(#paint503_linear_253_19555)"
      />
      <path
        d="M18.1957 8.53711L18.5908 10.3568H18.5801L18.1851 8.53711H18.1957Z"
        fill="url(#paint504_linear_253_19555)"
      />
      <path
        d="M18.206 8.53711L18.6011 10.3568H18.5904L18.1953 8.53711H18.206Z"
        fill="url(#paint505_linear_253_19555)"
      />
      <path
        d="M18.2162 8.53711L18.6113 10.3568H18.6006L18.2056 8.53711H18.2162Z"
        fill="url(#paint506_linear_253_19555)"
      />
      <path
        d="M18.2265 8.53711L18.6216 10.3568H18.6109L18.2158 8.53711H18.2265Z"
        fill="url(#paint507_linear_253_19555)"
      />
      <path
        d="M18.2382 8.53711L18.6333 10.3568H18.6226L18.2275 8.53711H18.2382Z"
        fill="url(#paint508_linear_253_19555)"
      />
      <path
        d="M18.2485 8.53711L18.6435 10.3568H18.6329L18.2378 8.53711H18.2485Z"
        fill="url(#paint509_linear_253_19555)"
      />
      <path
        d="M18.2587 8.53711L18.6538 10.3568H18.6431L18.248 8.53711H18.2587Z"
        fill="url(#paint510_linear_253_19555)"
      />
      <path
        d="M18.2709 8.53711L18.666 10.3568H18.6553L18.2603 8.53711H18.2709Z"
        fill="url(#paint511_linear_253_19555)"
      />
      <path
        d="M18.2812 8.53711L18.6763 10.3568H18.6656L18.2705 8.53711H18.2812Z"
        fill="url(#paint512_linear_253_19555)"
      />
      <path
        d="M18.2914 8.53711L18.6865 10.3568H18.6758L18.2808 8.53711H18.2914Z"
        fill="url(#paint513_linear_253_19555)"
      />
      <path
        d="M18.3032 8.53711L18.6982 10.3568H18.6875L18.2925 8.53711H18.3032Z"
        fill="url(#paint514_linear_253_19555)"
      />
      <path
        d="M18.3134 8.53711L18.7085 10.3568H18.6978L18.3027 8.53711H18.3134Z"
        fill="url(#paint515_linear_253_19555)"
      />
      <path
        d="M18.3237 8.53711L18.7187 10.3568H18.7081L18.313 8.53711H18.3237Z"
        fill="url(#paint516_linear_253_19555)"
      />
      <path
        d="M18.3339 8.53711L18.729 10.3568H18.7183L18.3232 8.53711H18.3339Z"
        fill="url(#paint517_linear_253_19555)"
      />
      <path
        d="M18.3415 8.53711L18.7366 10.3568H18.7286L18.3335 8.53711H18.3415Z"
        fill="url(#paint518_linear_253_19555)"
      />
      <path
        d="M18.3503 8.53711L18.7454 10.3568H18.7374L18.3423 8.53711H18.3503Z"
        fill="url(#paint519_linear_253_19555)"
      />
      <path
        d="M18.3598 8.53711L18.7522 10.3568H18.7442L18.3491 8.53711H18.3598Z"
        fill="url(#paint520_linear_253_19555)"
      />
      <path
        d="M18.3688 8.53711L18.7612 10.3568H18.7532L18.3608 8.53711H18.3688Z"
        fill="url(#paint521_linear_253_19555)"
      />
      <path
        d="M18.3776 8.53711L18.7727 10.3568H18.762L18.3696 8.53711H18.3776Z"
        fill="url(#paint522_linear_253_19555)"
      />
      <path
        d="M18.3859 8.53711L18.781 10.3568H18.773L18.3779 8.53711H18.3859Z"
        fill="url(#paint523_linear_253_19555)"
      />
      <path
        d="M18.3928 8.53711L18.7878 10.3568H18.7798L18.3848 8.53711H18.3928Z"
        fill="url(#paint524_linear_253_19555)"
      />
      <path
        d="M18.4042 8.53711L18.7966 10.3568H18.7886L18.3936 8.53711H18.4042Z"
        fill="url(#paint525_linear_253_19555)"
      />
      <path
        d="M18.4118 8.53711L18.8069 10.3568H18.7962L18.4038 8.53711H18.4118Z"
        fill="url(#paint526_linear_253_19555)"
      />
      <path
        d="M18.4187 8.53711L18.8137 10.3568H18.8057L18.4106 8.53711H18.4187Z"
        fill="url(#paint527_linear_253_19555)"
      />
      <path
        d="M18.427 8.53711L18.822 10.3568H18.814L18.4189 8.53711H18.427Z"
        fill="url(#paint528_linear_253_19555)"
      />
      <path
        d="M18.4384 8.53711L18.8308 10.3568H18.8228L18.4277 8.53711H18.4384Z"
        fill="url(#paint529_linear_253_19555)"
      />
      <path
        d="M18.4475 8.53711L18.8425 10.3568H18.8319L18.4395 8.53711H18.4475Z"
        fill="url(#paint530_linear_253_19555)"
      />
      <path
        d="M18.4543 8.53711L18.8494 10.3568H18.8414L18.4463 8.53711H18.4543Z"
        fill="url(#paint531_linear_253_19555)"
      />
      <path
        d="M18.4631 8.53711L18.8582 10.3568H18.8501L18.4551 8.53711H18.4631Z"
        fill="url(#paint532_linear_253_19555)"
      />
      <path
        d="M18.4726 8.53711L18.865 10.3568H18.857L18.4619 8.53711H18.4726Z"
        fill="url(#paint533_linear_253_19555)"
      />
      <path
        d="M18.4816 8.53711L18.874 10.3568H18.866L18.4736 8.53711H18.4816Z"
        fill="url(#paint534_linear_253_19555)"
      />
      <path
        d="M18.4885 8.53711L18.8835 10.3568H18.8729L18.4805 8.53711H18.4885Z"
        fill="url(#paint535_linear_253_19555)"
      />
      <path
        d="M18.4973 8.53711L18.8923 10.3568H18.8843L18.4893 8.53711H18.4973Z"
        fill="url(#paint536_linear_253_19555)"
      />
      <path
        d="M18.5056 8.53711L18.9006 10.3568H18.8926L18.4976 8.53711H18.5056Z"
        fill="url(#paint537_linear_253_19555)"
      />
      <path
        d="M18.517 8.53711L18.9094 10.3568H18.9014L18.5063 8.53711H18.517Z"
        fill="url(#paint538_linear_253_19555)"
      />
      <path
        d="M18.5246 8.53711L18.9197 10.3568H18.909L18.5166 8.53711H18.5246Z"
        fill="url(#paint539_linear_253_19555)"
      />
      <path
        d="M18.5314 8.53711L18.9265 10.3568H18.9185L18.5234 8.53711H18.5314Z"
        fill="url(#paint540_linear_253_19555)"
      />
      <path
        d="M18.5402 8.53711L18.9353 10.3568H18.9273L18.5322 8.53711H18.5402Z"
        fill="url(#paint541_linear_253_19555)"
      />
      <path
        d="M18.5512 8.53711L18.9436 10.3568H18.9356L18.5405 8.53711H18.5512Z"
        fill="url(#paint542_linear_253_19555)"
      />
      <path
        d="M18.5588 8.53711L18.9539 10.3568H18.9432L18.5508 8.53711H18.5588Z"
        fill="url(#paint543_linear_253_19555)"
      />
      <path
        d="M18.5656 8.53711L18.9607 10.3568H18.9527L18.5576 8.53711H18.5656Z"
        fill="url(#paint544_linear_253_19555)"
      />
      <path
        d="M18.5759 8.53711L18.9709 10.3568H18.9629L18.5679 8.53711H18.5759Z"
        fill="url(#paint545_linear_253_19555)"
      />
      <path
        d="M18.5854 8.53711L18.9778 10.3568H18.9698L18.5747 8.53711H18.5854Z"
        fill="url(#paint546_linear_253_19555)"
      />
      <path
        d="M18.593 8.53711L18.9854 10.3568H18.9774L18.585 8.53711H18.593Z"
        fill="url(#paint547_linear_253_19555)"
      />
      <path
        d="M18.6013 8.53711L18.9963 10.3568H18.9857L18.5933 8.53711H18.6013Z"
        fill="url(#paint548_linear_253_19555)"
      />
      <path
        d="M18.6101 8.53711L19.0051 10.3568H18.9971L18.6021 8.53711H18.6101Z"
        fill="url(#paint549_linear_253_19555)"
      />
      <path
        d="M18.6169 8.53711L19.012 10.3568H19.004L18.6089 8.53711H18.6169Z"
        fill="url(#paint550_linear_253_19555)"
      />
      <path
        d="M18.6279 8.53711L19.0203 10.3568H19.0123L18.6172 8.53711H18.6279Z"
        fill="url(#paint551_linear_253_19555)"
      />
      <path
        d="M18.6354 8.53711L19.0278 10.3461V10.3568H19.0198L18.6274 8.53711H18.6354Z"
        fill="url(#paint552_linear_253_19555)"
      />
      <path
        d="M18.6442 8.53711L19.0286 10.3058V10.3461L18.6362 8.53711H18.6442Z"
        fill="url(#paint553_linear_253_19555)"
      />
      <path
        d="M18.6525 8.53711L19.0289 10.2656V10.3058L18.6445 8.53711H18.6525Z"
        fill="url(#paint554_linear_253_19555)"
      />
      <path
        d="M18.664 8.53711L19.0297 10.2253V10.2656L18.6533 8.53711H18.664Z"
        fill="url(#paint555_linear_253_19555)"
      />
      <path
        d="M18.6716 8.53711L19.0293 10.185V10.2253L18.6636 8.53711H18.6716Z"
        fill="url(#paint556_linear_253_19555)"
      />
      <path
        d="M18.6784 8.53711L19.0281 10.1448V10.185L18.6704 8.53711H18.6784Z"
        fill="url(#paint557_linear_253_19555)"
      />
      <path
        d="M18.6867 8.53711L19.0284 10.1072V10.1448L18.6787 8.53711H18.6867Z"
        fill="url(#paint558_linear_253_19555)"
      />
      <path
        d="M18.6962 8.53711L19.0272 10.067V10.1072L18.6855 8.53711H18.6962Z"
        fill="url(#paint559_linear_253_19555)"
      />
      <path
        d="M18.7038 8.53711L19.0268 10.0267V10.067L18.6958 8.53711H18.7038Z"
        fill="url(#paint560_linear_253_19555)"
      />
      <path
        d="M18.7141 8.53711L19.0291 9.98643V10.0267L18.7061 8.53711H18.7141Z"
        fill="url(#paint561_linear_253_19555)"
      />
      <path
        d="M18.7229 8.53711L19.0298 9.94617V9.98643L18.7148 8.53711H18.7229Z"
        fill="url(#paint562_linear_253_19555)"
      />
      <path
        d="M18.7297 8.53711L19.0287 9.9086V9.94617L18.7217 8.53711H18.7297Z"
        fill="url(#paint563_linear_253_19555)"
      />
      <path
        d="M18.7407 8.53711L19.029 9.86834V9.9086L18.73 8.53711H18.7407Z"
        fill="url(#paint564_linear_253_19555)"
      />
      <path
        d="M18.7487 8.53711L19.029 9.82808V9.86834L18.7407 8.53711H18.7487Z"
        fill="url(#paint565_linear_253_19555)"
      />
      <path
        d="M18.7551 8.53711L19.0274 9.78782V9.82808L18.7471 8.53711H18.7551Z"
        fill="url(#paint566_linear_253_19555)"
      />
      <path
        d="M18.7639 8.53711L19.0281 9.74756V9.78782L18.7559 8.53711H18.7639Z"
        fill="url(#paint567_linear_253_19555)"
      />
      <path
        d="M19.027 9.74756L18.7627 8.53711H19.027V9.74756Z"
        fill="url(#paint568_linear_253_19555)"
      />
    </g>
    <mask
      height="3"
      id="mask5_253_19555"
      maskUnits="userSpaceOnUse"
      style={{ maskType: 'luminance' }}
      width="2"
      x="15"
      y="6"
    >
      <path
        d="M15.8113 7.00713C16.2574 6.91051 16.6981 7.195 16.7943 7.64054C16.8905 8.08607 16.6073 8.53429 16.1639 8.63091C15.7205 8.72753 15.277 8.44303 15.1809 7.99482C15.0847 7.5466 15.3679 7.10375 15.8113 7.00713Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask5_253_19555)">
      <path
        d="M15.0815 7.54883L15.3378 8.72976H15.0815V7.54883Z"
        fill="url(#paint569_linear_253_19555)"
      />
      <path
        d="M15.0815 7.41699L15.3672 8.72944H15.3378L15.0815 7.5485V7.41699Z"
        fill="url(#paint570_linear_253_19555)"
      />
      <path
        d="M15.0815 7.28809L15.3939 8.72936H15.3672L15.0815 7.41691V7.28809Z"
        fill="url(#paint571_linear_253_19555)"
      />
      <path
        d="M15.0815 7.15723L15.4232 8.73001H15.3939L15.0815 7.28874V7.15723Z"
        fill="url(#paint572_linear_253_19555)"
      />
      <path
        d="M15.0815 7.02539L15.4499 8.72969H15.4232L15.0815 7.1569V7.02539Z"
        fill="url(#paint573_linear_253_19555)"
      />
      <path
        d="M15.0842 6.91016L15.4793 8.72986H15.4499L15.0815 7.02557V6.91016H15.0842Z"
        fill="url(#paint574_linear_253_19555)"
      />
      <path
        d="M15.1143 6.91016L15.5094 8.72986H15.48L15.085 6.91016H15.1143Z"
        fill="url(#paint575_linear_253_19555)"
      />
      <path
        d="M15.139 6.91016L15.5341 8.72986H15.5074L15.1123 6.91016H15.139Z"
        fill="url(#paint576_linear_253_19555)"
      />
      <path
        d="M15.1705 6.91016L15.5655 8.72986H15.5362L15.1411 6.91016H15.1705Z"
        fill="url(#paint577_linear_253_19555)"
      />
      <path
        d="M15.1978 6.91016L15.5902 8.72986H15.5635L15.1685 6.91016H15.1978Z"
        fill="url(#paint578_linear_253_19555)"
      />
      <path
        d="M15.2259 6.91016L15.621 8.72986H15.5916L15.1992 6.91016H15.2259Z"
        fill="url(#paint579_linear_253_19555)"
      />
      <path
        d="M15.2545 6.91016L15.6469 8.72986H15.6202L15.2251 6.91016H15.2545Z"
        fill="url(#paint580_linear_253_19555)"
      />
      <path
        d="M15.2826 6.91016L15.6776 8.72986H15.6483L15.2559 6.91016H15.2826Z"
        fill="url(#paint581_linear_253_19555)"
      />
      <path
        d="M15.3106 6.91016L15.7057 8.72986H15.6763L15.2812 6.91016H15.3106Z"
        fill="url(#paint582_linear_253_19555)"
      />
      <path
        d="M15.3399 6.91016L15.7323 8.72986H15.7056L15.3105 6.91016H15.3399Z"
        fill="url(#paint583_linear_253_19555)"
      />
      <path
        d="M15.368 6.91016L15.7631 8.72986H15.7337L15.3413 6.91016H15.368Z"
        fill="url(#paint584_linear_253_19555)"
      />
      <path
        d="M15.3961 6.91016L15.7885 8.72986H15.7618L15.3667 6.91016H15.3961Z"
        fill="url(#paint585_linear_253_19555)"
      />
      <path
        d="M15.4242 6.91016L15.8192 8.72986H15.7899L15.3975 6.91016H15.4242Z"
        fill="url(#paint586_linear_253_19555)"
      />
      <path
        d="M15.4527 6.91016L15.8478 8.72986H15.8184L15.4233 6.91016H15.4527Z"
        fill="url(#paint587_linear_253_19555)"
      />
      <path
        d="M15.4815 6.91016L15.8739 8.72986H15.8472L15.4521 6.91016H15.4815Z"
        fill="url(#paint588_linear_253_19555)"
      />
      <path
        d="M15.5096 6.91016L15.9047 8.72986H15.8753L15.4829 6.91016H15.5096Z"
        fill="url(#paint589_linear_253_19555)"
      />
      <path
        d="M15.5382 6.91016L15.9306 8.72986H15.9039L15.5088 6.91016H15.5382Z"
        fill="url(#paint590_linear_253_19555)"
      />
      <path
        d="M15.5662 6.91016L15.9613 8.72986H15.932L15.5396 6.91016H15.5662Z"
        fill="url(#paint591_linear_253_19555)"
      />
      <path
        d="M15.5943 6.91016L15.9894 8.72986H15.96L15.5649 6.91016H15.5943Z"
        fill="url(#paint592_linear_253_19555)"
      />
      <path
        d="M15.6236 6.91016L16.016 8.72986H15.9893L15.5942 6.91016H15.6236Z"
        fill="url(#paint593_linear_253_19555)"
      />
      <path
        d="M15.6497 6.91016L16.0448 8.72986H16.0154L15.623 6.91016H15.6497Z"
        fill="url(#paint594_linear_253_19555)"
      />
      <path
        d="M15.6798 6.91016L16.0722 8.72986H16.0455L15.6504 6.91016H15.6798Z"
        fill="url(#paint595_linear_253_19555)"
      />
      <path
        d="M15.7078 6.91016L16.1029 8.72986H16.0736L15.6812 6.91016H15.7078Z"
        fill="url(#paint596_linear_253_19555)"
      />
      <path
        d="M15.7364 6.91016L16.1315 8.72986H16.1021L15.707 6.91016H15.7364Z"
        fill="url(#paint597_linear_253_19555)"
      />
      <path
        d="M15.7611 6.91016L16.1561 8.72986H16.1294L15.7344 6.91016H15.7611Z"
        fill="url(#paint598_linear_253_19555)"
      />
      <path
        d="M15.7925 6.91016L16.1876 8.72986H16.1583L15.7632 6.91016H15.7925Z"
        fill="url(#paint599_linear_253_19555)"
      />
      <path
        d="M15.8199 6.91016L16.2123 8.72986H16.1856L15.7905 6.91016H15.8199Z"
        fill="url(#paint600_linear_253_19555)"
      />
      <path
        d="M15.848 6.91016L16.2431 8.72986H16.2137L15.8213 6.91016H15.848Z"
        fill="url(#paint601_linear_253_19555)"
      />
      <path
        d="M15.878 6.91016L16.2704 8.72986H16.2437L15.8486 6.91016H15.878Z"
        fill="url(#paint602_linear_253_19555)"
      />
      <path
        d="M15.9046 6.91016L16.2997 8.72986H16.2703L15.8779 6.91016H15.9046Z"
        fill="url(#paint603_linear_253_19555)"
      />
      <path
        d="M15.9346 6.91016L16.3297 8.72986H16.3003L15.9053 6.91016H15.9346Z"
        fill="url(#paint604_linear_253_19555)"
      />
      <path
        d="M15.962 6.91016L16.3544 8.72986H16.3277L15.9326 6.91016H15.962Z"
        fill="url(#paint605_linear_253_19555)"
      />
      <path
        d="M15.9901 6.91016L16.3851 8.72986H16.3558L15.9634 6.91016H15.9901Z"
        fill="url(#paint606_linear_253_19555)"
      />
      <path
        d="M16.0181 6.91016L16.4105 8.72986H16.3838L15.9888 6.91016H16.0181Z"
        fill="url(#paint607_linear_253_19555)"
      />
      <path
        d="M16.0462 6.91016L16.4413 8.72986H16.4119L16.0195 6.91016H16.0462Z"
        fill="url(#paint608_linear_253_19555)"
      />
      <path
        d="M16.0748 6.91016L16.4698 8.72986H16.4405L16.0454 6.91016H16.0748Z"
        fill="url(#paint609_linear_253_19555)"
      />
      <path
        d="M16.1036 6.91016L16.496 8.72986H16.4693L16.0742 6.91016H16.1036Z"
        fill="url(#paint610_linear_253_19555)"
      />
      <path
        d="M16.1317 6.91016L16.5267 8.72986H16.4974L16.105 6.91016H16.1317Z"
        fill="url(#paint611_linear_253_19555)"
      />
      <path
        d="M16.1602 6.91016L16.5526 8.72986H16.5259L16.1309 6.91016H16.1602Z"
        fill="url(#paint612_linear_253_19555)"
      />
      <path
        d="M16.1883 6.91016L16.5834 8.72986H16.554L16.1616 6.91016H16.1883Z"
        fill="url(#paint613_linear_253_19555)"
      />
      <path
        d="M16.5821 8.72986L16.187 6.91016H16.8891V8.72986H16.5821Z"
        fill="url(#paint614_linear_253_19555)"
      />
    </g>
    <mask
      height="6"
      id="mask6_253_19555"
      maskUnits="userSpaceOnUse"
      style={{ maskType: 'luminance' }}
      width="6"
      x="3"
      y="7"
    >
      <path
        d="M8.22145 9.25331L8.44008 10.1764C8.46618 10.288 8.38787 10.3996 8.26714 10.4237L6.94234 10.6922C6.89013 10.7042 6.8575 10.7525 6.87055 10.8008L7.16096 12.0255C7.18706 12.1371 7.10875 12.2487 6.98802 12.2728L5.98952 12.4749C5.86879 12.499 5.74806 12.4267 5.72195 12.315L5.43154 11.0903C5.41849 11.0421 5.36954 11.0089 5.31733 11.021L3.98927 11.2894C3.86853 11.3136 3.7478 11.2412 3.72169 11.1296L3.50307 10.2065C3.47697 10.0919 3.55528 9.9833 3.67601 9.95917L5.00408 9.6907C5.05629 9.67864 5.08892 9.63037 5.07587 9.58211L4.78545 8.35742C4.75935 8.24581 4.83766 8.1342 4.95839 8.11007L5.95689 7.90796C6.07762 7.88383 6.19836 7.95623 6.22446 8.06784L6.51487 9.29253C6.52793 9.34079 6.57687 9.37397 6.62908 9.36191L7.95388 9.09344C8.07462 9.06931 8.19535 9.13869 8.22145 9.25331Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask6_253_19555)">
      <path
        d="M3.47217 10.0918L4.03955 12.4959H3.47217V10.0918Z"
        fill="url(#paint615_linear_253_19555)"
      />
      <path
        d="M3.47217 9.8418L4.09824 12.4963H4.03955L3.47217 10.0922V9.8418Z"
        fill="url(#paint616_linear_253_19555)"
      />
      <path
        d="M3.47217 9.59082L4.15694 12.4957H4.09824L3.47217 9.84119V9.59082Z"
        fill="url(#paint617_linear_253_19555)"
      />
      <path
        d="M3.47217 9.34082L4.21563 12.4961H4.15694L3.47217 9.59119V9.34082Z"
        fill="url(#paint618_linear_253_19555)"
      />
      <path
        d="M3.47217 9.09082L4.27433 12.4964H4.21563L3.47217 9.34119V9.09082Z"
        fill="url(#paint619_linear_253_19555)"
      />
      <path
        d="M3.47217 8.83984L4.33302 12.4958H4.27433L3.47217 9.09021V8.83984Z"
        fill="url(#paint620_linear_253_19555)"
      />
      <path
        d="M3.47217 8.58984L4.39172 12.4962H4.33302L3.47217 8.84021V8.58984Z"
        fill="url(#paint621_linear_253_19555)"
      />
      <path
        d="M3.47217 8.3418L4.45041 12.4955H4.39172L3.47217 8.58915V8.3418Z"
        fill="url(#paint622_linear_253_19555)"
      />
      <path
        d="M3.47217 8.0918L4.5091 12.4959H4.45041L3.47217 8.34216V8.0918Z"
        fill="url(#paint623_linear_253_19555)"
      />
      <path
        d="M3.48195 7.88379L4.57106 12.496H4.5091L3.47217 8.09193V7.88379H3.48195Z"
        fill="url(#paint624_linear_253_19555)"
      />
      <path
        d="M3.54112 7.88379L4.63023 12.496H4.57153L3.48242 7.88379H3.54112Z"
        fill="url(#paint625_linear_253_19555)"
      />
      <path
        d="M3.60248 7.88379L4.68833 12.496H4.62964L3.54053 7.88379H3.60248Z"
        fill="url(#paint626_linear_253_19555)"
      />
      <path
        d="M3.66221 7.88379L4.74806 12.496H4.68936L3.60352 7.88379H3.66221Z"
        fill="url(#paint627_linear_253_19555)"
      />
      <path
        d="M3.71885 7.88379L4.8047 12.496H4.74601L3.66016 7.88379H3.71885Z"
        fill="url(#paint628_linear_253_19555)"
      />
      <path
        d="M3.75103 7.88379L4.83688 12.496H4.80753L3.72168 7.88379H3.75103Z"
        fill="url(#paint629_linear_253_19555)"
      />
      <path
        d="M3.78163 7.88379L4.86748 12.496H4.83487L3.74902 7.88379H3.78163Z"
        fill="url(#paint630_linear_253_19555)"
      />
      <path
        d="M3.81255 7.88379L4.8984 12.496H4.86905L3.7832 7.88379H3.81255Z"
        fill="url(#paint631_linear_253_19555)"
      />
      <path
        d="M3.84267 7.88379L4.92852 12.496H4.89591L3.81006 7.88379H3.84267Z"
        fill="url(#paint632_linear_253_19555)"
      />
      <path
        d="M3.87407 7.88379L4.95992 12.496H4.93058L3.84473 7.88379H3.87407Z"
        fill="url(#paint633_linear_253_19555)"
      />
      <path
        d="M3.90468 7.88379L4.99053 12.496H4.95792L3.87207 7.88379H3.90468Z"
        fill="url(#paint634_linear_253_19555)"
      />
      <path
        d="M3.9356 7.88379L5.02471 12.496H4.9921L3.90625 7.88379H3.9356Z"
        fill="url(#paint635_linear_253_19555)"
      />
      <path
        d="M3.96767 7.88379L5.05352 12.496H5.02417L3.93506 7.88379H3.96767Z"
        fill="url(#paint636_linear_253_19555)"
      />
      <path
        d="M4.00038 7.88379L5.08623 12.496H5.05362L3.96777 7.88379H4.00038Z"
        fill="url(#paint637_linear_253_19555)"
      />
      <path
        d="M4.0313 7.88379L5.11715 12.496H5.0878L4.00195 7.88379H4.0313Z"
        fill="url(#paint638_linear_253_19555)"
      />
      <path
        d="M4.06386 7.88379L5.14971 12.496H5.1171L4.03125 7.88379H4.06386Z"
        fill="url(#paint639_linear_253_19555)"
      />
      <path
        d="M4.09282 7.88379L5.17867 12.496H5.14933L4.06348 7.88379H4.09282Z"
        fill="url(#paint640_linear_253_19555)"
      />
      <path
        d="M4.12343 7.88379L5.20928 12.496H5.17667L4.09082 7.88379H4.12343Z"
        fill="url(#paint641_linear_253_19555)"
      />
      <path
        d="M4.15435 7.88379L5.2402 12.496H5.21085L4.125 7.88379H4.15435Z"
        fill="url(#paint642_linear_253_19555)"
      />
      <path
        d="M4.18788 7.88379L5.27373 12.496H5.24112L4.15527 7.88379H4.18788Z"
        fill="url(#paint643_linear_253_19555)"
      />
      <path
        d="M4.21587 7.88379L5.30172 12.496H5.27237L4.18652 7.88379H4.21587Z"
        fill="url(#paint644_linear_253_19555)"
      />
      <path
        d="M4.24794 7.88379L5.33379 12.496H5.30118L4.21533 7.88379H4.24794Z"
        fill="url(#paint645_linear_253_19555)"
      />
      <path
        d="M4.28066 7.88379L5.3665 12.496H5.3339L4.24805 7.88379H4.28066Z"
        fill="url(#paint646_linear_253_19555)"
      />
      <path
        d="M4.31157 7.88379L5.39742 12.496H5.36808L4.28223 7.88379H4.31157Z"
        fill="url(#paint647_linear_253_19555)"
      />
      <path
        d="M4.34364 7.88379L5.42949 12.496H5.39688L4.31104 7.88379H4.34364Z"
        fill="url(#paint648_linear_253_19555)"
      />
      <path
        d="M4.3731 7.88379L5.45895 12.496H5.4296L4.34375 7.88379H4.3731Z"
        fill="url(#paint649_linear_253_19555)"
      />
      <path
        d="M4.40566 7.88379L5.4915 12.496H5.4589L4.37305 7.88379H4.40566Z"
        fill="url(#paint650_linear_253_19555)"
      />
      <path
        d="M4.43609 7.88379L5.52193 12.496H5.49259L4.40674 7.88379H4.43609Z"
        fill="url(#paint651_linear_253_19555)"
      />
      <path
        d="M4.46864 7.88379L5.55449 12.496H5.52188L4.43604 7.88379H4.46864Z"
        fill="url(#paint652_linear_253_19555)"
      />
      <path
        d="M4.49614 7.88379L5.58199 12.496H5.55265L4.4668 7.88379H4.49614Z"
        fill="url(#paint653_linear_253_19555)"
      />
      <path
        d="M4.52968 7.88379L5.61553 12.496H5.58292L4.49707 7.88379H4.52968Z"
        fill="url(#paint654_linear_253_19555)"
      />
      <path
        d="M4.55767 7.88379L5.64678 12.496H5.61417L4.52832 7.88379H4.55767Z"
        fill="url(#paint655_linear_253_19555)"
      />
      <path
        d="M4.59315 7.88379L5.679 12.496H5.64966L4.56055 7.88379H4.59315Z"
        fill="url(#paint656_linear_253_19555)"
      />
      <path
        d="M4.62392 7.88379L5.70977 12.496H5.67716L4.59131 7.88379H4.62392Z"
        fill="url(#paint657_linear_253_19555)"
      />
      <path
        d="M4.65337 7.88379L5.73922 12.496H5.70987L4.62402 7.88379H4.65337Z"
        fill="url(#paint658_linear_253_19555)"
      />
      <path
        d="M4.68544 7.88379L5.77129 12.496H5.73868L4.65283 7.88379H4.68544Z"
        fill="url(#paint659_linear_253_19555)"
      />
      <path
        d="M4.71636 7.88379L5.80221 12.496H5.77286L4.68701 7.88379H4.71636Z"
        fill="url(#paint660_linear_253_19555)"
      />
      <path
        d="M4.74892 7.88379L5.83477 12.496H5.80216L4.71631 7.88379H4.74892Z"
        fill="url(#paint661_linear_253_19555)"
      />
      <path
        d="M4.77788 7.88379L5.86373 12.496H5.83438L4.74854 7.88379H4.77788Z"
        fill="url(#paint662_linear_253_19555)"
      />
      <path
        d="M4.81044 7.88379L5.89629 12.496H5.86368L4.77783 7.88379H4.81044Z"
        fill="url(#paint663_linear_253_19555)"
      />
      <path
        d="M4.83794 7.88379L5.92379 12.496H5.89444L4.80859 7.88379H4.83794Z"
        fill="url(#paint664_linear_253_19555)"
      />
      <path
        d="M4.87343 7.88379L5.95928 12.496H5.92667L4.84082 7.88379H4.87343Z"
        fill="url(#paint665_linear_253_19555)"
      />
      <path
        d="M4.90093 7.88379L5.99004 12.496H5.95743L4.87158 7.88379H4.90093Z"
        fill="url(#paint666_linear_253_19555)"
      />
      <path
        d="M4.93495 7.88379L6.0208 12.496H5.99145L4.90234 7.88379H4.93495Z"
        fill="url(#paint667_linear_253_19555)"
      />
      <path
        d="M4.96571 7.88379L6.05156 12.496H6.01895L4.93311 7.88379H4.96571Z"
        fill="url(#paint668_linear_253_19555)"
      />
      <path
        d="M4.99663 7.88379L6.08248 12.496H6.05313L4.96729 7.88379H4.99663Z"
        fill="url(#paint669_linear_253_19555)"
      />
      <path
        d="M5.02919 7.88379L6.11504 12.496H6.08243L4.99658 7.88379H5.02919Z"
        fill="url(#paint670_linear_253_19555)"
      />
      <path
        d="M5.05816 7.88379L6.144 12.496H6.11466L5.02881 7.88379H5.05816Z"
        fill="url(#paint671_linear_253_19555)"
      />
      <path
        d="M5.09071 7.88379L6.17656 12.496H6.14395L5.05811 7.88379H5.09071Z"
        fill="url(#paint672_linear_253_19555)"
      />
      <path
        d="M5.11821 7.88379L6.20406 12.496H6.17472L5.08887 7.88379H5.11821Z"
        fill="url(#paint673_linear_253_19555)"
      />
      <path
        d="M5.1537 7.88379L6.23955 12.496H6.20694L5.12109 7.88379H5.1537Z"
        fill="url(#paint674_linear_253_19555)"
      />
      <path
        d="M5.1812 7.88379L6.27031 12.496H6.2377L5.15186 7.88379H5.1812Z"
        fill="url(#paint675_linear_253_19555)"
      />
      <path
        d="M5.21523 7.88379L6.30107 12.496H6.27173L5.18262 7.88379H5.21523Z"
        fill="url(#paint676_linear_253_19555)"
      />
      <path
        d="M5.24599 7.88379L6.33184 12.496H6.29923L5.21338 7.88379H5.24599Z"
        fill="url(#paint677_linear_253_19555)"
      />
      <path
        d="M5.27691 7.88379L6.36275 12.496H6.33341L5.24756 7.88379H5.27691Z"
        fill="url(#paint678_linear_253_19555)"
      />
      <path
        d="M5.30946 7.88379L6.39531 12.496H6.3627L5.27686 7.88379H5.30946Z"
        fill="url(#paint679_linear_253_19555)"
      />
      <path
        d="M5.33843 7.88379L6.42428 12.496H6.39493L5.30908 7.88379H5.33843Z"
        fill="url(#paint680_linear_253_19555)"
      />
      <path
        d="M5.37099 7.88379L6.45684 12.496H6.42423L5.33838 7.88379H5.37099Z"
        fill="url(#paint681_linear_253_19555)"
      />
      <path
        d="M5.40191 7.88379L6.48775 12.496H6.45841L5.37256 7.88379H5.40191Z"
        fill="url(#paint682_linear_253_19555)"
      />
      <path
        d="M5.43398 7.88379L6.51982 12.496H6.48722L5.40137 7.88379H5.43398Z"
        fill="url(#paint683_linear_253_19555)"
      />
      <path
        d="M5.46148 7.88379L6.54733 12.496H6.51798L5.43213 7.88379H5.46148Z"
        fill="url(#paint684_linear_253_19555)"
      />
      <path
        d="M5.4955 7.88379L6.58135 12.496H6.54874L5.46289 7.88379H5.4955Z"
        fill="url(#paint685_linear_253_19555)"
      />
      <path
        d="M5.523 7.88379L6.61211 12.496H6.5795L5.49365 7.88379H5.523Z"
        fill="url(#paint686_linear_253_19555)"
      />
      <path
        d="M5.55702 7.88379L6.64287 12.496H6.61352L5.52441 7.88379H5.55702Z"
        fill="url(#paint687_linear_253_19555)"
      />
      <path
        d="M5.58974 7.88379L6.67559 12.496H6.64298L5.55713 7.88379H5.58974Z"
        fill="url(#paint688_linear_253_19555)"
      />
      <path
        d="M5.6187 7.88379L6.70455 12.496H6.6752L5.58936 7.88379H5.6187Z"
        fill="url(#paint689_linear_253_19555)"
      />
      <path
        d="M5.65126 7.88379L6.73711 12.496H6.7045L5.61865 7.88379H5.65126Z"
        fill="url(#paint690_linear_253_19555)"
      />
      <path
        d="M5.68218 7.88379L6.76803 12.496H6.73868L5.65283 7.88379H5.68218Z"
        fill="url(#paint691_linear_253_19555)"
      />
      <path
        d="M5.71474 7.88379L6.80059 12.496H6.76798L5.68213 7.88379H5.71474Z"
        fill="url(#paint692_linear_253_19555)"
      />
      <path
        d="M5.7437 7.88379L6.82955 12.496H6.8002L5.71436 7.88379H5.7437Z"
        fill="url(#paint693_linear_253_19555)"
      />
      <path
        d="M5.77577 7.88379L6.86162 12.496H6.82901L5.74316 7.88379H5.77577Z"
        fill="url(#paint694_linear_253_19555)"
      />
      <path
        d="M5.80327 7.88379L6.88912 12.496H6.85977L5.77393 7.88379H5.80327Z"
        fill="url(#paint695_linear_253_19555)"
      />
      <path
        d="M5.8373 7.88379L6.92314 12.496H6.89054L5.80469 7.88379H5.8373Z"
        fill="url(#paint696_linear_253_19555)"
      />
      <path
        d="M5.87001 7.88379L6.95586 12.496H6.92325L5.8374 7.88379H5.87001Z"
        fill="url(#paint697_linear_253_19555)"
      />
      <path
        d="M5.89898 7.88379L6.98482 12.496H6.95548L5.86963 7.88379H5.89898Z"
        fill="url(#paint698_linear_253_19555)"
      />
      <path
        d="M5.93153 7.88379L7.01738 12.496H6.98477L5.89893 7.88379H5.93153Z"
        fill="url(#paint699_linear_253_19555)"
      />
      <path
        d="M5.96245 7.88379L7.0483 12.496H7.01895L5.93311 7.88379H5.96245Z"
        fill="url(#paint700_linear_253_19555)"
      />
      <path
        d="M5.99452 7.88379L7.08037 12.496H7.04776L5.96191 7.88379H5.99452Z"
        fill="url(#paint701_linear_253_19555)"
      />
      <path
        d="M6.02398 7.88379L7.10983 12.496H7.08048L5.99463 7.88379H6.02398Z"
        fill="url(#paint702_linear_253_19555)"
      />
      <path
        d="M6.05605 7.88379L7.14189 12.496H7.10929L6.02344 7.88379H6.05605Z"
        fill="url(#paint703_linear_253_19555)"
      />
      <path
        d="M6.08355 7.88379L7.1694 12.496H7.14005L6.0542 7.88379H6.08355Z"
        fill="url(#paint704_linear_253_19555)"
      />
      <path
        d="M6.11952 7.88379L7.20537 12.496H7.17276L6.08691 7.88379H6.11952Z"
        fill="url(#paint705_linear_253_19555)"
      />
      <path
        d="M6.14702 7.88379L7.23613 12.496H7.20352L6.11768 7.88379H6.14702Z"
        fill="url(#paint706_linear_253_19555)"
      />
      <path
        d="M6.18105 7.88379L7.26689 12.496H7.23755L6.14844 7.88379H6.18105Z"
        fill="url(#paint707_linear_253_19555)"
      />
      <path
        d="M6.21181 7.88379L7.29766 12.496H7.26505L6.1792 7.88379H6.21181Z"
        fill="url(#paint708_linear_253_19555)"
      />
      <path
        d="M6.24273 7.88379L7.32858 12.496H7.29923L6.21338 7.88379H6.24273Z"
        fill="url(#paint709_linear_253_19555)"
      />
      <path
        d="M6.2748 7.88379L7.36064 12.496H7.32804L6.24219 7.88379H6.2748Z"
        fill="url(#paint710_linear_253_19555)"
      />
      <path
        d="M6.30425 7.88379L7.3901 12.496H7.36075L6.2749 7.88379H6.30425Z"
        fill="url(#paint711_linear_253_19555)"
      />
      <path
        d="M6.33681 7.88379L7.42266 12.496H7.39005L6.3042 7.88379H6.33681Z"
        fill="url(#paint712_linear_253_19555)"
      />
      <path
        d="M6.36577 7.88379L7.45162 12.496H7.42227L6.33643 7.88379H6.36577Z"
        fill="url(#paint713_linear_253_19555)"
      />
      <path
        d="M6.3998 7.88379L7.48564 12.496H7.45304L6.36719 7.88379H6.3998Z"
        fill="url(#paint714_linear_253_19555)"
      />
      <path
        d="M6.4273 7.88379L7.51315 12.496H7.4838L6.39795 7.88379H6.4273Z"
        fill="url(#paint715_linear_253_19555)"
      />
      <path
        d="M6.46083 7.88379L7.54668 12.496H7.51407L6.42822 7.88379H6.46083Z"
        fill="url(#paint716_linear_253_19555)"
      />
      <path
        d="M6.48882 7.88379L7.57793 12.496H7.54532L6.45947 7.88379H6.48882Z"
        fill="url(#paint717_linear_253_19555)"
      />
      <path
        d="M6.52284 7.88379L7.60869 12.496H7.57934L6.49023 7.88379H6.52284Z"
        fill="url(#paint718_linear_253_19555)"
      />
      <path
        d="M6.55507 7.88379L7.64092 12.496H7.60831L6.52246 7.88379H6.55507Z"
        fill="url(#paint719_linear_253_19555)"
      />
      <path
        d="M6.58452 7.88379L7.67037 12.496H7.64102L6.55518 7.88379H6.58452Z"
        fill="url(#paint720_linear_253_19555)"
      />
      <path
        d="M6.61659 7.88379L7.70244 12.496H7.66983L6.58398 7.88379H6.61659Z"
        fill="url(#paint721_linear_253_19555)"
      />
      <path
        d="M6.63952 7.88379L7.72537 12.496H7.70255L6.6167 7.88379H6.63952Z"
        fill="url(#paint722_linear_253_19555)"
      />
      <path
        d="M6.66671 7.88379L7.75256 12.496H7.72647L6.64062 7.88379H6.66671Z"
        fill="url(#paint723_linear_253_19555)"
      />
      <path
        d="M6.6921 7.88379L7.77795 12.496H7.75186L6.66602 7.88379H6.6921Z"
        fill="url(#paint724_linear_253_19555)"
      />
      <path
        d="M6.71798 7.88379L7.80383 12.496H7.77774L6.69189 7.88379H6.71798Z"
        fill="url(#paint725_linear_253_19555)"
      />
      <path
        d="M6.74206 7.88379L7.82791 12.496H7.80509L6.71924 7.88379H6.74206Z"
        fill="url(#paint726_linear_253_19555)"
      />
      <path
        d="M6.76583 7.88379L7.85168 12.496H7.8256L6.73975 7.88379H6.76583Z"
        fill="url(#paint727_linear_253_19555)"
      />
      <path
        d="M6.79318 7.88379L7.87903 12.496H7.85294L6.76709 7.88379H6.79318Z"
        fill="url(#paint728_linear_253_19555)"
      />
      <path
        d="M6.81726 7.88379L7.90637 12.496H7.88028L6.79443 7.88379H6.81726Z"
        fill="url(#paint729_linear_253_19555)"
      />
      <path
        d="M6.84249 7.88379L7.92834 12.496H7.90552L6.81641 7.88379H6.84249Z"
        fill="url(#paint730_linear_253_19555)"
      />
      <path
        d="M6.86984 7.88379L7.95569 12.496H7.9296L6.84375 7.88379H6.86984Z"
        fill="url(#paint731_linear_253_19555)"
      />
      <path
        d="M6.89572 7.88379L7.98156 12.496H7.95548L6.86963 7.88379H6.89572Z"
        fill="url(#paint732_linear_253_19555)"
      />
      <path
        d="M6.91785 7.88379L8.00369 12.496H7.98087L6.89502 7.88379H6.91785Z"
        fill="url(#paint733_linear_253_19555)"
      />
      <path
        d="M6.94503 7.88379L8.03088 12.496H8.00479L6.91895 7.88379H6.94503Z"
        fill="url(#paint734_linear_253_19555)"
      />
      <path
        d="M6.96896 7.88379L8.05481 12.496H8.02872L6.94287 7.88379H6.96896Z"
        fill="url(#paint735_linear_253_19555)"
      />
      <path
        d="M6.9963 7.88379L8.08215 12.496H8.05606L6.97021 7.88379H6.9963Z"
        fill="url(#paint736_linear_253_19555)"
      />
      <path
        d="M7.01892 7.88379L8.10477 12.496H8.08194L6.99609 7.88379H7.01892Z"
        fill="url(#paint737_linear_253_19555)"
      />
      <path
        d="M7.04415 7.88379L8.13 12.496H8.10392L7.01807 7.88379H7.04415Z"
        fill="url(#paint738_linear_253_19555)"
      />
      <path
        d="M7.0715 7.88379L8.15735 12.496H8.13126L7.04541 7.88379H7.0715Z"
        fill="url(#paint739_linear_253_19555)"
      />
      <path
        d="M7.09216 7.88379L8.18127 12.496H8.15518L7.06934 7.88379H7.09216Z"
        fill="url(#paint740_linear_253_19555)"
      />
      <path
        d="M7.1213 7.88379L8.20715 12.496H8.18432L7.09521 7.88379H7.1213Z"
        fill="url(#paint741_linear_253_19555)"
      />
      <path
        d="M7.14669 7.88379L8.23254 12.496H8.20645L7.12061 7.88379H7.14669Z"
        fill="url(#paint742_linear_253_19555)"
      />
      <path
        d="M7.17062 7.88379L8.25647 12.496H8.23038L7.14453 7.88379H7.17062Z"
        fill="url(#paint743_linear_253_19555)"
      />
      <path
        d="M7.19665 7.88379L8.2825 12.496H8.25968L7.17383 7.88379H7.19665Z"
        fill="url(#paint744_linear_253_19555)"
      />
      <path
        d="M7.22042 7.88379L8.30627 12.496H8.28018L7.19434 7.88379H7.22042Z"
        fill="url(#paint745_linear_253_19555)"
      />
      <path
        d="M7.24581 7.88379L8.33166 12.496H8.30558L7.21973 7.88379H7.24581Z"
        fill="url(#paint746_linear_253_19555)"
      />
      <path
        d="M7.27511 7.88379L8.36096 12.496H8.33487L7.24902 7.88379H7.27511Z"
        fill="url(#paint747_linear_253_19555)"
      />
      <path
        d="M7.29577 7.88379L8.38162 12.496H8.3588L7.27295 7.88379H7.29577Z"
        fill="url(#paint748_linear_253_19555)"
      />
      <path
        d="M7.32296 7.88379L8.40881 12.496H8.38272L7.29688 7.88379H7.32296Z"
        fill="url(#paint749_linear_253_19555)"
      />
      <path
        d="M7.34982 7.88379L8.43567 12.496H8.40958L7.32373 7.88379H7.34982Z"
        fill="url(#paint750_linear_253_19555)"
      />
      <path
        d="M7.37097 7.88379L8.46008 12.496H8.43399L7.34814 7.88379H7.37097Z"
        fill="url(#paint751_linear_253_19555)"
      />
      <path
        d="M7.3962 7.88379L8.45923 12.4025V12.496L7.37012 7.88379H7.3962Z"
        fill="url(#paint752_linear_253_19555)"
      />
      <path
        d="M7.42355 7.88379L8.46048 12.2939V12.4025L7.39746 7.88379H7.42355Z"
        fill="url(#paint753_linear_253_19555)"
      />
      <path
        d="M7.44943 7.88379L8.46028 12.1883V12.2939L7.42334 7.88379H7.44943Z"
        fill="url(#paint754_linear_253_19555)"
      />
      <path
        d="M7.47351 7.88379L8.46153 12.0797V12.1883L7.45068 7.88379H7.47351Z"
        fill="url(#paint755_linear_253_19555)"
      />
      <path
        d="M7.49923 7.88379L8.46117 11.9741V12.0797L7.47314 7.88379H7.49923Z"
        fill="url(#paint756_linear_253_19555)"
      />
      <path
        d="M7.52462 7.88379L8.46047 11.8655V11.9741L7.49854 7.88379H7.52462Z"
        fill="url(#paint757_linear_253_19555)"
      />
      <path
        d="M7.55001 7.88379L8.45978 11.76V11.8655L7.52393 7.88379H7.55001Z"
        fill="url(#paint758_linear_253_19555)"
      />
      <path
        d="M7.57263 7.88379L8.45957 11.6544V11.76L7.5498 7.88379H7.57263Z"
        fill="url(#paint759_linear_253_19555)"
      />
      <path
        d="M7.60128 7.88379L8.46213 11.5458V11.6544L7.5752 7.88379H7.60128Z"
        fill="url(#paint760_linear_253_19555)"
      />
      <path
        d="M7.62521 7.88379L8.45997 11.4402V11.5458L7.59912 7.88379H7.62521Z"
        fill="url(#paint761_linear_253_19555)"
      />
      <path
        d="M7.64783 7.88379L8.45977 11.3316V11.4402L7.625 7.88379H7.64783Z"
        fill="url(#paint762_linear_253_19555)"
      />
      <path
        d="M7.67501 7.88379L8.46087 11.226V11.3316L7.64893 7.88379H7.67501Z"
        fill="url(#paint763_linear_253_19555)"
      />
      <path
        d="M7.7004 7.88379L8.46017 11.1175V11.226L7.67432 7.88379H7.7004Z"
        fill="url(#paint764_linear_253_19555)"
      />
      <path
        d="M7.72628 7.88379L8.45996 11.0119V11.1175L7.7002 7.88379H7.72628Z"
        fill="url(#paint765_linear_253_19555)"
      />
      <path
        d="M7.75036 7.88379L8.46122 10.9033V11.0119L7.72754 7.88379H7.75036Z"
        fill="url(#paint766_linear_253_19555)"
      />
      <path
        d="M7.77609 7.88379L8.46086 10.7977V10.9033L7.75 7.88379H7.77609Z"
        fill="url(#paint767_linear_253_19555)"
      />
      <path
        d="M7.79952 7.88379L8.45821 10.6891V10.7977L7.77344 7.88379H7.79952Z"
        fill="url(#paint768_linear_253_19555)"
      />
      <path
        d="M7.82882 7.88379L8.46142 10.5835V10.6891L7.80273 7.88379H7.82882Z"
        fill="url(#paint769_linear_253_19555)"
      />
      <path
        d="M7.85095 7.88379L8.46072 10.4749V10.5835L7.82812 7.88379H7.85095Z"
        fill="url(#paint770_linear_253_19555)"
      />
      <path
        d="M7.87667 7.88379L8.46036 10.3694V10.4749L7.85059 7.88379H7.87667Z"
        fill="url(#paint771_linear_253_19555)"
      />
      <path
        d="M8.46161 10.3694L7.87793 7.88379H8.46161V10.3694Z"
        fill="url(#paint772_linear_253_19555)"
      />
    </g>
    <mask
      height="11"
      id="mask7_253_19555"
      maskUnits="userSpaceOnUse"
      style={{ maskType: 'luminance' }}
      width="11"
      x="0"
      y="5"
    >
      <path
        d="M4.89951 5.24061C7.54916 4.75177 10.1225 6.45976 10.6976 9.11892C11.2874 11.834 9.57088 14.5167 6.86548 15.1087C4.3596 15.6564 1.88601 14.2193 1.06441 11.8488L1.01746 11.6338C0.98812 11.5042 0.970515 11.3746 0.955843 11.2451C0.941172 11.1891 0.929435 11.1302 0.917698 11.0743C0.797392 10.5236 0.776852 9.97586 0.838472 9.44579C1.1319 7.45805 2.60784 5.76184 4.67064 5.28773L4.89951 5.24061ZM8.01571 10.1791L7.81912 9.27794C7.79564 9.16604 7.68707 9.09831 7.57851 9.12187L6.38719 9.38395C6.34024 9.39573 6.29329 9.36334 6.28449 9.31622L6.02334 8.12063C5.99986 8.01167 5.8913 7.941 5.78273 7.96456L4.88484 8.16186C4.77627 8.18542 4.70585 8.29437 4.72932 8.40333L4.99047 9.59892C5.00221 9.64604 4.97287 9.69316 4.92592 9.70494L3.73167 9.96702C3.6231 9.99058 3.55268 10.0966 3.57615 10.2085L3.77275 11.1096C3.79622 11.2186 3.90479 11.2892 4.01336 11.2657L5.20761 11.0036C5.25456 10.9918 5.30151 11.0242 5.31031 11.0713L5.57146 12.2669C5.59493 12.3759 5.7035 12.4466 5.81207 12.423L6.70996 12.2257C6.81853 12.2021 6.88895 12.0932 6.86548 11.9842L6.60433 10.7886C6.59259 10.7415 6.62193 10.6944 6.66888 10.6826L7.8602 10.4205C7.96876 10.397 8.03919 10.288 8.01571 10.1791Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask7_253_19555)">
      <path
        d="M3.55078 11.9932L3.65048 12.4437H3.55078V11.9932Z"
        fill="url(#paint773_linear_253_19555)"
      />
      <path
        d="M3.55078 11.54L3.74724 12.4441H3.65048L3.55078 11.9935V11.54Z"
        fill="url(#paint774_linear_253_19555)"
      />
      <path
        d="M3.55078 11.0859L3.84694 12.4435H3.74724L3.55078 11.5394V11.0859Z"
        fill="url(#paint775_linear_253_19555)"
      />
      <path
        d="M3.55078 10.6328L3.9437 12.4439H3.84694L3.55078 11.0863V10.6328Z"
        fill="url(#paint776_linear_253_19555)"
      />
      <path
        d="M3.55078 10.1797L4.0434 12.4442H3.9437L3.55078 10.6332V10.1797Z"
        fill="url(#paint777_linear_253_19555)"
      />
      <path
        d="M3.55078 9.72559L4.14016 12.4436H4.0434L3.55078 10.1791V9.72559Z"
        fill="url(#paint778_linear_253_19555)"
      />
      <path
        d="M3.55078 9.27539L4.23986 12.444H4.14016L3.55078 9.72595V9.27539Z"
        fill="url(#paint779_linear_253_19555)"
      />
      <path
        d="M3.55078 8.82129L4.33662 12.4434H4.23986L3.55078 9.27479V8.82129Z"
        fill="url(#paint780_linear_253_19555)"
      />
      <path
        d="M3.55078 8.36816L4.43632 12.4438H4.33662L3.55078 8.82166V8.36816Z"
        fill="url(#paint781_linear_253_19555)"
      />
      <path
        d="M3.55665 7.94141L4.53309 12.444H4.43632L3.55078 8.3684V7.94141H3.55665Z"
        fill="url(#paint782_linear_253_19555)"
      />
      <path
        d="M3.65536 7.94141L4.6318 12.444H4.5321L3.55566 7.94141H3.65536Z"
        fill="url(#paint783_linear_253_19555)"
      />
      <path
        d="M3.7535 7.94141L4.72994 12.444H4.63318L3.65674 7.94141H3.7535Z"
        fill="url(#paint784_linear_253_19555)"
      />
      <path
        d="M3.85214 7.94141L4.82858 12.444H4.72888L3.75244 7.94141H3.85214Z"
        fill="url(#paint785_linear_253_19555)"
      />
      <path
        d="M3.94979 7.94141L4.92623 12.444H4.82947L3.85303 7.94141H3.94979Z"
        fill="url(#paint786_linear_253_19555)"
      />
      <path
        d="M4.04843 7.94141L5.02487 12.444H4.92517L3.94873 7.94141H4.04843Z"
        fill="url(#paint787_linear_253_19555)"
      />
      <path
        d="M4.14803 7.94141L5.12447 12.444H5.02771L4.05127 7.94141H4.14803Z"
        fill="url(#paint788_linear_253_19555)"
      />
      <path
        d="M4.2452 7.94141L5.22164 12.444H5.12195L4.14551 7.94141H4.2452Z"
        fill="url(#paint789_linear_253_19555)"
      />
      <path
        d="M4.34286 7.94141L5.3193 12.444H5.22253L4.24609 7.94141H4.34286Z"
        fill="url(#paint790_linear_253_19555)"
      />
      <path
        d="M4.44491 7.94141L5.42135 12.444H5.32165L4.34521 7.94141H4.44491Z"
        fill="url(#paint791_linear_253_19555)"
      />
      <path
        d="M4.53964 7.94141L5.51607 12.444H5.41931L4.44287 7.94141H4.53964Z"
        fill="url(#paint792_linear_253_19555)"
      />
      <path
        d="M4.64169 7.94141L5.61813 12.444H5.51843L4.54199 7.94141H4.64169Z"
        fill="url(#paint793_linear_253_19555)"
      />
      <path
        d="M4.73788 7.94141L5.71432 12.444H5.61755L4.64111 7.94141H4.73788Z"
        fill="url(#paint794_linear_253_19555)"
      />
      <path
        d="M4.83798 7.94141L5.81442 12.444H5.71472L4.73828 7.94141H4.83798Z"
        fill="url(#paint795_linear_253_19555)"
      />
      <path
        d="M4.93417 7.94141L5.91354 12.444H5.81384L4.8374 7.94141H4.93417Z"
        fill="url(#paint796_linear_253_19555)"
      />
      <path
        d="M5.0328 7.94141L6.00924 12.444H5.91248L4.93311 7.94141H5.0328Z"
        fill="url(#paint797_linear_253_19555)"
      />
      <path
        d="M5.13094 7.94141L6.11032 12.444H6.01062L5.03418 7.94141H5.13094Z"
        fill="url(#paint798_linear_253_19555)"
      />
      <path
        d="M5.22958 7.94141L6.20602 12.444H6.10925L5.12988 7.94141H5.22958Z"
        fill="url(#paint799_linear_253_19555)"
      />
      <path
        d="M5.32723 7.94141L6.3066 12.444H6.20691L5.23047 7.94141H5.32723Z"
        fill="url(#paint800_linear_253_19555)"
      />
      <path
        d="M5.42587 7.94141L6.40231 12.444H6.30554L5.32617 7.94141H5.42587Z"
        fill="url(#paint801_linear_253_19555)"
      />
      <path
        d="M5.52401 7.94141L6.50338 12.444H6.40369L5.42725 7.94141H5.52401Z"
        fill="url(#paint802_linear_253_19555)"
      />
      <path
        d="M5.62265 7.94141L6.59909 12.444H6.50232L5.52295 7.94141H5.62265Z"
        fill="url(#paint803_linear_253_19555)"
      />
      <path
        d="M5.72177 7.94141L6.69821 12.444H6.59851L5.62207 7.94141H5.72177Z"
        fill="url(#paint804_linear_253_19555)"
      />
      <path
        d="M5.81942 7.94141L6.79586 12.444H6.6991L5.72266 7.94141H5.81942Z"
        fill="url(#paint805_linear_253_19555)"
      />
      <path
        d="M5.91806 7.94141L6.8945 12.444H6.7948L5.81836 7.94141H5.91806Z"
        fill="url(#paint806_linear_253_19555)"
      />
      <path
        d="M6.0162 7.94141L6.99264 12.444H6.89587L5.91943 7.94141H6.0162Z"
        fill="url(#paint807_linear_253_19555)"
      />
      <path
        d="M6.11483 7.94141L7.09127 12.444H6.99158L6.01514 7.94141H6.11483Z"
        fill="url(#paint808_linear_253_19555)"
      />
      <path
        d="M6.21249 7.94141L7.18893 12.444H7.09216L6.11572 7.94141H6.21249Z"
        fill="url(#paint809_linear_253_19555)"
      />
      <path
        d="M6.31112 7.94141L7.28756 12.444H7.18787L6.21143 7.94141H6.31112Z"
        fill="url(#paint810_linear_253_19555)"
      />
      <path
        d="M6.40731 7.94141L7.38375 12.444H7.28699L6.31055 7.94141H6.40731Z"
        fill="url(#paint811_linear_253_19555)"
      />
      <path
        d="M6.50936 7.94141L7.4858 12.444H7.38611L6.40967 7.94141H6.50936Z"
        fill="url(#paint812_linear_253_19555)"
      />
      <path
        d="M6.60409 7.94141L7.58053 12.444H7.48376L6.50732 7.94141H6.60409Z"
        fill="url(#paint813_linear_253_19555)"
      />
      <path
        d="M6.70614 7.94141L7.68258 12.444H7.58288L6.60645 7.94141H6.70614Z"
        fill="url(#paint814_linear_253_19555)"
      />
      <path
        d="M6.80233 7.94141L7.77877 12.444H7.68201L6.70557 7.94141H6.80233Z"
        fill="url(#paint815_linear_253_19555)"
      />
      <path
        d="M6.90097 7.94141L7.87741 12.444H7.77771L6.80127 7.94141H6.90097Z"
        fill="url(#paint816_linear_253_19555)"
      />
      <path
        d="M6.99862 7.94141L7.97506 12.444H7.87829L6.90186 7.94141H6.99862Z"
        fill="url(#paint817_linear_253_19555)"
      />
      <path
        d="M7.09726 7.94141L8.03557 12.2791V12.444H7.974L6.99756 7.94141H7.09726Z"
        fill="url(#paint818_linear_253_19555)"
      />
      <path
        d="M7.1954 7.94141L8.03695 11.8256V12.2791L7.09863 7.94141H7.1954Z"
        fill="url(#paint819_linear_253_19555)"
      />
      <path
        d="M7.29403 7.94141L8.03589 11.3721V11.8256L7.19434 7.94141H7.29403Z"
        fill="url(#paint820_linear_253_19555)"
      />
      <path
        d="M7.39364 7.94141L8.03873 10.9186V11.3721L7.29688 7.94141H7.39364Z"
        fill="url(#paint821_linear_253_19555)"
      />
      <path
        d="M7.49032 7.94141L8.03572 10.4651V10.9186L7.39062 7.94141H7.49032Z"
        fill="url(#paint822_linear_253_19555)"
      />
      <path
        d="M7.58846 7.94141L8.0371 10.0146V10.4651L7.4917 7.94141H7.58846Z"
        fill="url(#paint823_linear_253_19555)"
      />
      <path
        d="M7.6871 7.94141L8.03604 9.56105V10.0145L7.5874 7.94141H7.6871Z"
        fill="url(#paint824_linear_253_19555)"
      />
      <path
        d="M7.78475 7.94141L8.03693 9.10755V9.56105L7.68799 7.94141H7.78475Z"
        fill="url(#paint825_linear_253_19555)"
      />
      <path
        d="M7.88681 7.94141L8.03928 8.65405V9.10755L7.78711 7.94141H7.88681Z"
        fill="url(#paint826_linear_253_19555)"
      />
      <path
        d="M7.98153 7.94141L8.03724 8.20055V8.65405L7.88477 7.94141H7.98153Z"
        fill="url(#paint827_linear_253_19555)"
      />
      <path
        d="M8.0396 8.20055L7.98389 7.94141H8.0396V8.20055Z"
        fill="url(#paint828_linear_253_19555)"
      />
      <path
        d="M0.775391 10.5205L1.88965 15.6562H0.775391V10.5205Z"
        fill="url(#paint829_linear_253_19555)"
      />
      <path
        d="M0.775391 10.0674L1.98641 15.6566H1.88965L0.775391 10.5209V10.0674Z"
        fill="url(#paint830_linear_253_19555)"
      />
      <path
        d="M0.775391 9.61426L2.08611 15.657H1.98641L0.775391 10.0678V9.61426Z"
        fill="url(#paint831_linear_253_19555)"
      />
      <path
        d="M0.775391 9.16016L2.18287 15.6564H2.08611L0.775391 9.61366V9.16016Z"
        fill="url(#paint832_linear_253_19555)"
      />
      <path
        d="M0.775391 8.70703L2.28361 15.6568H2.18384L0.775391 9.16053V8.70703Z"
        fill="url(#paint833_linear_253_19555)"
      />
      <path
        d="M0.775391 8.25586L2.38044 15.6562H2.28361L0.775391 8.70641V8.25586Z"
        fill="url(#paint834_linear_253_19555)"
      />
      <path
        d="M0.775391 7.80273L2.48021 15.6565H2.38044L0.775391 8.25623V7.80273Z"
        fill="url(#paint835_linear_253_19555)"
      />
      <path
        d="M0.775391 7.34961L2.57704 15.6569H2.48021L0.775391 7.80311V7.34961Z"
        fill="url(#paint836_linear_253_19555)"
      />
      <path
        d="M0.775391 6.89551L2.6768 15.6563H2.57704L0.775391 7.34901V6.89551Z"
        fill="url(#paint837_linear_253_19555)"
      />
      <path
        d="M0.775391 6.44238L2.77363 15.6567H2.6768L0.775391 6.89588V6.44238Z"
        fill="url(#paint838_linear_253_19555)"
      />
      <path
        d="M0.775391 5.98828L2.8734 15.6561H2.77363L0.775391 6.44178V5.98828Z"
        fill="url(#paint839_linear_253_19555)"
      />
      <path
        d="M0.775391 5.53809L2.97023 15.6564H2.8734L0.775391 5.98864V5.53809Z"
        fill="url(#paint840_linear_253_19555)"
      />
      <path
        d="M0.775391 5.53819L0.869287 5.51758L3.06999 15.6565H2.97023L0.775391 5.53819Z"
        fill="url(#paint841_linear_253_19555)"
      />
      <path
        d="M0.869141 5.51768L0.963037 5.49707L3.16668 15.6566H3.06985L0.869141 5.51768Z"
        fill="url(#paint842_linear_253_19555)"
      />
      <path
        d="M0.964844 5.49718L1.05874 5.47656L3.26825 15.6568H3.16849L0.964844 5.49718Z"
        fill="url(#paint843_linear_253_19555)"
      />
      <path
        d="M1.05566 5.47667L1.14956 5.45605L3.36201 15.6569H3.26517L1.05566 5.47667Z"
        fill="url(#paint844_linear_253_19555)"
      />
      <path
        d="M1.14941 5.45616L1.24331 5.43555L3.46162 15.657H3.36186L1.14941 5.45616Z"
        fill="url(#paint845_linear_253_19555)"
      />
      <path
        d="M1.24512 5.43468L1.33901 5.41406L3.56026 15.6561H3.46343L1.24512 5.43468Z"
        fill="url(#paint846_linear_253_19555)"
      />
      <path
        d="M1.33936 5.41417L1.43325 5.39355L3.66037 15.6562H3.5606L1.33936 5.41417Z"
        fill="url(#paint847_linear_253_19555)"
      />
      <path
        d="M1.43311 5.39366L1.527 5.37305L3.75705 15.6563H3.66022L1.43311 5.39366Z"
        fill="url(#paint848_linear_253_19555)"
      />
      <path
        d="M1.52539 5.37315L1.61929 5.35254L3.85521 15.6564H3.75544L1.52539 5.37315Z"
        fill="url(#paint849_linear_253_19555)"
      />
      <path
        d="M1.61963 5.35265L1.71353 5.33203L3.95238 15.6565H3.85555L1.61963 5.35265Z"
        fill="url(#paint850_linear_253_19555)"
      />
      <path
        d="M1.71533 5.33214L1.80923 5.31152L4.05395 15.6566H3.95419L1.71533 5.33214Z"
        fill="url(#paint851_linear_253_19555)"
      />
      <path
        d="M1.80762 5.31163L1.90151 5.29102L4.14917 15.6567H4.05234L1.80762 5.31163Z"
        fill="url(#paint852_linear_253_19555)"
      />
      <path
        d="M1.90137 5.29112L1.99526 5.27051L4.24879 15.6568H4.14902L1.90137 5.29112Z"
        fill="url(#paint853_linear_253_19555)"
      />
      <path
        d="M1.99561 5.27061L2.0895 5.25L4.34596 15.6569H4.24913L1.99561 5.27061Z"
        fill="url(#paint854_linear_253_19555)"
      />
      <path
        d="M2.08936 5.25011L2.18325 5.22949L4.44558 15.6571H4.34581L2.08936 5.25011Z"
        fill="url(#paint855_linear_253_19555)"
      />
      <path
        d="M2.18359 5.22862L2.27749 5.20801L4.54275 15.6562H4.44592L2.18359 5.22862Z"
        fill="url(#paint856_linear_253_19555)"
      />
      <path
        d="M2.27734 5.20811L2.37124 5.1875L4.64237 15.6563H4.5426L2.27734 5.20811Z"
        fill="url(#paint857_linear_253_19555)"
      />
      <path
        d="M2.37158 5.18761L2.46548 5.16699L4.73954 15.6564H4.64271L2.37158 5.18761Z"
        fill="url(#paint858_linear_253_19555)"
      />
      <path
        d="M2.46533 5.1671L2.55923 5.14648L4.83916 15.6565H4.7394L2.46533 5.1671Z"
        fill="url(#paint859_linear_253_19555)"
      />
      <path
        d="M2.55957 5.14659L2.65347 5.12598L4.93927 15.6566H4.8395L2.55957 5.14659Z"
        fill="url(#paint860_linear_253_19555)"
      />
      <path
        d="M2.65332 5.12608L2.74722 5.10547L5.03595 15.6567H4.93912L2.65332 5.12608Z"
        fill="url(#paint861_linear_253_19555)"
      />
      <path
        d="M2.74756 5.10557L2.84146 5.08496L5.13606 15.6568H5.03629L2.74756 5.10557Z"
        fill="url(#paint862_linear_253_19555)"
      />
      <path
        d="M2.84131 5.08505L2.93521 5.06738L5.23274 15.6569H5.13591L2.84131 5.08505Z"
        fill="url(#paint863_linear_253_19555)"
      />
      <path
        d="M2.93359 5.06651L3.02749 5.0459L5.3309 15.656H5.23113L2.93359 5.06651Z"
        fill="url(#paint864_linear_253_19555)"
      />
      <path
        d="M3.0293 5.046L3.12319 5.02539L5.42954 15.6561H5.3327L3.0293 5.046Z"
        fill="url(#paint865_linear_253_19555)"
      />
      <path
        d="M3.12158 5.0255L3.21548 5.00488L5.52769 15.6562H5.42792L3.12158 5.0255Z"
        fill="url(#paint866_linear_253_19555)"
      />
      <path
        d="M3.21582 5.00499L3.30972 4.98438L5.62486 15.6564H5.52803L3.21582 5.00499Z"
        fill="url(#paint867_linear_253_19555)"
      />
      <path
        d="M3.31152 4.98448L3.40542 4.96387L5.72643 15.6565H5.62667L3.31152 4.98448Z"
        fill="url(#paint868_linear_253_19555)"
      />
      <path
        d="M3.40527 4.96397L3.49917 4.94336L5.82312 15.6566H5.72629L3.40527 4.96397Z"
        fill="url(#paint869_linear_253_19555)"
      />
      <path
        d="M3.49756 4.94347L3.59146 4.92285L5.92127 15.6567H5.82151L3.49756 4.94347Z"
        fill="url(#paint870_linear_253_19555)"
      />
      <path
        d="M3.5918 4.92296L3.68569 4.90234L6.01844 15.6568H5.92161L3.5918 4.92296Z"
        fill="url(#paint871_linear_253_19555)"
      />
      <path
        d="M3.68555 4.90245L3.77944 4.88184L6.11806 15.6569H6.0183L3.68555 4.90245Z"
        fill="url(#paint872_linear_253_19555)"
      />
      <path
        d="M3.78125 4.88194L3.87515 4.86133L6.2167 15.657H6.11987L3.78125 4.88194Z"
        fill="url(#paint873_linear_253_19555)"
      />
      <path
        d="M3.87549 4.86046L3.96939 4.83984L6.31681 15.6561H6.21704L3.87549 4.86046Z"
        fill="url(#paint874_linear_253_19555)"
      />
      <path
        d="M3.96582 4.83995L4.05678 4.81934L6.41007 15.6562H6.31324L3.96582 4.83995Z"
        fill="url(#paint875_linear_253_19555)"
      />
      <path
        d="M4.06006 4.81944L4.15396 4.79883L6.51311 15.6563H6.41335L4.06006 4.81944Z"
        fill="url(#paint876_linear_253_19555)"
      />
      <path
        d="M4.15234 4.79893L4.24624 4.77832L6.60833 15.6564H6.5115L4.15234 4.79893Z"
        fill="url(#paint877_linear_253_19555)"
      />
      <path
        d="M4.24609 4.77843L4.33999 4.75781L6.70795 15.6565H6.60819L4.24609 4.77843Z"
        fill="url(#paint878_linear_253_19555)"
      />
      <path
        d="M4.34033 4.75784L4.36087 4.75195H4.4401L6.80512 15.6566H6.70829L4.34033 4.75784Z"
        fill="url(#paint879_linear_253_19555)"
      />
      <path
        d="M4.53628 4.75195L6.90425 15.6566H6.80448L4.43945 4.75195H4.53628Z"
        fill="url(#paint880_linear_253_19555)"
      />
      <path
        d="M4.63639 4.75195L7.00141 15.6566H6.90458L4.53662 4.75195H4.63639Z"
        fill="url(#paint881_linear_253_19555)"
      />
      <path
        d="M4.73453 4.75195L7.10249 15.6566H7.00272L4.6377 4.75195H4.73453Z"
        fill="url(#paint882_linear_253_19555)"
      />
      <path
        d="M4.83121 4.75195L7.1933 15.6389L7.11408 15.6566H7.09941L4.73145 4.75195H4.83121Z"
        fill="url(#paint883_linear_253_19555)"
      />
      <path
        d="M4.93082 4.75195L7.28997 15.6183L7.19608 15.6389L4.83398 4.75195H4.93082Z"
        fill="url(#paint884_linear_253_19555)"
      />
      <path
        d="M5.02945 4.75195L7.38274 15.5977L7.28885 15.6183L4.92969 4.75195H5.02945Z"
        fill="url(#paint885_linear_253_19555)"
      />
      <path
        d="M5.12759 4.75195L7.47795 15.5771L7.38405 15.5977L5.03076 4.75195H5.12759Z"
        fill="url(#paint886_linear_253_19555)"
      />
      <path
        d="M5.2277 4.75195L7.57218 15.5564L7.47829 15.5771L5.12793 4.75195H5.2277Z"
        fill="url(#paint887_linear_253_19555)"
      />
      <path
        d="M5.32388 4.75195L7.66543 15.5358L7.57154 15.5564L5.22705 4.75195H5.32388Z"
        fill="url(#paint888_linear_253_19555)"
      />
      <path
        d="M5.42447 4.75195L7.76016 15.5152L7.66626 15.5358L5.32471 4.75195H5.42447Z"
        fill="url(#paint889_linear_253_19555)"
      />
      <path
        d="M5.51871 4.75195L7.85146 15.4946L7.75756 15.5152L5.42188 4.75195H5.51871Z"
        fill="url(#paint890_linear_253_19555)"
      />
      <path
        d="M5.62076 4.75195L7.94764 15.474L7.85375 15.4946L5.521 4.75195H5.62076Z"
        fill="url(#paint891_linear_253_19555)"
      />
      <path
        d="M5.71695 4.75195L8.0409 15.4534L7.947 15.474L5.62012 4.75195H5.71695Z"
        fill="url(#paint892_linear_253_19555)"
      />
      <path
        d="M5.81754 4.75195L8.13562 15.4357L8.04172 15.4534L5.71777 4.75195H5.81754Z"
        fill="url(#paint893_linear_253_19555)"
      />
      <path
        d="M5.91373 4.75195L8.22887 15.4151L8.13497 15.4357L5.81689 4.75195H5.91373Z"
        fill="url(#paint894_linear_253_19555)"
      />
      <path
        d="M6.01383 4.75195L8.3231 15.3945L8.22921 15.4151L5.91406 4.75195H6.01383Z"
        fill="url(#paint895_linear_253_19555)"
      />
      <path
        d="M6.11001 4.75195L8.41636 15.3739L8.32246 15.3945L6.01318 4.75195H6.11001Z"
        fill="url(#paint896_linear_253_19555)"
      />
      <path
        d="M6.20865 4.75195L8.50912 15.3533L8.41523 15.3739L6.10889 4.75195H6.20865Z"
        fill="url(#paint897_linear_253_19555)"
      />
      <path
        d="M6.3063 4.75195L8.60384 15.3326L8.50995 15.3533L6.20947 4.75195H6.3063Z"
        fill="url(#paint898_linear_253_19555)"
      />
      <path
        d="M6.40543 4.75195L8.6971 15.312L8.6032 15.3326L6.30566 4.75195H6.40543Z"
        fill="url(#paint899_linear_253_19555)"
      />
      <path
        d="M6.50308 4.75195L8.79182 15.2914L8.69792 15.312L6.40625 4.75195H6.50308Z"
        fill="url(#paint900_linear_253_19555)"
      />
      <path
        d="M6.60221 4.75195L8.88507 15.2708L8.79118 15.2914L6.50244 4.75195H6.60221Z"
        fill="url(#paint901_linear_253_19555)"
      />
      <path
        d="M6.69986 4.75195L8.97979 15.2502L8.88589 15.2708L6.60303 4.75195H6.69986Z"
        fill="url(#paint902_linear_253_19555)"
      />
      <path
        d="M6.79996 4.75195L9.07403 15.2296L8.98013 15.2502L6.7002 4.75195H6.79996Z"
        fill="url(#paint903_linear_253_19555)"
      />
      <path
        d="M6.89468 4.75195L9.16581 15.209L9.07192 15.2296L6.79785 4.75195H6.89468Z"
        fill="url(#paint904_linear_253_19555)"
      />
      <path
        d="M6.99674 4.75195L9.262 15.1883L9.1681 15.209L6.89697 4.75195H6.99674Z"
        fill="url(#paint905_linear_253_19555)"
      />
      <path
        d="M7.09097 4.75195L9.3533 15.1677L9.2594 15.1883L6.99414 4.75195H7.09097Z"
        fill="url(#paint906_linear_253_19555)"
      />
      <path
        d="M7.19303 4.75195L9.44949 15.1471L9.35559 15.1677L7.09326 4.75195H7.19303Z"
        fill="url(#paint907_linear_253_19555)"
      />
      <path
        d="M7.28921 4.75195L9.54274 15.1265L9.44884 15.1471L7.19238 4.75195H7.28921Z"
        fill="url(#paint908_linear_253_19555)"
      />
      <path
        d="M7.3898 4.75195L9.63746 15.1059L9.54356 15.1265L7.29004 4.75195H7.3898Z"
        fill="url(#paint909_linear_253_19555)"
      />
      <path
        d="M7.48599 4.75195L9.73071 15.0853L9.63682 15.1059L7.38916 4.75195H7.48599Z"
        fill="url(#paint910_linear_253_19555)"
      />
      <path
        d="M7.58463 4.75195L9.82348 15.0647L9.72958 15.0853L7.48486 4.75195H7.58463Z"
        fill="url(#paint911_linear_253_19555)"
      />
      <path
        d="M7.68228 4.75195L9.9182 15.0441L9.8243 15.0647L7.58545 4.75195H7.68228Z"
        fill="url(#paint912_linear_253_19555)"
      />
      <path
        d="M7.78092 4.75195L10.011 15.0234L9.91707 15.0441L7.68115 4.75195H7.78092Z"
        fill="url(#paint913_linear_253_19555)"
      />
      <path
        d="M7.87906 4.75195L10.1062 15.0028L10.0123 15.0234L7.78223 4.75195H7.87906Z"
        fill="url(#paint914_linear_253_19555)"
      />
      <path
        d="M7.9777 4.75195L10.1989 14.9822L10.105 15.0028L7.87793 4.75195H7.9777Z"
        fill="url(#paint915_linear_253_19555)"
      />
      <path
        d="M8.07828 4.75195L10.2937 14.9616L10.1998 14.9822L7.97852 4.75195H8.07828Z"
        fill="url(#paint916_linear_253_19555)"
      />
      <path
        d="M8.17642 4.75195L10.3889 14.941L10.295 14.9616L8.07959 4.75195H8.17642Z"
        fill="url(#paint917_linear_253_19555)"
      />
      <path
        d="M8.27506 4.75195L10.4816 14.9204L10.3877 14.941L8.17529 4.75195H8.27506Z"
        fill="url(#paint918_linear_253_19555)"
      />
      <path
        d="M8.37271 4.75195L10.5764 14.8998L10.4825 14.9204L8.27588 4.75195H8.37271Z"
        fill="url(#paint919_linear_253_19555)"
      />
      <path
        d="M8.47135 4.75195L10.6691 14.8791L10.5752 14.8998L8.37158 4.75195H8.47135Z"
        fill="url(#paint920_linear_253_19555)"
      />
      <path
        d="M8.56949 4.75195L10.7643 14.8585L10.6704 14.8791L8.47266 4.75195H8.56949Z"
        fill="url(#paint921_linear_253_19555)"
      />
      <path
        d="M8.66812 4.75195L10.8571 14.8379L10.7632 14.8585L8.56836 4.75195H8.66812Z"
        fill="url(#paint922_linear_253_19555)"
      />
      <path
        d="M8.76578 4.75195L10.9518 14.8173L10.8579 14.8379L8.66895 4.75195H8.76578Z"
        fill="url(#paint923_linear_253_19555)"
      />
      <path
        d="M8.86637 4.75195L11.0465 14.7967L10.9526 14.8173L8.7666 4.75195H8.86637Z"
        fill="url(#paint924_linear_253_19555)"
      />
      <path
        d="M8.9606 4.75195L11.1378 14.779L11.0439 14.7967L8.86377 4.75195H8.9606Z"
        fill="url(#paint925_linear_253_19555)"
      />
      <path
        d="M9.06266 4.75195L11.234 14.7584L11.1401 14.779L8.96289 4.75195H9.06266Z"
        fill="url(#paint926_linear_253_19555)"
      />
      <path
        d="M9.15884 4.75195L11.2862 14.5552V14.7466L11.2334 14.7584L9.06201 4.75195H9.15884Z"
        fill="url(#paint927_linear_253_19555)"
      />
      <path
        d="M9.25943 4.75195L11.287 14.1017V14.5552L9.15967 4.75195H9.25943Z"
        fill="url(#paint928_linear_253_19555)"
      />
      <path
        d="M9.35562 4.75195L11.2864 13.6482V14.1017L9.25879 4.75195H9.35562Z"
        fill="url(#paint929_linear_253_19555)"
      />
      <path
        d="M9.45572 4.75195L11.2867 13.1947V13.6482L9.35596 4.75195H9.45572Z"
        fill="url(#paint930_linear_253_19555)"
      />
      <path
        d="M9.55191 4.75195L11.2861 12.7412V13.1947L9.45508 4.75195H9.55191Z"
        fill="url(#paint931_linear_253_19555)"
      />
      <path
        d="M9.65055 4.75195L11.2849 12.2907V12.7412L9.55078 4.75195H9.65055Z"
        fill="url(#paint932_linear_253_19555)"
      />
      <path
        d="M9.74869 4.75195L11.2862 11.8372V12.2907L9.65186 4.75195H9.74869Z"
        fill="url(#paint933_linear_253_19555)"
      />
      <path
        d="M11.2851 11.8372L9.74756 4.75195H11.2851V11.8372Z"
        fill="url(#paint934_linear_253_19555)"
      />
    </g>
    <path
      d="M17.2201 6.73756C16.9751 6.73756 16.7301 6.66637 16.5113 6.52398C16.2138 6.3282 16.0126 6.03453 15.9338 5.68747C15.8813 5.3938 15.9076 5.13573 16.0038 4.89545C16.1613 4.49499 16.5026 4.19243 16.9226 4.09454C17.2726 4.01444 17.6226 4.07674 17.9201 4.27252C18.2176 4.4683 18.4188 4.76197 18.4976 5.10903C18.6551 5.82985 18.2088 6.54178 17.5001 6.70196C17.4038 6.71976 17.3076 6.73756 17.2201 6.73756ZM17.2201 4.94885C17.2201 4.94885 17.1588 4.94885 17.1238 4.95775C16.9838 4.99334 16.8701 5.09123 16.8176 5.22472V5.24252C16.7826 5.32261 16.7738 5.4027 16.7913 5.50949C16.8176 5.60738 16.8788 5.71417 16.9838 5.77646C17.0888 5.83875 17.2026 5.86545 17.3163 5.83875C17.5526 5.78536 17.7013 5.54508 17.6488 5.30481C17.6226 5.18912 17.5526 5.09123 17.4563 5.02894C17.3863 4.98444 17.2988 4.95775 17.2201 4.95775V4.94885Z"
      fill="#6E3264"
    />
    <path
      d="M18.042 10.6091C17.797 10.6091 17.552 10.5379 17.3332 10.3955C17.0357 10.1998 16.8345 9.90609 16.7557 9.55902C16.5982 8.8382 17.0445 8.12627 17.7532 7.96609C18.0945 7.886 18.4445 7.95719 18.742 8.14407C19.0395 8.33985 19.2407 8.63352 19.3195 8.98058C19.477 9.70141 19.0307 10.4133 18.322 10.5735C18.2257 10.5913 18.1295 10.6091 18.042 10.6091ZM18.042 8.8204C18.042 8.8204 17.9807 8.8204 17.9457 8.8293C17.7095 8.88269 17.5607 9.12297 17.6132 9.36324C17.6395 9.47893 17.7095 9.57682 17.8057 9.63911C17.9107 9.70141 18.0245 9.7281 18.1382 9.70141C18.3745 9.64801 18.5232 9.40774 18.4707 9.16746C18.4445 9.05177 18.3745 8.95388 18.2782 8.89159C18.2082 8.8471 18.1207 8.8204 18.042 8.8204Z"
      fill="#6E3264"
    />
    <path
      d="M15.7231 9.09596C15.4781 9.09596 15.2331 9.02477 15.0144 8.88238C14.7169 8.6866 14.5156 8.39293 14.4369 8.04587C14.2794 7.32504 14.7256 6.61312 15.4344 6.45293C15.7756 6.37284 16.1256 6.43514 16.4231 6.63092C16.7206 6.8267 16.9219 7.12036 17.0006 7.46743C17.1581 8.18825 16.7119 8.90018 16.0031 9.06036C15.9069 9.07816 15.8106 9.09596 15.7231 9.09596ZM15.7231 7.31614C15.7231 7.31614 15.6619 7.31614 15.6269 7.32504C15.3906 7.37844 15.2419 7.61871 15.2944 7.85899C15.3206 7.97467 15.3906 8.07257 15.4869 8.13486C15.5919 8.19715 15.7056 8.22385 15.8194 8.19715C16.0556 8.14376 16.2044 7.90348 16.1519 7.66321C16.1256 7.54752 16.0556 7.44963 15.9594 7.38734C15.8894 7.34284 15.8019 7.31614 15.7231 7.31614Z"
      fill="#6E3264"
    />
    <path
      d="M19.5288 8.2595C19.2838 8.2595 19.0388 8.18831 18.8201 8.04592C18.5226 7.85014 18.3213 7.55648 18.2426 7.20941C18.0851 6.48859 18.5313 5.77666 19.2401 5.61648C19.5813 5.53639 19.9313 5.60758 20.2288 5.79446C20.5263 5.99024 20.7276 6.28391 20.8063 6.63097C20.9638 7.3518 20.5176 8.06372 19.8088 8.22391C19.7126 8.2417 19.6163 8.2595 19.5288 8.2595ZM19.5201 6.47079C19.5201 6.47079 19.4588 6.47079 19.4238 6.47969C19.1876 6.53308 19.0388 6.77336 19.0913 7.01363C19.1176 7.12932 19.1876 7.22721 19.2838 7.2895C19.3888 7.3518 19.5026 7.37849 19.6163 7.3518C19.8526 7.2984 20.0013 7.05813 19.9488 6.81785C19.9226 6.70217 19.8526 6.60428 19.7563 6.54198C19.6863 6.49749 19.5988 6.47079 19.5201 6.47079Z"
      fill="#6E3264"
    />
    <path
      d="M5.92255 12.5578C5.80005 12.5578 5.67755 12.5222 5.5813 12.451C5.4413 12.3621 5.34505 12.2197 5.31005 12.0506L5.13505 11.223L4.33005 11.401C3.99755 11.4721 3.6563 11.2586 3.57755 10.9115L3.3938 10.0305C3.3238 9.69234 3.5338 9.34527 3.87505 9.27408L4.6888 9.0961L4.5138 8.27738C4.43505 7.93032 4.6538 7.59216 4.99505 7.51206L5.87005 7.32518C6.2113 7.25399 6.5438 7.46757 6.6138 7.81463L6.7888 8.64225L7.5938 8.46426C7.93505 8.38417 8.26755 8.60665 8.3463 8.95371L8.53005 9.83472C8.60005 10.1729 8.39005 10.5199 8.0488 10.5911L7.23505 10.7691L7.41005 11.5878C7.4888 11.9349 7.27005 12.2731 6.9288 12.3532L6.0538 12.54C6.0538 12.54 5.9663 12.5578 5.92255 12.5578ZM5.3888 10.2619C5.55505 10.2619 5.7213 10.3509 5.83505 10.5199L5.90505 10.6801L6.1063 11.6145L6.50005 11.5255L6.29005 10.5022C6.29005 10.2797 6.43005 10.1284 6.51755 10.0572L6.5963 9.986L7.6113 9.75463L7.53255 9.36307L6.62255 9.56775C6.4388 9.62114 6.2113 9.52325 6.0713 9.32747L6.0013 9.15839L5.80005 8.22399L5.4063 8.31298L5.6163 9.33637C5.6163 9.55885 5.4763 9.71013 5.3888 9.78133L5.31005 9.85252L4.29505 10.0839L4.3738 10.4755L5.2838 10.2708C5.2838 10.2708 5.3538 10.2619 5.3888 10.2619ZM5.4763 11.1429H5.4588C5.4588 11.1429 5.46755 11.1429 5.4763 11.1429ZM6.4563 8.70454C6.4563 8.70454 6.4388 8.70454 6.43005 8.70454H6.4563Z"
      fill="#6E3264"
    />
    <path
      d="M24.3699 13.5269L22.8737 6.56786C22.8562 6.46997 22.8299 6.38098 22.8037 6.29199C22.8037 6.28309 22.8037 6.26529 22.8037 6.25639L22.7162 5.87373C22.7162 5.87373 22.6899 5.79364 22.6812 5.75804C21.9987 3.20401 19.5137 1.55768 17.0112 1.94034L16.9849 1.82465C16.8099 0.988142 15.9874 0.463097 15.1824 0.641079L5.46991 2.79465C4.65616 2.97264 4.13116 3.80025 4.30616 4.63676L4.33241 4.76135C2.44241 5.35759 1.04241 7.00391 0.75366 9.0151C0.75366 9.0507 0.73616 9.0863 0.72741 9.13079C0.63991 9.78932 0.65741 10.439 0.78866 11.0708C0.83241 11.2577 0.87616 11.4268 0.93741 11.5958C0.93741 11.6136 0.93741 11.6403 0.93741 11.6581L2.38116 18.4036C2.75741 20.1745 4.29741 21.3937 5.95991 21.3937C6.19616 21.3937 6.43241 21.367 6.67741 21.3225H6.77366C7.72741 21.1 8.54991 20.5216 9.08366 19.6673C9.61741 18.8219 9.79241 17.8252 9.58241 16.8463C9.34616 15.7695 10.0199 14.6927 11.0874 14.4524L14.8324 13.6248C15.3487 13.518 15.8737 13.6159 16.3199 13.9007C16.7662 14.1944 17.0812 14.6482 17.1862 15.1644C17.4049 16.1522 17.9912 16.9976 18.8399 17.5404C19.6799 18.0744 20.6599 18.2434 21.6224 18.0121C23.5737 17.5493 24.8074 15.5381 24.3699 13.518V13.5269ZM16.5999 2.95484C16.7924 2.91034 16.9937 2.88364 17.1862 2.86585C17.6062 2.82135 18.0437 2.84805 18.4549 2.92814C18.9712 3.03493 19.4612 3.23071 19.9162 3.50658C20.3712 3.78245 20.7649 4.14731 21.0887 4.56557C21.4124 4.98382 21.6924 5.48217 21.8237 5.99832C21.8324 6.03392 21.8499 6.06951 21.8674 6.12291L21.9462 6.48777C22.3837 8.85492 20.8787 11.1776 18.5599 11.6937C17.4224 11.9429 16.2412 11.7293 15.2524 11.0797C14.2637 10.4301 13.5812 9.43336 13.3362 8.26758C13.2224 7.73364 13.2049 7.19079 13.2837 6.64795C13.3624 6.10511 13.5287 5.62456 13.7737 5.16181C14.0187 4.69905 14.3512 4.2808 14.7449 3.94263C15.1387 3.60447 15.6112 3.3019 16.1187 3.10612C16.2237 3.06163 16.3374 3.02603 16.4424 2.99043C16.4949 2.97264 16.5474 2.95484 16.5999 2.94594V2.95484ZM5.65366 3.65786L15.3574 1.50429C15.6987 1.4331 16.0487 1.65557 16.1274 2.01154L16.1449 2.10053C14.2549 2.51878 7.01866 4.12062 5.18991 4.52997L5.17241 4.44098C5.09366 4.08502 5.32116 3.73796 5.66241 3.65786H5.65366ZM1.64616 10.875C1.53241 10.3589 1.51491 9.79822 1.59366 9.26428C1.59366 9.24648 1.59366 9.23758 1.59366 9.21978C1.87366 7.43997 3.20366 5.98052 4.91866 5.56226L5.07616 5.52667L5.13741 5.50887C7.48241 5.06392 9.72241 6.58566 10.2212 8.96171C10.7287 11.3378 9.18866 13.785 6.86116 14.2923C4.69991 14.7728 2.50366 13.5269 1.77741 11.3734C1.71616 11.2043 1.67241 11.0352 1.63741 10.8661L1.64616 10.875ZM21.4212 17.1578C20.6949 17.3357 19.9424 17.2022 19.3037 16.7929C18.6562 16.3835 18.2099 15.7339 18.0437 14.9864C17.8862 14.23 17.4487 13.5892 16.8012 13.1621C16.1624 12.7438 15.4012 12.6014 14.6574 12.7616L10.9124 13.5892C9.38116 13.9363 8.40116 15.4847 8.74241 17.0421C8.89991 17.7807 8.75991 18.546 8.35741 19.1867C7.94616 19.8364 7.32491 20.2813 6.64241 20.4326H6.55491C5.05866 20.7619 3.57991 19.7652 3.24741 18.2256L2.30241 13.8028C3.27366 14.7461 4.57741 15.2978 5.94241 15.2978C6.31866 15.2978 6.69491 15.2534 7.07116 15.1733C9.90616 14.5503 11.7174 11.6848 11.1049 8.78373C10.7112 6.90602 9.40741 5.48217 7.77116 4.87704C9.64366 4.45878 12.0849 3.91594 13.9487 3.50658C12.6974 4.75245 12.0937 6.60346 12.4962 8.47226C12.7937 9.86941 13.6074 11.0619 14.7974 11.845C15.6637 12.4145 16.6524 12.7082 17.6499 12.7082C18.0262 12.7082 18.4024 12.6637 18.7699 12.5836C20.5637 12.1832 21.9549 10.875 22.5674 9.23758L23.5299 13.7227C23.8624 15.2622 22.9262 16.8107 21.4387 17.1578H21.4212Z"
      fill="#6E3264"
    />
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_253_19555"
        x1="4.40853"
        x2="4.40928"
        y1="5.36098"
        y2="4.19043"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint1_linear_253_19555"
        x1="4.51461"
        x2="4.51599"
        y1="5.48119"
        y2="3.28907"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint2_linear_253_19555"
        x1="4.61925"
        x2="4.62035"
        y1="5.50117"
        y2="3.13575"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint3_linear_253_19555"
        x1="4.80879"
        x2="4.80987"
        y1="5.50674"
        y2="3.09571"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint4_linear_253_19555"
        x1="5.01621"
        x2="5.01732"
        y1="5.5123"
        y2="3.05567"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint5_linear_253_19555"
        x1="5.22217"
        x2="5.22331"
        y1="5.51689"
        y2="3.01466"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint6_linear_253_19555"
        x1="5.42814"
        x2="5.4293"
        y1="5.52355"
        y2="2.97266"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint7_linear_253_19555"
        x1="5.63553"
        x2="5.63672"
        y1="5.52814"
        y2="2.93165"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint8_linear_253_19555"
        x1="5.84344"
        x2="5.84466"
        y1="5.5337"
        y2="2.89161"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint9_linear_253_19555"
        x1="6.0494"
        x2="6.05065"
        y1="5.53927"
        y2="2.85157"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint10_linear_253_19555"
        x1="6.25484"
        x2="6.25611"
        y1="5.54495"
        y2="2.8086"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint11_linear_253_19555"
        x1="6.45934"
        x2="6.46064"
        y1="5.55052"
        y2="2.76856"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint12_linear_253_19555"
        x1="6.6653"
        x2="6.66663"
        y1="5.55511"
        y2="2.72755"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint13_linear_253_19555"
        x1="6.87273"
        x2="6.87408"
        y1="5.56067"
        y2="2.68751"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint14_linear_253_19555"
        x1="7.45332"
        x2="6.87454"
        y1="5.53004"
        y2="2.64799"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint15_linear_253_19555"
        x1="7.65156"
        x2="7.07279"
        y1="5.49098"
        y2="2.60893"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint16_linear_253_19555"
        x1="7.84833"
        x2="7.26956"
        y1="5.44996"
        y2="2.56791"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint17_linear_253_19555"
        x1="8.05341"
        x2="7.47464"
        y1="5.4109"
        y2="2.52885"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint18_linear_253_19555"
        x1="8.25312"
        x2="7.67435"
        y1="5.36598"
        y2="2.48393"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint19_linear_253_19555"
        x1="8.45673"
        x2="7.87796"
        y1="5.32691"
        y2="2.44487"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint20_linear_253_19555"
        x1="8.65839"
        x2="8.07962"
        y1="5.28492"
        y2="2.40287"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint21_linear_253_19555"
        x1="8.86005"
        x2="8.28128"
        y1="5.24586"
        y2="2.36381"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint22_linear_253_19555"
        x1="9.05976"
        x2="8.48099"
        y1="5.20191"
        y2="2.31987"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint23_linear_253_19555"
        x1="9.26142"
        x2="8.68265"
        y1="5.16383"
        y2="2.28178"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint24_linear_253_19555"
        x1="9.46308"
        x2="8.88431"
        y1="5.12184"
        y2="2.23979"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint25_linear_253_19555"
        x1="9.66669"
        x2="9.08792"
        y1="5.08277"
        y2="2.20073"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint26_linear_253_19555"
        x1="9.86835"
        x2="9.28958"
        y1="5.04078"
        y2="2.15873"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint27_linear_253_19555"
        x1="10.0715"
        x2="9.49271"
        y1="4.99879"
        y2="2.11674"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint28_linear_253_19555"
        x1="10.2697"
        x2="9.69095"
        y1="4.95777"
        y2="2.07573"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint29_linear_253_19555"
        x1="10.4714"
        x2="9.89261"
        y1="4.91871"
        y2="2.03666"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint30_linear_253_19555"
        x1="10.6716"
        x2="10.0928"
        y1="4.87672"
        y2="1.99467"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint31_linear_253_19555"
        x1="10.8713"
        x2="10.2925"
        y1="4.8357"
        y2="1.95366"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint32_linear_253_19555"
        x1="11.0749"
        x2="10.4961"
        y1="4.79371"
        y2="1.91166"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint33_linear_253_19555"
        x1="11.2766"
        x2="10.6978"
        y1="4.75465"
        y2="1.8726"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint34_linear_253_19555"
        x1="11.4782"
        x2="10.8994"
        y1="4.71266"
        y2="1.83061"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint35_linear_253_19555"
        x1="11.6799"
        x2="11.1011"
        y1="4.67359"
        y2="1.79155"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint36_linear_253_19555"
        x1="11.883"
        x2="11.3042"
        y1="4.62965"
        y2="1.7476"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint37_linear_253_19555"
        x1="12.0812"
        x2="11.5025"
        y1="4.59059"
        y2="1.70854"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint38_linear_253_19555"
        x1="12.2849"
        x2="11.7061"
        y1="4.54957"
        y2="1.66752"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint39_linear_253_19555"
        x1="12.4865"
        x2="11.9077"
        y1="4.51051"
        y2="1.62846"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint40_linear_253_19555"
        x1="12.6848"
        x2="12.106"
        y1="4.47145"
        y2="1.5894"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint41_linear_253_19555"
        x1="12.8879"
        x2="12.3091"
        y1="4.42652"
        y2="1.54448"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint42_linear_253_19555"
        x1="13.0895"
        x2="12.5108"
        y1="4.38746"
        y2="1.50541"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint43_linear_253_19555"
        x1="13.2912"
        x2="12.7124"
        y1="4.34547"
        y2="1.46342"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint44_linear_253_19555"
        x1="13.4914"
        x2="12.9126"
        y1="4.30738"
        y2="1.42534"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint45_linear_253_19555"
        x1="14.7394"
        x2="14.7397"
        y1="4.28779"
        y2="1.39942"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint46_linear_253_19555"
        x1="12.7071"
        x2="12.7097"
        y1="23.656"
        y2="2.38678"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint47_linear_253_19555"
        x1="14.5286"
        x2="14.5287"
        y1="8.88184"
        y2="8.80176"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint48_linear_253_19555"
        x1="14.5784"
        x2="14.5788"
        y1="8.94256"
        y2="8.34863"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint49_linear_253_19555"
        x1="14.6279"
        x2="14.6287"
        y1="9.00272"
        y2="7.89161"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint50_linear_253_19555"
        x1="14.6761"
        x2="14.6772"
        y1="9.06344"
        y2="7.43848"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint51_linear_253_19555"
        x1="14.7257"
        x2="14.7271"
        y1="9.1236"
        y2="6.98145"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint52_linear_253_19555"
        x1="14.7738"
        x2="14.7751"
        y1="9.13825"
        y2="6.87598"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint53_linear_253_19555"
        x1="14.8641"
        x2="14.8653"
        y1="9.13825"
        y2="6.87598"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint54_linear_253_19555"
        x1="14.9612"
        x2="14.9625"
        y1="9.13825"
        y2="6.87598"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint55_linear_253_19555"
        x1="15.0589"
        x2="15.0601"
        y1="9.13825"
        y2="6.87598"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint56_linear_253_19555"
        x1="15.1595"
        x2="15.1607"
        y1="9.13825"
        y2="6.87598"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint57_linear_253_19555"
        x1="15.2566"
        x2="15.2579"
        y1="9.13825"
        y2="6.87598"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint58_linear_253_19555"
        x1="15.3563"
        x2="15.3575"
        y1="9.13825"
        y2="6.87598"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint59_linear_253_19555"
        x1="15.4554"
        x2="15.4566"
        y1="9.13825"
        y2="6.87598"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint60_linear_253_19555"
        x1="15.554"
        x2="15.5552"
        y1="9.13825"
        y2="6.87598"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint61_linear_253_19555"
        x1="15.6536"
        x2="15.6549"
        y1="9.13825"
        y2="6.87598"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint62_linear_253_19555"
        x1="15.7542"
        x2="15.7555"
        y1="9.13825"
        y2="6.87598"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint63_linear_253_19555"
        x1="15.8499"
        x2="15.8512"
        y1="9.13825"
        y2="6.87598"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint64_linear_253_19555"
        x1="15.949"
        x2="15.9503"
        y1="9.13825"
        y2="6.87598"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint65_linear_253_19555"
        x1="16.0481"
        x2="16.0494"
        y1="9.13825"
        y2="6.87598"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint66_linear_253_19555"
        x1="16.1458"
        x2="16.1471"
        y1="9.13825"
        y2="6.87598"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint67_linear_253_19555"
        x1="16.2449"
        x2="16.2462"
        y1="9.13825"
        y2="6.87598"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint68_linear_253_19555"
        x1="16.2925"
        x2="16.294"
        y1="9.12824"
        y2="6.87598"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint69_linear_253_19555"
        x1="16.344"
        x2="16.3452"
        y1="8.61439"
        y2="6.87598"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint70_linear_253_19555"
        x1="16.3935"
        x2="16.3944"
        y1="8.10054"
        y2="6.87598"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint71_linear_253_19555"
        x1="16.4411"
        x2="16.4416"
        y1="7.58335"
        y2="6.87598"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint72_linear_253_19555"
        x1="16.4917"
        x2="16.4918"
        y1="7.0695"
        y2="6.87598"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint73_linear_253_19555"
        x1="16.9337"
        x2="16.9338"
        y1="10.4348"
        y2="10.3047"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint74_linear_253_19555"
        x1="16.9836"
        x2="16.984"
        y1="10.495"
        y2="9.84766"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint75_linear_253_19555"
        x1="17.0317"
        x2="17.0325"
        y1="10.5557"
        y2="9.39454"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint76_linear_253_19555"
        x1="17.0813"
        x2="17.0825"
        y1="10.6159"
        y2="8.93751"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint77_linear_253_19555"
        x1="17.1294"
        x2="17.1309"
        y1="10.6766"
        y2="8.48438"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint78_linear_253_19555"
        x1="17.179"
        x2="17.1803"
        y1="10.6841"
        y2="8.42188"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint79_linear_253_19555"
        x1="17.2718"
        x2="17.273"
        y1="10.6841"
        y2="8.42188"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint80_linear_253_19555"
        x1="17.3694"
        x2="17.3707"
        y1="10.6841"
        y2="8.42188"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint81_linear_253_19555"
        x1="17.4666"
        x2="17.4679"
        y1="10.6841"
        y2="8.42188"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint82_linear_253_19555"
        x1="17.5672"
        x2="17.5684"
        y1="10.6841"
        y2="8.42188"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint83_linear_253_19555"
        x1="17.6634"
        x2="17.6646"
        y1="10.6841"
        y2="8.42188"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint84_linear_253_19555"
        x1="17.764"
        x2="17.7652"
        y1="10.6841"
        y2="8.42188"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint85_linear_253_19555"
        x1="17.8631"
        x2="17.8643"
        y1="10.6841"
        y2="8.42188"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint86_linear_253_19555"
        x1="17.9607"
        x2="17.962"
        y1="10.6841"
        y2="8.42188"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint87_linear_253_19555"
        x1="18.0594"
        x2="18.0606"
        y1="10.6841"
        y2="8.42188"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint88_linear_253_19555"
        x1="18.157"
        x2="18.1583"
        y1="10.6841"
        y2="8.42188"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint89_linear_253_19555"
        x1="18.2562"
        x2="18.2574"
        y1="10.6841"
        y2="8.42188"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint90_linear_253_19555"
        x1="18.3553"
        x2="18.3565"
        y1="10.6841"
        y2="8.42188"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint91_linear_253_19555"
        x1="18.4563"
        x2="18.4576"
        y1="10.6841"
        y2="8.42188"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint92_linear_253_19555"
        x1="18.5535"
        x2="18.5548"
        y1="10.6841"
        y2="8.42188"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint93_linear_253_19555"
        x1="18.6483"
        x2="18.6495"
        y1="10.6841"
        y2="8.42188"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint94_linear_253_19555"
        x1="18.6978"
        x2="18.6993"
        y1="10.6241"
        y2="8.42188"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint95_linear_253_19555"
        x1="18.7459"
        x2="18.747"
        y1="10.1102"
        y2="8.42188"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint96_linear_253_19555"
        x1="18.7969"
        x2="18.7977"
        y1="9.59305"
        y2="8.42188"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint97_linear_253_19555"
        x1="18.8444"
        x2="18.8449"
        y1="9.0792"
        y2="8.42188"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint98_linear_253_19555"
        x1="18.8951"
        x2="18.8952"
        y1="8.56202"
        y2="8.42188"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint99_linear_253_19555"
        x1="16.1591"
        x2="16.1593"
        y1="6.50188"
        y2="6.19824"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint100_linear_253_19555"
        x1="16.2086"
        x2="16.2092"
        y1="6.5626"
        y2="5.74512"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint101_linear_253_19555"
        x1="16.2568"
        x2="16.2577"
        y1="6.62235"
        y2="5.29102"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint102_linear_253_19555"
        x1="16.3064"
        x2="16.3076"
        y1="6.68348"
        y2="4.83497"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint103_linear_253_19555"
        x1="16.3559"
        x2="16.3574"
        y1="6.732"
        y2="4.46973"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint104_linear_253_19555"
        x1="16.4124"
        x2="16.4137"
        y1="6.732"
        y2="4.46973"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint105_linear_253_19555"
        x1="16.5115"
        x2="16.5128"
        y1="6.732"
        y2="4.46973"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint106_linear_253_19555"
        x1="16.6102"
        x2="16.6114"
        y1="6.732"
        y2="4.46973"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint107_linear_253_19555"
        x1="16.7078"
        x2="16.7091"
        y1="6.732"
        y2="4.46973"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint108_linear_253_19555"
        x1="16.8069"
        x2="16.8082"
        y1="6.732"
        y2="4.46973"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint109_linear_253_19555"
        x1="16.906"
        x2="16.9073"
        y1="6.732"
        y2="4.46973"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint110_linear_253_19555"
        x1="17.0037"
        x2="17.005"
        y1="6.732"
        y2="4.46973"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint111_linear_253_19555"
        x1="17.1043"
        x2="17.1056"
        y1="6.732"
        y2="4.46973"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint112_linear_253_19555"
        x1="17.2034"
        x2="17.2047"
        y1="6.732"
        y2="4.46973"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint113_linear_253_19555"
        x1="17.3011"
        x2="17.3023"
        y1="6.732"
        y2="4.46973"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint114_linear_253_19555"
        x1="17.3997"
        x2="17.4009"
        y1="6.732"
        y2="4.46973"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint115_linear_253_19555"
        x1="17.4993"
        x2="17.5006"
        y1="6.732"
        y2="4.46973"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint116_linear_253_19555"
        x1="17.5965"
        x2="17.5977"
        y1="6.732"
        y2="4.46973"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint117_linear_253_19555"
        x1="17.6971"
        x2="17.6983"
        y1="6.732"
        y2="4.46973"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint118_linear_253_19555"
        x1="17.7889"
        x2="17.7902"
        y1="6.732"
        y2="4.46973"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint119_linear_253_19555"
        x1="17.8384"
        x2="17.8399"
        y1="6.67194"
        y2="4.46973"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint120_linear_253_19555"
        x1="17.888"
        x2="17.8891"
        y1="6.15475"
        y2="4.46973"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint121_linear_253_19555"
        x1="17.9375"
        x2="17.9383"
        y1="5.6409"
        y2="4.46973"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint122_linear_253_19555"
        x1="17.9865"
        x2="17.987"
        y1="5.12705"
        y2="4.46973"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint123_linear_253_19555"
        x1="18.0357"
        x2="18.0358"
        y1="4.60987"
        y2="4.46973"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint124_linear_253_19555"
        x1="18.4775"
        x2="18.4776"
        y1="8.03077"
        y2="7.85059"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint125_linear_253_19555"
        x1="18.5275"
        x2="18.528"
        y1="8.09149"
        y2="7.39746"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint126_linear_253_19555"
        x1="18.5757"
        x2="18.5765"
        y1="8.15165"
        y2="6.94043"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint127_linear_253_19555"
        x1="18.6252"
        x2="18.6264"
        y1="8.21237"
        y2="6.48731"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint128_linear_253_19555"
        x1="18.6748"
        x2="18.6763"
        y1="8.27253"
        y2="6.03028"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint129_linear_253_19555"
        x1="18.723"
        x2="18.7242"
        y1="8.27456"
        y2="6.01563"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint130_linear_253_19555"
        x1="18.8201"
        x2="18.8214"
        y1="8.27456"
        y2="6.01563"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint131_linear_253_19555"
        x1="18.9173"
        x2="18.9185"
        y1="8.27456"
        y2="6.01563"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint132_linear_253_19555"
        x1="19.0169"
        x2="19.0181"
        y1="8.27456"
        y2="6.01563"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint133_linear_253_19555"
        x1="19.116"
        x2="19.1173"
        y1="8.27456"
        y2="6.01563"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint134_linear_253_19555"
        x1="19.2132"
        x2="19.2144"
        y1="8.27456"
        y2="6.01563"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint135_linear_253_19555"
        x1="19.3123"
        x2="19.3136"
        y1="8.27456"
        y2="6.01563"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint136_linear_253_19555"
        x1="19.4114"
        x2="19.4127"
        y1="8.27456"
        y2="6.01563"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint137_linear_253_19555"
        x1="19.5091"
        x2="19.5103"
        y1="8.27456"
        y2="6.01563"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint138_linear_253_19555"
        x1="19.6082"
        x2="19.6095"
        y1="8.27456"
        y2="6.01563"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint139_linear_253_19555"
        x1="19.7068"
        x2="19.7081"
        y1="8.27456"
        y2="6.01563"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint140_linear_253_19555"
        x1="19.8064"
        x2="19.8077"
        y1="8.27456"
        y2="6.01563"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint141_linear_253_19555"
        x1="19.907"
        x2="19.9083"
        y1="8.27456"
        y2="6.01563"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint142_linear_253_19555"
        x1="20.0042"
        x2="20.0054"
        y1="8.27456"
        y2="6.01563"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint143_linear_253_19555"
        x1="20.1038"
        x2="20.1051"
        y1="8.27456"
        y2="6.01563"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint144_linear_253_19555"
        x1="20.1927"
        x2="20.194"
        y1="8.27456"
        y2="6.01563"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint145_linear_253_19555"
        x1="20.2403"
        x2="20.2418"
        y1="8.16445"
        y2="6.01563"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint146_linear_253_19555"
        x1="20.2913"
        x2="20.2924"
        y1="7.6506"
        y2="6.01563"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint147_linear_253_19555"
        x1="20.3389"
        x2="20.3396"
        y1="7.13675"
        y2="6.01563"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint148_linear_253_19555"
        x1="20.3904"
        x2="20.3908"
        y1="6.61956"
        y2="6.01563"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint149_linear_253_19555"
        x1="20.4397"
        x2="20.4397"
        y1="6.10572"
        y2="6.01563"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint150_linear_253_19555"
        x1="12.7755"
        x2="12.7809"
        y1="13.8949"
        y2="5.85354"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint151_linear_253_19555"
        x1="12.8251"
        x2="12.8309"
        y1="13.9561"
        y2="5.39749"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint152_linear_253_19555"
        x1="12.8732"
        x2="12.8794"
        y1="14.0158"
        y2="4.94339"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint153_linear_253_19555"
        x1="12.9229"
        x2="12.9294"
        y1="14.0769"
        y2="4.48734"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint154_linear_253_19555"
        x1="12.9725"
        x2="12.9793"
        y1="14.1367"
        y2="4.03324"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint155_linear_253_19555"
        x1="13.0206"
        x2="13.0278"
        y1="14.1974"
        y2="3.58011"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint156_linear_253_19555"
        x1="13.0702"
        x2="13.0778"
        y1="14.2576"
        y2="3.12308"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint157_linear_253_19555"
        x1="13.1199"
        x2="13.1274"
        y1="14.2904"
        y2="2.87894"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint158_linear_253_19555"
        x1="13.1906"
        x2="13.198"
        y1="14.2932"
        y2="2.85844"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint159_linear_253_19555"
        x1="13.2877"
        x2="13.2952"
        y1="14.2961"
        y2="2.83793"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint160_linear_253_19555"
        x1="13.3829"
        x2="13.3904"
        y1="14.2989"
        y2="2.81742"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint161_linear_253_19555"
        x1="13.4816"
        x2="13.489"
        y1="14.3008"
        y2="2.79594"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint162_linear_253_19555"
        x1="13.5768"
        x2="13.5843"
        y1="14.3036"
        y2="2.77543"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint163_linear_253_19555"
        x1="13.6705"
        x2="13.678"
        y1="14.3065"
        y2="2.75492"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint164_linear_253_19555"
        x1="13.7691"
        x2="13.7767"
        y1="14.3093"
        y2="2.73441"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint165_linear_253_19555"
        x1="13.8663"
        x2="13.8738"
        y1="14.3122"
        y2="2.7139"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint166_linear_253_19555"
        x1="13.9615"
        x2="13.9691"
        y1="14.315"
        y2="2.6934"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint167_linear_253_19555"
        x1="14.0567"
        x2="14.0643"
        y1="14.3179"
        y2="2.67289"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint168_linear_253_19555"
        x1="14.1524"
        x2="14.16"
        y1="14.3207"
        y2="2.65238"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint169_linear_253_19555"
        x1="14.251"
        x2="14.2586"
        y1="14.3236"
        y2="2.63187"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint170_linear_253_19555"
        x1="14.3482"
        x2="14.3558"
        y1="14.3255"
        y2="2.61039"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint171_linear_253_19555"
        x1="14.4434"
        x2="14.451"
        y1="14.3283"
        y2="2.58988"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint172_linear_253_19555"
        x1="14.542"
        x2="14.5497"
        y1="14.3312"
        y2="2.56937"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint173_linear_253_19555"
        x1="14.6358"
        x2="14.6434"
        y1="14.334"
        y2="2.54887"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint174_linear_253_19555"
        x1="14.7329"
        x2="14.7406"
        y1="14.3369"
        y2="2.52836"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint175_linear_253_19555"
        x1="14.8296"
        x2="14.8373"
        y1="14.3397"
        y2="2.50785"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint176_linear_253_19555"
        x1="14.9267"
        x2="14.9345"
        y1="14.3426"
        y2="2.48734"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint177_linear_253_19555"
        x1="15.022"
        x2="15.0297"
        y1="14.3454"
        y2="2.46684"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint178_linear_253_19555"
        x1="15.1211"
        x2="15.1288"
        y1="14.3482"
        y2="2.44633"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint179_linear_253_19555"
        x1="15.2148"
        x2="15.2226"
        y1="14.3501"
        y2="2.42484"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint180_linear_253_19555"
        x1="15.3115"
        x2="15.3193"
        y1="14.353"
        y2="2.40434"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint181_linear_253_19555"
        x1="15.4086"
        x2="15.4164"
        y1="14.3558"
        y2="2.38383"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint182_linear_253_19555"
        x1="15.5038"
        x2="15.5117"
        y1="14.3587"
        y2="2.36332"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint183_linear_253_19555"
        x1="15.6025"
        x2="15.6103"
        y1="14.3615"
        y2="2.34281"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint184_linear_253_19555"
        x1="15.6977"
        x2="15.7055"
        y1="14.3644"
        y2="2.3223"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint185_linear_253_19555"
        x1="15.7934"
        x2="15.8012"
        y1="14.3672"
        y2="2.3018"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint186_linear_253_19555"
        x1="15.89"
        x2="15.8979"
        y1="14.3701"
        y2="2.28129"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint187_linear_253_19555"
        x1="15.9857"
        x2="15.9936"
        y1="14.3719"
        y2="2.2598"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint188_linear_253_19555"
        x1="16.0844"
        x2="16.0923"
        y1="14.3748"
        y2="2.2393"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint189_linear_253_19555"
        x1="16.1796"
        x2="16.1875"
        y1="14.3776"
        y2="2.21879"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint190_linear_253_19555"
        x1="16.2753"
        x2="16.2832"
        y1="14.3805"
        y2="2.19828"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint191_linear_253_19555"
        x1="16.3719"
        x2="16.3799"
        y1="14.3833"
        y2="2.17777"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint192_linear_253_19555"
        x1="16.4691"
        x2="16.4771"
        y1="14.3862"
        y2="2.15727"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint193_linear_253_19555"
        x1="16.5663"
        x2="16.5742"
        y1="14.389"
        y2="2.13676"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint194_linear_253_19555"
        x1="16.6615"
        x2="16.6695"
        y1="14.3919"
        y2="2.11625"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint195_linear_253_19555"
        x1="16.7581"
        x2="16.7661"
        y1="14.3947"
        y2="2.09574"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint196_linear_253_19555"
        x1="16.8558"
        x2="16.8638"
        y1="14.3966"
        y2="2.07426"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint197_linear_253_19555"
        x1="16.9525"
        x2="16.9605"
        y1="14.3994"
        y2="2.05375"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint198_linear_253_19555"
        x1="17.0482"
        x2="17.0562"
        y1="14.4023"
        y2="2.03324"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint199_linear_253_19555"
        x1="17.1434"
        x2="17.1514"
        y1="14.4051"
        y2="2.01274"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint200_linear_253_19555"
        x1="17.24"
        x2="17.2481"
        y1="14.408"
        y2="1.99223"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint201_linear_253_19555"
        x1="17.3357"
        x2="17.3438"
        y1="14.4092"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint202_linear_253_19555"
        x1="17.4329"
        x2="17.441"
        y1="14.4092"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint203_linear_253_19555"
        x1="17.5291"
        x2="17.5372"
        y1="14.3925"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint204_linear_253_19555"
        x1="17.6253"
        x2="17.6334"
        y1="14.3692"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint205_linear_253_19555"
        x1="17.7215"
        x2="17.7296"
        y1="14.3458"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint206_linear_253_19555"
        x1="17.8192"
        x2="17.8272"
        y1="14.3225"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint207_linear_253_19555"
        x1="17.9134"
        x2="17.9214"
        y1="14.2991"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint208_linear_253_19555"
        x1="18.0096"
        x2="18.0176"
        y1="14.2757"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint209_linear_253_19555"
        x1="18.1087"
        x2="18.1167"
        y1="14.2524"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint210_linear_253_19555"
        x1="18.2035"
        x2="18.2114"
        y1="14.229"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint211_linear_253_19555"
        x1="18.3011"
        x2="18.3091"
        y1="14.2057"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint212_linear_253_19555"
        x1="18.3954"
        x2="18.4033"
        y1="14.1823"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint213_linear_253_19555"
        x1="18.4935"
        x2="18.5015"
        y1="14.159"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint214_linear_253_19555"
        x1="18.5897"
        x2="18.5977"
        y1="14.1356"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint215_linear_253_19555"
        x1="18.684"
        x2="18.6919"
        y1="14.1123"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint216_linear_253_19555"
        x1="18.7831"
        x2="18.791"
        y1="14.0889"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint217_linear_253_19555"
        x1="18.8798"
        x2="18.8877"
        y1="14.0655"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint218_linear_253_19555"
        x1="18.977"
        x2="18.9848"
        y1="14.0422"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint219_linear_253_19555"
        x1="19.0732"
        x2="19.081"
        y1="14.0188"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint220_linear_253_19555"
        x1="19.1694"
        x2="19.1772"
        y1="13.9955"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint221_linear_253_19555"
        x1="19.2656"
        x2="19.2734"
        y1="13.9721"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint222_linear_253_19555"
        x1="19.3632"
        x2="19.371"
        y1="13.9488"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint223_linear_253_19555"
        x1="19.4575"
        x2="19.4653"
        y1="13.9254"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint224_linear_253_19555"
        x1="19.5537"
        x2="19.5614"
        y1="13.902"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint225_linear_253_19555"
        x1="19.6518"
        x2="19.6596"
        y1="13.8787"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint226_linear_253_19555"
        x1="19.7461"
        x2="19.7538"
        y1="13.8553"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint227_linear_253_19555"
        x1="19.8437"
        x2="19.8515"
        y1="13.832"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint228_linear_253_19555"
        x1="19.9419"
        x2="19.9496"
        y1="13.8086"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint229_linear_253_19555"
        x1="20.0376"
        x2="20.0453"
        y1="13.7853"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint230_linear_253_19555"
        x1="20.1338"
        x2="20.1415"
        y1="13.7619"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint231_linear_253_19555"
        x1="20.2281"
        x2="20.2357"
        y1="13.7385"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint232_linear_253_19555"
        x1="20.3257"
        x2="20.3334"
        y1="13.7152"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint233_linear_253_19555"
        x1="20.4219"
        x2="20.4295"
        y1="13.6918"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint234_linear_253_19555"
        x1="20.5181"
        x2="20.5257"
        y1="13.6685"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint235_linear_253_19555"
        x1="20.6143"
        x2="20.6219"
        y1="13.6451"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint236_linear_253_19555"
        x1="20.712"
        x2="20.7196"
        y1="13.6218"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint237_linear_253_19555"
        x1="20.8077"
        x2="20.8152"
        y1="13.5984"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint238_linear_253_19555"
        x1="20.9039"
        x2="20.9114"
        y1="13.575"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint239_linear_253_19555"
        x1="21.0001"
        x2="21.0076"
        y1="13.5517"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint240_linear_253_19555"
        x1="21.0963"
        x2="21.1038"
        y1="13.5283"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint241_linear_253_19555"
        x1="21.194"
        x2="21.2015"
        y1="13.505"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint242_linear_253_19555"
        x1="21.2887"
        x2="21.2962"
        y1="13.4816"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint243_linear_253_19555"
        x1="21.3864"
        x2="21.3938"
        y1="13.4583"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint244_linear_253_19555"
        x1="21.484"
        x2="21.4915"
        y1="13.4349"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint245_linear_253_19555"
        x1="21.5768"
        x2="21.5842"
        y1="13.4115"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint246_linear_253_19555"
        x1="21.6779"
        x2="21.6853"
        y1="13.3882"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint247_linear_253_19555"
        x1="21.7741"
        x2="21.7815"
        y1="13.3648"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint248_linear_253_19555"
        x1="21.8362"
        x2="21.8438"
        y1="13.3415"
        y2="1.98344"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint249_linear_253_19555"
        x1="21.8857"
        x2="21.8932"
        y1="12.9711"
        y2="1.98343"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint250_linear_253_19555"
        x1="21.9352"
        x2="21.9423"
        y1="12.4573"
        y2="1.98343"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint251_linear_253_19555"
        x1="21.9847"
        x2="21.9915"
        y1="11.9434"
        y2="1.98343"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint252_linear_253_19555"
        x1="22.0342"
        x2="22.0406"
        y1="11.4262"
        y2="1.98343"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint253_linear_253_19555"
        x1="22.0832"
        x2="22.0893"
        y1="10.9124"
        y2="1.98343"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint254_linear_253_19555"
        x1="22.1327"
        x2="22.1384"
        y1="10.3952"
        y2="1.98343"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint255_linear_253_19555"
        x1="22.1842"
        x2="22.1896"
        y1="9.88133"
        y2="1.98342"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint256_linear_253_19555"
        x1="18.7728"
        x2="19.4527"
        y1="7.89402"
        y2="7.0573"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint257_linear_253_19555"
        x1="18.7824"
        x2="19.5218"
        y1="7.90157"
        y2="6.9873"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint258_linear_253_19555"
        x1="18.7909"
        x2="19.5932"
        y1="7.90907"
        y2="6.92377"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint259_linear_253_19555"
        x1="18.8005"
        x2="19.6623"
        y1="7.91663"
        y2="6.85376"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint260_linear_253_19555"
        x1="18.8101"
        x2="19.7333"
        y1="7.92413"
        y2="6.78331"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint261_linear_253_19555"
        x1="18.8186"
        x2="19.8047"
        y1="7.93163"
        y2="6.71978"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint262_linear_253_19555"
        x1="18.8282"
        x2="19.8739"
        y1="7.93918"
        y2="6.64977"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint263_linear_253_19555"
        x1="18.8378"
        x2="19.8691"
        y1="7.93918"
        y2="6.59016"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint264_linear_253_19555"
        x1="18.8607"
        x2="19.8937"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint265_linear_253_19555"
        x1="18.8846"
        x2="19.9176"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint266_linear_253_19555"
        x1="18.9066"
        x2="19.9396"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint267_linear_253_19555"
        x1="18.929"
        x2="19.962"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint268_linear_253_19555"
        x1="18.9521"
        x2="19.9834"
        y1="7.93918"
        y2="6.59016"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint269_linear_253_19555"
        x1="18.9749"
        x2="20.0079"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint270_linear_253_19555"
        x1="18.9988"
        x2="20.0319"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint271_linear_253_19555"
        x1="19.0224"
        x2="20.0537"
        y1="7.93918"
        y2="6.59016"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint272_linear_253_19555"
        x1="19.0452"
        x2="20.0783"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint273_linear_253_19555"
        x1="19.0672"
        x2="20.1002"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint274_linear_253_19555"
        x1="19.0911"
        x2="20.1241"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint275_linear_253_19555"
        x1="19.1136"
        x2="20.1466"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint276_linear_253_19555"
        x1="19.1366"
        x2="20.1679"
        y1="7.93918"
        y2="6.59016"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint277_linear_253_19555"
        x1="19.1595"
        x2="20.1925"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint278_linear_253_19555"
        x1="19.1834"
        x2="20.2164"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint279_linear_253_19555"
        x1="19.205"
        x2="20.2363"
        y1="7.93918"
        y2="6.59016"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint280_linear_253_19555"
        x1="19.2298"
        x2="20.2628"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint281_linear_253_19555"
        x1="19.2514"
        x2="20.2827"
        y1="7.93918"
        y2="6.59016"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint282_linear_253_19555"
        x1="19.2742"
        x2="20.3073"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint283_linear_253_19555"
        x1="19.2973"
        x2="20.3286"
        y1="7.93918"
        y2="6.59016"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint284_linear_253_19555"
        x1="19.3201"
        x2="20.3532"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint285_linear_253_19555"
        x1="19.3417"
        x2="20.373"
        y1="7.93918"
        y2="6.59016"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint286_linear_253_19555"
        x1="19.3665"
        x2="20.3995"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint287_linear_253_19555"
        x1="19.3885"
        x2="20.4215"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint288_linear_253_19555"
        x1="19.409"
        x2="20.442"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint289_linear_253_19555"
        x1="19.4349"
        x2="20.4679"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint290_linear_253_19555"
        x1="19.4569"
        x2="20.4899"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint291_linear_253_19555"
        x1="19.4793"
        x2="20.5123"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint292_linear_253_19555"
        x1="19.5013"
        x2="20.5343"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint293_linear_253_19555"
        x1="19.5252"
        x2="20.5582"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint294_linear_253_19555"
        x1="19.5457"
        x2="20.5787"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint295_linear_253_19555"
        x1="19.5716"
        x2="20.6046"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint296_linear_253_19555"
        x1="19.5921"
        x2="20.6251"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint297_linear_253_19555"
        x1="19.616"
        x2="20.6491"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint298_linear_253_19555"
        x1="19.6391"
        x2="20.6704"
        y1="7.93918"
        y2="6.59016"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint299_linear_253_19555"
        x1="19.6619"
        x2="20.6949"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint300_linear_253_19555"
        x1="19.6835"
        x2="20.7148"
        y1="7.93918"
        y2="6.59016"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint301_linear_253_19555"
        x1="19.7083"
        x2="20.7413"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint302_linear_253_19555"
        x1="19.7299"
        x2="20.7612"
        y1="7.93918"
        y2="6.59016"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint303_linear_253_19555"
        x1="19.7528"
        x2="20.7858"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint304_linear_253_19555"
        x1="19.7767"
        x2="20.8097"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint305_linear_253_19555"
        x1="19.7987"
        x2="20.8317"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint306_linear_253_19555"
        x1="19.8211"
        x2="20.8541"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint307_linear_253_19555"
        x1="19.8431"
        x2="20.8761"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint308_linear_253_19555"
        x1="19.867"
        x2="20.9"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint309_linear_253_19555"
        x1="19.8875"
        x2="20.9205"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint310_linear_253_19555"
        x1="19.9134"
        x2="20.9464"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint311_linear_253_19555"
        x1="19.9334"
        x2="20.9664"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint312_linear_253_19555"
        x1="19.9578"
        x2="20.9908"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint313_linear_253_19555"
        x1="19.9798"
        x2="21.0128"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint314_linear_253_19555"
        x1="20.0037"
        x2="21.0367"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint315_linear_253_19555"
        x1="20.0242"
        x2="21.0573"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint316_linear_253_19555"
        x1="20.0501"
        x2="21.0831"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint317_linear_253_19555"
        x1="20.0712"
        x2="21.1025"
        y1="7.93918"
        y2="6.59016"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint318_linear_253_19555"
        x1="20.0946"
        x2="21.1276"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint319_linear_253_19555"
        x1="20.1176"
        x2="21.1489"
        y1="7.93918"
        y2="6.59016"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint320_linear_253_19555"
        x1="20.1405"
        x2="21.1735"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint321_linear_253_19555"
        x1="20.162"
        x2="21.1933"
        y1="7.93918"
        y2="6.59016"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint322_linear_253_19555"
        x1="20.1868"
        x2="21.2199"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint323_linear_253_19555"
        x1="20.2088"
        x2="21.2418"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint324_linear_253_19555"
        x1="20.2313"
        x2="21.2643"
        y1="7.93918"
        y2="6.59653"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint325_linear_253_19555"
        x1="20.2456"
        x2="21.289"
        y1="7.93344"
        y2="6.65173"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint326_linear_253_19555"
        x1="20.2571"
        x2="21.2376"
        y1="7.81852"
        y2="6.60784"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint327_linear_253_19555"
        x1="20.2719"
        x2="21.1929"
        y1="7.70647"
        y2="6.57335"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint328_linear_253_19555"
        x1="20.2854"
        x2="21.1453"
        y1="7.59442"
        y2="6.53194"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint329_linear_253_19555"
        x1="20.2997"
        x2="21.1001"
        y1="7.48237"
        y2="6.49746"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint330_linear_253_19555"
        x1="20.3117"
        x2="21.0511"
        y1="7.37032"
        y2="6.45605"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint331_linear_253_19555"
        x1="20.3279"
        x2="21.0078"
        y1="7.25828"
        y2="6.42156"
      >
        <stop offset="0.0795732" stopColor="#FF6D4E" />
        <stop offset="0.772297" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint332_linear_253_19555"
        x1="16.1444"
        x2="16.1444"
        y1="6.16056"
        y2="5.07693"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint333_linear_253_19555"
        x1="16.156"
        x2="16.156"
        y1="6.16062"
        y2="4.9548"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint334_linear_253_19555"
        x1="16.1676"
        x2="16.1676"
        y1="6.16065"
        y2="4.83586"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint335_linear_253_19555"
        x1="16.1807"
        x2="16.1807"
        y1="6.16071"
        y2="4.71373"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint336_linear_253_19555"
        x1="16.1923"
        x2="16.1923"
        y1="6.16077"
        y2="4.5916"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint337_linear_253_19555"
        x1="16.2039"
        x2="16.2039"
        y1="6.16083"
        y2="4.46947"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint338_linear_253_19555"
        x1="16.2155"
        x2="16.2155"
        y1="6.16087"
        y2="4.35053"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint339_linear_253_19555"
        x1="16.2271"
        x2="16.2271"
        y1="6.16093"
        y2="4.2284"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint340_linear_253_19555"
        x1="16.2402"
        x2="16.2402"
        y1="6.16099"
        y2="4.10627"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint341_linear_253_19555"
        x1="16.2518"
        x2="16.2518"
        y1="6.16105"
        y2="3.98415"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint342_linear_253_19555"
        x1="16.2634"
        x2="16.2634"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint343_linear_253_19555"
        x1="16.2853"
        x2="16.2853"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint344_linear_253_19555"
        x1="16.3107"
        x2="16.3107"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint345_linear_253_19555"
        x1="16.3346"
        x2="16.3346"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint346_linear_253_19555"
        x1="16.3571"
        x2="16.3571"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint347_linear_253_19555"
        x1="16.381"
        x2="16.381"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint348_linear_253_19555"
        x1="16.405"
        x2="16.405"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint349_linear_253_19555"
        x1="16.4303"
        x2="16.4303"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint350_linear_253_19555"
        x1="16.4543"
        x2="16.4543"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint351_linear_253_19555"
        x1="16.4767"
        x2="16.4767"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint352_linear_253_19555"
        x1="16.4987"
        x2="16.4987"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint353_linear_253_19555"
        x1="16.526"
        x2="16.526"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint354_linear_253_19555"
        x1="16.5485"
        x2="16.5485"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint355_linear_253_19555"
        x1="16.5705"
        x2="16.5705"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint356_linear_253_19555"
        x1="16.5964"
        x2="16.5964"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint357_linear_253_19555"
        x1="16.6188"
        x2="16.6188"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint358_linear_253_19555"
        x1="16.6457"
        x2="16.6457"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint359_linear_253_19555"
        x1="16.6681"
        x2="16.6681"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint360_linear_253_19555"
        x1="16.6901"
        x2="16.6901"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint361_linear_253_19555"
        x1="16.718"
        x2="16.718"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint362_linear_253_19555"
        x1="16.7414"
        x2="16.7414"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint363_linear_253_19555"
        x1="16.7638"
        x2="16.7638"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint364_linear_253_19555"
        x1="16.7878"
        x2="16.7878"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint365_linear_253_19555"
        x1="16.8112"
        x2="16.8112"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint366_linear_253_19555"
        x1="16.8342"
        x2="16.8342"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint367_linear_253_19555"
        x1="16.8595"
        x2="16.8595"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint368_linear_253_19555"
        x1="16.8835"
        x2="16.8835"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint369_linear_253_19555"
        x1="16.9054"
        x2="16.9054"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint370_linear_253_19555"
        x1="16.9313"
        x2="16.9313"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint371_linear_253_19555"
        x1="16.9552"
        x2="16.9552"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint372_linear_253_19555"
        x1="16.9772"
        x2="16.9772"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint373_linear_253_19555"
        x1="17.0031"
        x2="17.0031"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint374_linear_253_19555"
        x1="17.0251"
        x2="17.0251"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint375_linear_253_19555"
        x1="17.0509"
        x2="17.0509"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint376_linear_253_19555"
        x1="17.0749"
        x2="17.0749"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint377_linear_253_19555"
        x1="17.0973"
        x2="17.0973"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint378_linear_253_19555"
        x1="17.1208"
        x2="17.1208"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint379_linear_253_19555"
        x1="17.1452"
        x2="17.1452"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint380_linear_253_19555"
        x1="17.1706"
        x2="17.1706"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint381_linear_253_19555"
        x1="17.1925"
        x2="17.1925"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint382_linear_253_19555"
        x1="17.2165"
        x2="17.2165"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint383_linear_253_19555"
        x1="17.2389"
        x2="17.2389"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint384_linear_253_19555"
        x1="17.2677"
        x2="17.2677"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint385_linear_253_19555"
        x1="17.2897"
        x2="17.2897"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint386_linear_253_19555"
        x1="17.3122"
        x2="17.3122"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint387_linear_253_19555"
        x1="17.3361"
        x2="17.3361"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint388_linear_253_19555"
        x1="17.36"
        x2="17.36"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint389_linear_253_19555"
        x1="17.384"
        x2="17.384"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint390_linear_253_19555"
        x1="17.4098"
        x2="17.4098"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint391_linear_253_19555"
        x1="17.4318"
        x2="17.4318"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint392_linear_253_19555"
        x1="17.4543"
        x2="17.4543"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint393_linear_253_19555"
        x1="17.4816"
        x2="17.4816"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint394_linear_253_19555"
        x1="17.5036"
        x2="17.5036"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint395_linear_253_19555"
        x1="17.526"
        x2="17.526"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint396_linear_253_19555"
        x1="17.55"
        x2="17.55"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint397_linear_253_19555"
        x1="17.5759"
        x2="17.5759"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint398_linear_253_19555"
        x1="17.5993"
        x2="17.5993"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint399_linear_253_19555"
        x1="17.6232"
        x2="17.6232"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint400_linear_253_19555"
        x1="17.6476"
        x2="17.6476"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint401_linear_253_19555"
        x1="17.6696"
        x2="17.6696"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint402_linear_253_19555"
        x1="17.695"
        x2="17.695"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint403_linear_253_19555"
        x1="17.7151"
        x2="17.7151"
        y1="6.16107"
        y2="3.98096"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint404_linear_253_19555"
        x1="17.7254"
        x2="17.7254"
        y1="6.12559"
        y2="3.98406"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint405_linear_253_19555"
        x1="17.7377"
        x2="17.7377"
        y1="6.01618"
        y2="3.99363"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint406_linear_253_19555"
        x1="17.7501"
        x2="17.7501"
        y1="5.90382"
        y2="4.00345"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint407_linear_253_19555"
        x1="17.7609"
        x2="17.7609"
        y1="5.79145"
        y2="4.01327"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint408_linear_253_19555"
        x1="17.7747"
        x2="17.7747"
        y1="5.67909"
        y2="4.0231"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint409_linear_253_19555"
        x1="17.7856"
        x2="17.7856"
        y1="5.56968"
        y2="4.03267"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint410_linear_253_19555"
        x1="17.7994"
        x2="17.7994"
        y1="5.45732"
        y2="4.04249"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint411_linear_253_19555"
        x1="17.3459"
        x2="17.3459"
        y1="10.3567"
        y2="9.17576"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint412_linear_253_19555"
        x1="17.3566"
        x2="17.3566"
        y1="10.3569"
        y2="9.08201"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint413_linear_253_19555"
        x1="17.3659"
        x2="17.3659"
        y1="10.3571"
        y2="8.98826"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint414_linear_253_19555"
        x1="17.3766"
        x2="17.3766"
        y1="10.3565"
        y2="8.89646"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint415_linear_253_19555"
        x1="17.3859"
        x2="17.3859"
        y1="10.3567"
        y2="8.80271"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint416_linear_253_19555"
        x1="17.3966"
        x2="17.3966"
        y1="10.3572"
        y2="8.71189"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint417_linear_253_19555"
        x1="17.4073"
        x2="17.4073"
        y1="10.3564"
        y2="8.61716"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint418_linear_253_19555"
        x1="17.4166"
        x2="17.4166"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint419_linear_253_19555"
        x1="17.4275"
        x2="17.4275"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint420_linear_253_19555"
        x1="17.4486"
        x2="17.4486"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint421_linear_253_19555"
        x1="17.4685"
        x2="17.4685"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint422_linear_253_19555"
        x1="17.4896"
        x2="17.4896"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint423_linear_253_19555"
        x1="17.5101"
        x2="17.5101"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint424_linear_253_19555"
        x1="17.5287"
        x2="17.5287"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint425_linear_253_19555"
        x1="17.5458"
        x2="17.5458"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint426_linear_253_19555"
        x1="17.556"
        x2="17.556"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint427_linear_253_19555"
        x1="17.5663"
        x2="17.5663"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint428_linear_253_19555"
        x1="17.5765"
        x2="17.5765"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint429_linear_253_19555"
        x1="17.5868"
        x2="17.5868"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint430_linear_253_19555"
        x1="17.5985"
        x2="17.5985"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint431_linear_253_19555"
        x1="17.6088"
        x2="17.6088"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint432_linear_253_19555"
        x1="17.619"
        x2="17.619"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint433_linear_253_19555"
        x1="17.6293"
        x2="17.6293"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint434_linear_253_19555"
        x1="17.6395"
        x2="17.6395"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint435_linear_253_19555"
        x1="17.6517"
        x2="17.6517"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint436_linear_253_19555"
        x1="17.6635"
        x2="17.6635"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint437_linear_253_19555"
        x1="17.6737"
        x2="17.6737"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint438_linear_253_19555"
        x1="17.684"
        x2="17.684"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint439_linear_253_19555"
        x1="17.6942"
        x2="17.6942"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint440_linear_253_19555"
        x1="17.7045"
        x2="17.7045"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint441_linear_253_19555"
        x1="17.7147"
        x2="17.7147"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint442_linear_253_19555"
        x1="17.725"
        x2="17.725"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint443_linear_253_19555"
        x1="17.7372"
        x2="17.7372"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint444_linear_253_19555"
        x1="17.7489"
        x2="17.7489"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint445_linear_253_19555"
        x1="17.7592"
        x2="17.7592"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint446_linear_253_19555"
        x1="17.7699"
        x2="17.7699"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint447_linear_253_19555"
        x1="17.7776"
        x2="17.7776"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint448_linear_253_19555"
        x1="17.7878"
        x2="17.7878"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint449_linear_253_19555"
        x1="17.8015"
        x2="17.8015"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint450_linear_253_19555"
        x1="17.8118"
        x2="17.8118"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint451_linear_253_19555"
        x1="17.822"
        x2="17.822"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint452_linear_253_19555"
        x1="17.8323"
        x2="17.8323"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint453_linear_253_19555"
        x1="17.8425"
        x2="17.8425"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint454_linear_253_19555"
        x1="17.8528"
        x2="17.8528"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint455_linear_253_19555"
        x1="17.863"
        x2="17.863"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint456_linear_253_19555"
        x1="17.8752"
        x2="17.8752"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint457_linear_253_19555"
        x1="17.8855"
        x2="17.8855"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint458_linear_253_19555"
        x1="17.8953"
        x2="17.8953"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint459_linear_253_19555"
        x1="17.906"
        x2="17.906"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint460_linear_253_19555"
        x1="17.9177"
        x2="17.9177"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint461_linear_253_19555"
        x1="17.928"
        x2="17.928"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint462_linear_253_19555"
        x1="17.9402"
        x2="17.9402"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint463_linear_253_19555"
        x1="17.9504"
        x2="17.9504"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint464_linear_253_19555"
        x1="17.9607"
        x2="17.9607"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint465_linear_253_19555"
        x1="17.9709"
        x2="17.9709"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint466_linear_253_19555"
        x1="17.9812"
        x2="17.9812"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint467_linear_253_19555"
        x1="17.9914"
        x2="17.9914"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint468_linear_253_19555"
        x1="18.0017"
        x2="18.0017"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint469_linear_253_19555"
        x1="18.0134"
        x2="18.0134"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint470_linear_253_19555"
        x1="18.0237"
        x2="18.0237"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint471_linear_253_19555"
        x1="18.0354"
        x2="18.0354"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint472_linear_253_19555"
        x1="18.0461"
        x2="18.0461"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint473_linear_253_19555"
        x1="18.0564"
        x2="18.0564"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint474_linear_253_19555"
        x1="18.0666"
        x2="18.0666"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint475_linear_253_19555"
        x1="18.0784"
        x2="18.0784"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint476_linear_253_19555"
        x1="18.0886"
        x2="18.0886"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint477_linear_253_19555"
        x1="18.0989"
        x2="18.0989"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint478_linear_253_19555"
        x1="18.1091"
        x2="18.1091"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint479_linear_253_19555"
        x1="18.1194"
        x2="18.1194"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint480_linear_253_19555"
        x1="18.1296"
        x2="18.1296"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint481_linear_253_19555"
        x1="18.1418"
        x2="18.1418"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint482_linear_253_19555"
        x1="18.1536"
        x2="18.1536"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint483_linear_253_19555"
        x1="18.1638"
        x2="18.1638"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint484_linear_253_19555"
        x1="18.1741"
        x2="18.1741"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint485_linear_253_19555"
        x1="18.1848"
        x2="18.1848"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint486_linear_253_19555"
        x1="18.1946"
        x2="18.1946"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint487_linear_253_19555"
        x1="18.2048"
        x2="18.2048"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint488_linear_253_19555"
        x1="18.217"
        x2="18.217"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint489_linear_253_19555"
        x1="18.2273"
        x2="18.2273"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint490_linear_253_19555"
        x1="18.2375"
        x2="18.2375"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint491_linear_253_19555"
        x1="18.2493"
        x2="18.2493"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint492_linear_253_19555"
        x1="18.2595"
        x2="18.2595"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint493_linear_253_19555"
        x1="18.2698"
        x2="18.2698"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint494_linear_253_19555"
        x1="18.28"
        x2="18.28"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint495_linear_253_19555"
        x1="18.2922"
        x2="18.2922"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint496_linear_253_19555"
        x1="18.3025"
        x2="18.3025"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint497_linear_253_19555"
        x1="18.3127"
        x2="18.3127"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint498_linear_253_19555"
        x1="18.323"
        x2="18.323"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint499_linear_253_19555"
        x1="18.3332"
        x2="18.3332"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint500_linear_253_19555"
        x1="18.3435"
        x2="18.3435"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint501_linear_253_19555"
        x1="18.3572"
        x2="18.3572"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint502_linear_253_19555"
        x1="18.3674"
        x2="18.3674"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint503_linear_253_19555"
        x1="18.3772"
        x2="18.3772"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint504_linear_253_19555"
        x1="18.3879"
        x2="18.3879"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint505_linear_253_19555"
        x1="18.3982"
        x2="18.3982"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint506_linear_253_19555"
        x1="18.4084"
        x2="18.4084"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint507_linear_253_19555"
        x1="18.4187"
        x2="18.4187"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint508_linear_253_19555"
        x1="18.4304"
        x2="18.4304"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint509_linear_253_19555"
        x1="18.4407"
        x2="18.4407"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint510_linear_253_19555"
        x1="18.4509"
        x2="18.4509"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint511_linear_253_19555"
        x1="18.4631"
        x2="18.4631"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint512_linear_253_19555"
        x1="18.4734"
        x2="18.4734"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint513_linear_253_19555"
        x1="18.4836"
        x2="18.4836"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint514_linear_253_19555"
        x1="18.4954"
        x2="18.4954"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint515_linear_253_19555"
        x1="18.5056"
        x2="18.5056"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint516_linear_253_19555"
        x1="18.5159"
        x2="18.5159"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint517_linear_253_19555"
        x1="18.5261"
        x2="18.5261"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint518_linear_253_19555"
        x1="18.535"
        x2="18.535"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint519_linear_253_19555"
        x1="18.5438"
        x2="18.5438"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint520_linear_253_19555"
        x1="18.5507"
        x2="18.5507"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint521_linear_253_19555"
        x1="18.561"
        x2="18.561"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint522_linear_253_19555"
        x1="18.5712"
        x2="18.5712"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint523_linear_253_19555"
        x1="18.5795"
        x2="18.5795"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint524_linear_253_19555"
        x1="18.5863"
        x2="18.5863"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint525_linear_253_19555"
        x1="18.5951"
        x2="18.5951"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint526_linear_253_19555"
        x1="18.6053"
        x2="18.6053"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint527_linear_253_19555"
        x1="18.6122"
        x2="18.6122"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint528_linear_253_19555"
        x1="18.6205"
        x2="18.6205"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint529_linear_253_19555"
        x1="18.6293"
        x2="18.6293"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint530_linear_253_19555"
        x1="18.641"
        x2="18.641"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint531_linear_253_19555"
        x1="18.6478"
        x2="18.6478"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint532_linear_253_19555"
        x1="18.6566"
        x2="18.6566"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint533_linear_253_19555"
        x1="18.6635"
        x2="18.6635"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint534_linear_253_19555"
        x1="18.6738"
        x2="18.6738"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint535_linear_253_19555"
        x1="18.682"
        x2="18.682"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint536_linear_253_19555"
        x1="18.6908"
        x2="18.6908"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint537_linear_253_19555"
        x1="18.6991"
        x2="18.6991"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint538_linear_253_19555"
        x1="18.7079"
        x2="18.7079"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint539_linear_253_19555"
        x1="18.7181"
        x2="18.7181"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint540_linear_253_19555"
        x1="18.725"
        x2="18.725"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint541_linear_253_19555"
        x1="18.7338"
        x2="18.7338"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint542_linear_253_19555"
        x1="18.7421"
        x2="18.7421"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint543_linear_253_19555"
        x1="18.7523"
        x2="18.7523"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint544_linear_253_19555"
        x1="18.7592"
        x2="18.7592"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint545_linear_253_19555"
        x1="18.7694"
        x2="18.7694"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint546_linear_253_19555"
        x1="18.7762"
        x2="18.7762"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint547_linear_253_19555"
        x1="18.7852"
        x2="18.7852"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint548_linear_253_19555"
        x1="18.7948"
        x2="18.7948"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint549_linear_253_19555"
        x1="18.8036"
        x2="18.8036"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint550_linear_253_19555"
        x1="18.8104"
        x2="18.8104"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint551_linear_253_19555"
        x1="18.8187"
        x2="18.8187"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint552_linear_253_19555"
        x1="18.8276"
        x2="18.8276"
        y1="10.3568"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint553_linear_253_19555"
        x1="18.8324"
        x2="18.8324"
        y1="10.3461"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint554_linear_253_19555"
        x1="18.8367"
        x2="18.8367"
        y1="10.3058"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint555_linear_253_19555"
        x1="18.8415"
        x2="18.8415"
        y1="10.2656"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint556_linear_253_19555"
        x1="18.8464"
        x2="18.8464"
        y1="10.2253"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint557_linear_253_19555"
        x1="18.8493"
        x2="18.8493"
        y1="10.185"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint558_linear_253_19555"
        x1="18.8536"
        x2="18.8536"
        y1="10.1448"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint559_linear_253_19555"
        x1="18.8564"
        x2="18.8564"
        y1="10.1072"
        y2="8.53708"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint560_linear_253_19555"
        x1="18.8613"
        x2="18.8613"
        y1="10.0669"
        y2="8.53709"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint561_linear_253_19555"
        x1="18.8676"
        x2="18.8676"
        y1="10.0267"
        y2="8.53709"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint562_linear_253_19555"
        x1="18.8723"
        x2="18.8723"
        y1="9.98643"
        y2="8.53709"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint563_linear_253_19555"
        x1="18.8752"
        x2="18.8752"
        y1="9.94617"
        y2="8.53709"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint564_linear_253_19555"
        x1="18.8795"
        x2="18.8795"
        y1="9.90859"
        y2="8.53709"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint565_linear_253_19555"
        x1="18.8849"
        x2="18.8849"
        y1="9.86833"
        y2="8.53709"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint566_linear_253_19555"
        x1="18.8872"
        x2="18.8872"
        y1="9.82807"
        y2="8.53709"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint567_linear_253_19555"
        x1="18.892"
        x2="18.892"
        y1="9.78782"
        y2="8.53709"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint568_linear_253_19555"
        x1="18.8948"
        x2="18.8948"
        y1="9.74756"
        y2="8.53709"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint569_linear_253_19555"
        x1="15.2097"
        x2="15.2097"
        y1="8.72977"
        y2="7.54883"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint570_linear_253_19555"
        x1="15.2244"
        x2="15.2244"
        y1="8.72945"
        y2="7.41699"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint571_linear_253_19555"
        x1="15.2377"
        x2="15.2377"
        y1="8.72937"
        y2="7.28809"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint572_linear_253_19555"
        x1="15.2524"
        x2="15.2524"
        y1="8.73003"
        y2="7.15723"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint573_linear_253_19555"
        x1="15.2657"
        x2="15.2657"
        y1="8.72971"
        y2="7.02539"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint574_linear_253_19555"
        x1="15.2804"
        x2="15.2804"
        y1="8.72988"
        y2="6.91016"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint575_linear_253_19555"
        x1="15.2972"
        x2="15.2972"
        y1="8.72988"
        y2="6.91016"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint576_linear_253_19555"
        x1="15.3232"
        x2="15.3232"
        y1="8.72988"
        y2="6.91016"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint577_linear_253_19555"
        x1="15.3533"
        x2="15.3533"
        y1="8.72988"
        y2="6.91016"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint578_linear_253_19555"
        x1="15.3793"
        x2="15.3793"
        y1="8.72988"
        y2="6.91016"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint579_linear_253_19555"
        x1="15.4101"
        x2="15.4101"
        y1="8.72988"
        y2="6.91016"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint580_linear_253_19555"
        x1="15.436"
        x2="15.436"
        y1="8.72988"
        y2="6.91016"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint581_linear_253_19555"
        x1="15.4667"
        x2="15.4667"
        y1="8.72988"
        y2="6.91016"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint582_linear_253_19555"
        x1="15.4935"
        x2="15.4935"
        y1="8.72988"
        y2="6.91016"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint583_linear_253_19555"
        x1="15.5214"
        x2="15.5214"
        y1="8.72988"
        y2="6.91016"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint584_linear_253_19555"
        x1="15.5522"
        x2="15.5522"
        y1="8.72988"
        y2="6.91016"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint585_linear_253_19555"
        x1="15.5776"
        x2="15.5776"
        y1="8.72988"
        y2="6.91016"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint586_linear_253_19555"
        x1="15.6083"
        x2="15.6083"
        y1="8.72988"
        y2="6.91016"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint587_linear_253_19555"
        x1="15.6356"
        x2="15.6356"
        y1="8.72988"
        y2="6.91016"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint588_linear_253_19555"
        x1="15.663"
        x2="15.663"
        y1="8.72988"
        y2="6.91016"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint589_linear_253_19555"
        x1="15.6938"
        x2="15.6938"
        y1="8.72988"
        y2="6.91016"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint590_linear_253_19555"
        x1="15.7197"
        x2="15.7197"
        y1="8.72988"
        y2="6.91016"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint591_linear_253_19555"
        x1="15.7504"
        x2="15.7504"
        y1="8.72988"
        y2="6.91016"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint592_linear_253_19555"
        x1="15.7772"
        x2="15.7772"
        y1="8.72988"
        y2="6.91016"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint593_linear_253_19555"
        x1="15.8051"
        x2="15.8051"
        y1="8.72988"
        y2="6.91016"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint594_linear_253_19555"
        x1="15.8339"
        x2="15.8339"
        y1="8.72988"
        y2="6.91016"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint595_linear_253_19555"
        x1="15.8613"
        x2="15.8613"
        y1="8.72988"
        y2="6.91016"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint596_linear_253_19555"
        x1="15.892"
        x2="15.892"
        y1="8.72988"
        y2="6.91016"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint597_linear_253_19555"
        x1="15.9192"
        x2="15.9192"
        y1="8.72988"
        y2="6.91016"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint598_linear_253_19555"
        x1="15.9453"
        x2="15.9453"
        y1="8.72988"
        y2="6.91016"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint599_linear_253_19555"
        x1="15.9754"
        x2="15.9754"
        y1="8.72988"
        y2="6.91016"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint600_linear_253_19555"
        x1="16.0014"
        x2="16.0014"
        y1="8.72988"
        y2="6.91016"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint601_linear_253_19555"
        x1="16.0322"
        x2="16.0322"
        y1="8.72988"
        y2="6.91016"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint602_linear_253_19555"
        x1="16.0595"
        x2="16.0595"
        y1="8.72988"
        y2="6.91016"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint603_linear_253_19555"
        x1="16.0888"
        x2="16.0888"
        y1="8.72988"
        y2="6.91016"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint604_linear_253_19555"
        x1="16.1175"
        x2="16.1175"
        y1="8.72988"
        y2="6.91016"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint605_linear_253_19555"
        x1="16.1435"
        x2="16.1435"
        y1="8.72988"
        y2="6.91016"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint606_linear_253_19555"
        x1="16.1743"
        x2="16.1743"
        y1="8.72988"
        y2="6.91016"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint607_linear_253_19555"
        x1="16.1996"
        x2="16.1996"
        y1="8.72988"
        y2="6.91016"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint608_linear_253_19555"
        x1="16.2304"
        x2="16.2304"
        y1="8.72988"
        y2="6.91016"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint609_linear_253_19555"
        x1="16.2576"
        x2="16.2576"
        y1="8.72988"
        y2="6.91016"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint610_linear_253_19555"
        x1="16.2851"
        x2="16.2851"
        y1="8.72988"
        y2="6.91016"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint611_linear_253_19555"
        x1="16.3159"
        x2="16.3159"
        y1="8.72988"
        y2="6.91016"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint612_linear_253_19555"
        x1="16.3417"
        x2="16.3417"
        y1="8.72988"
        y2="6.91016"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint613_linear_253_19555"
        x1="16.3725"
        x2="16.3725"
        y1="8.72988"
        y2="6.91016"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint614_linear_253_19555"
        x1="16.538"
        x2="16.538"
        y1="8.72988"
        y2="6.91016"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint615_linear_253_19555"
        x1="3.75586"
        x2="3.75586"
        y1="12.4959"
        y2="10.0918"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint616_linear_253_19555"
        x1="3.78521"
        x2="3.78521"
        y1="12.4963"
        y2="9.84176"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint617_linear_253_19555"
        x1="3.81455"
        x2="3.81455"
        y1="12.4957"
        y2="9.59077"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint618_linear_253_19555"
        x1="3.8439"
        x2="3.8439"
        y1="12.496"
        y2="9.34077"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint619_linear_253_19555"
        x1="3.87325"
        x2="3.87325"
        y1="12.4964"
        y2="9.09077"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint620_linear_253_19555"
        x1="3.90259"
        x2="3.90259"
        y1="12.4958"
        y2="8.83979"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint621_linear_253_19555"
        x1="3.93194"
        x2="3.93194"
        y1="12.4962"
        y2="8.58978"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint622_linear_253_19555"
        x1="3.96129"
        x2="3.96129"
        y1="12.4955"
        y2="8.34173"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint623_linear_253_19555"
        x1="3.99064"
        x2="3.99064"
        y1="12.4958"
        y2="8.09173"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint624_linear_253_19555"
        x1="4.02161"
        x2="4.02161"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint625_linear_253_19555"
        x1="4.05632"
        x2="4.05632"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint626_linear_253_19555"
        x1="4.11443"
        x2="4.11443"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint627_linear_253_19555"
        x1="4.17579"
        x2="4.17579"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint628_linear_253_19555"
        x1="4.23243"
        x2="4.23243"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint629_linear_253_19555"
        x1="4.27928"
        x2="4.27928"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint630_linear_253_19555"
        x1="4.30825"
        x2="4.30825"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint631_linear_253_19555"
        x1="4.3408"
        x2="4.3408"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint632_linear_253_19555"
        x1="4.36929"
        x2="4.36929"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint633_linear_253_19555"
        x1="4.40232"
        x2="4.40232"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint634_linear_253_19555"
        x1="4.4313"
        x2="4.4313"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint635_linear_253_19555"
        x1="4.46548"
        x2="4.46548"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint636_linear_253_19555"
        x1="4.49429"
        x2="4.49429"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint637_linear_253_19555"
        x1="4.527"
        x2="4.527"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint638_linear_253_19555"
        x1="4.55955"
        x2="4.55955"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint639_linear_253_19555"
        x1="4.59048"
        x2="4.59048"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint640_linear_253_19555"
        x1="4.62107"
        x2="4.62107"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint641_linear_253_19555"
        x1="4.65005"
        x2="4.65005"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint642_linear_253_19555"
        x1="4.6826"
        x2="4.6826"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint643_linear_253_19555"
        x1="4.7145"
        x2="4.7145"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint644_linear_253_19555"
        x1="4.74412"
        x2="4.74412"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint645_linear_253_19555"
        x1="4.77456"
        x2="4.77456"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint646_linear_253_19555"
        x1="4.80728"
        x2="4.80728"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint647_linear_253_19555"
        x1="4.83982"
        x2="4.83982"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint648_linear_253_19555"
        x1="4.87026"
        x2="4.87026"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint649_linear_253_19555"
        x1="4.90135"
        x2="4.90135"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint650_linear_253_19555"
        x1="4.93228"
        x2="4.93228"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint651_linear_253_19555"
        x1="4.96434"
        x2="4.96434"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint652_linear_253_19555"
        x1="4.99526"
        x2="4.99526"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint653_linear_253_19555"
        x1="5.02439"
        x2="5.02439"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint654_linear_253_19555"
        x1="5.0563"
        x2="5.0563"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint655_linear_253_19555"
        x1="5.08755"
        x2="5.08755"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint656_linear_253_19555"
        x1="5.11978"
        x2="5.11978"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint657_linear_253_19555"
        x1="5.15054"
        x2="5.15054"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint658_linear_253_19555"
        x1="5.18162"
        x2="5.18162"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint659_linear_253_19555"
        x1="5.21206"
        x2="5.21206"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint660_linear_253_19555"
        x1="5.24461"
        x2="5.24461"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint661_linear_253_19555"
        x1="5.27554"
        x2="5.27554"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint662_linear_253_19555"
        x1="5.30613"
        x2="5.30613"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint663_linear_253_19555"
        x1="5.33706"
        x2="5.33706"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint664_linear_253_19555"
        x1="5.36619"
        x2="5.36619"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint665_linear_253_19555"
        x1="5.40005"
        x2="5.40005"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint666_linear_253_19555"
        x1="5.43081"
        x2="5.43081"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint667_linear_253_19555"
        x1="5.46157"
        x2="5.46157"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint668_linear_253_19555"
        x1="5.49233"
        x2="5.49233"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint669_linear_253_19555"
        x1="5.52488"
        x2="5.52488"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint670_linear_253_19555"
        x1="5.55581"
        x2="5.55581"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint671_linear_253_19555"
        x1="5.58641"
        x2="5.58641"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint672_linear_253_19555"
        x1="5.61733"
        x2="5.61733"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint673_linear_253_19555"
        x1="5.64647"
        x2="5.64647"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint674_linear_253_19555"
        x1="5.68032"
        x2="5.68032"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint675_linear_253_19555"
        x1="5.71108"
        x2="5.71108"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint676_linear_253_19555"
        x1="5.74185"
        x2="5.74185"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint677_linear_253_19555"
        x1="5.77261"
        x2="5.77261"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint678_linear_253_19555"
        x1="5.80516"
        x2="5.80516"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint679_linear_253_19555"
        x1="5.83608"
        x2="5.83608"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint680_linear_253_19555"
        x1="5.86668"
        x2="5.86668"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint681_linear_253_19555"
        x1="5.89761"
        x2="5.89761"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint682_linear_253_19555"
        x1="5.93016"
        x2="5.93016"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint683_linear_253_19555"
        x1="5.9606"
        x2="5.9606"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint684_linear_253_19555"
        x1="5.98973"
        x2="5.98973"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint685_linear_253_19555"
        x1="6.02212"
        x2="6.02212"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint686_linear_253_19555"
        x1="6.05288"
        x2="6.05288"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint687_linear_253_19555"
        x1="6.08364"
        x2="6.08364"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint688_linear_253_19555"
        x1="6.11636"
        x2="6.11636"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint689_linear_253_19555"
        x1="6.14695"
        x2="6.14695"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint690_linear_253_19555"
        x1="6.17788"
        x2="6.17788"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint691_linear_253_19555"
        x1="6.21043"
        x2="6.21043"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint692_linear_253_19555"
        x1="6.24136"
        x2="6.24136"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint693_linear_253_19555"
        x1="6.27195"
        x2="6.27195"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint694_linear_253_19555"
        x1="6.30239"
        x2="6.30239"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint695_linear_253_19555"
        x1="6.33152"
        x2="6.33152"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint696_linear_253_19555"
        x1="6.36392"
        x2="6.36392"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint697_linear_253_19555"
        x1="6.39663"
        x2="6.39663"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint698_linear_253_19555"
        x1="6.42723"
        x2="6.42723"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint699_linear_253_19555"
        x1="6.45815"
        x2="6.45815"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint700_linear_253_19555"
        x1="6.4907"
        x2="6.4907"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint701_linear_253_19555"
        x1="6.52114"
        x2="6.52114"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint702_linear_253_19555"
        x1="6.55223"
        x2="6.55223"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint703_linear_253_19555"
        x1="6.58267"
        x2="6.58267"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint704_linear_253_19555"
        x1="6.6118"
        x2="6.6118"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint705_linear_253_19555"
        x1="6.64614"
        x2="6.64614"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint706_linear_253_19555"
        x1="6.6769"
        x2="6.6769"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint707_linear_253_19555"
        x1="6.70767"
        x2="6.70767"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint708_linear_253_19555"
        x1="6.73843"
        x2="6.73843"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint709_linear_253_19555"
        x1="6.77098"
        x2="6.77098"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint710_linear_253_19555"
        x1="6.80142"
        x2="6.80142"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint711_linear_253_19555"
        x1="6.8325"
        x2="6.8325"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint712_linear_253_19555"
        x1="6.86343"
        x2="6.86343"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint713_linear_253_19555"
        x1="6.89402"
        x2="6.89402"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint714_linear_253_19555"
        x1="6.92642"
        x2="6.92642"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint715_linear_253_19555"
        x1="6.95555"
        x2="6.95555"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint716_linear_253_19555"
        x1="6.98745"
        x2="6.98745"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint717_linear_253_19555"
        x1="7.0187"
        x2="7.0187"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint718_linear_253_19555"
        x1="7.04946"
        x2="7.04946"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint719_linear_253_19555"
        x1="7.08169"
        x2="7.08169"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint720_linear_253_19555"
        x1="7.11277"
        x2="7.11277"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint721_linear_253_19555"
        x1="7.14321"
        x2="7.14321"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint722_linear_253_19555"
        x1="7.17104"
        x2="7.17104"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint723_linear_253_19555"
        x1="7.19659"
        x2="7.19659"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint724_linear_253_19555"
        x1="7.22198"
        x2="7.22198"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint725_linear_253_19555"
        x1="7.24786"
        x2="7.24786"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint726_linear_253_19555"
        x1="7.27358"
        x2="7.27358"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint727_linear_253_19555"
        x1="7.29571"
        x2="7.29571"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint728_linear_253_19555"
        x1="7.32306"
        x2="7.32306"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint729_linear_253_19555"
        x1="7.3504"
        x2="7.3504"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint730_linear_253_19555"
        x1="7.37237"
        x2="7.37237"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint731_linear_253_19555"
        x1="7.39972"
        x2="7.39972"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint732_linear_253_19555"
        x1="7.4256"
        x2="7.4256"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint733_linear_253_19555"
        x1="7.44936"
        x2="7.44936"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint734_linear_253_19555"
        x1="7.47491"
        x2="7.47491"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint735_linear_253_19555"
        x1="7.49884"
        x2="7.49884"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint736_linear_253_19555"
        x1="7.52618"
        x2="7.52618"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint737_linear_253_19555"
        x1="7.55043"
        x2="7.55043"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint738_linear_253_19555"
        x1="7.57403"
        x2="7.57403"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint739_linear_253_19555"
        x1="7.60138"
        x2="7.60138"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint740_linear_253_19555"
        x1="7.6253"
        x2="7.6253"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint741_linear_253_19555"
        x1="7.65118"
        x2="7.65118"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint742_linear_253_19555"
        x1="7.67657"
        x2="7.67657"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint743_linear_253_19555"
        x1="7.7005"
        x2="7.7005"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint744_linear_253_19555"
        x1="7.72817"
        x2="7.72817"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint745_linear_253_19555"
        x1="7.7503"
        x2="7.7503"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint746_linear_253_19555"
        x1="7.77569"
        x2="7.77569"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint747_linear_253_19555"
        x1="7.80499"
        x2="7.80499"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint748_linear_253_19555"
        x1="7.82729"
        x2="7.82729"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint749_linear_253_19555"
        x1="7.85284"
        x2="7.85284"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint750_linear_253_19555"
        x1="7.8797"
        x2="7.8797"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint751_linear_253_19555"
        x1="7.90411"
        x2="7.90411"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint752_linear_253_19555"
        x1="7.91467"
        x2="7.91467"
        y1="12.496"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint753_linear_253_19555"
        x1="7.92897"
        x2="7.92897"
        y1="12.4025"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint754_linear_253_19555"
        x1="7.94181"
        x2="7.94181"
        y1="12.2939"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint755_linear_253_19555"
        x1="7.95611"
        x2="7.95611"
        y1="12.1883"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint756_linear_253_19555"
        x1="7.96716"
        x2="7.96716"
        y1="12.0797"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint757_linear_253_19555"
        x1="7.9795"
        x2="7.9795"
        y1="11.9741"
        y2="7.88372"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint758_linear_253_19555"
        x1="7.99185"
        x2="7.99185"
        y1="11.8655"
        y2="7.88373"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint759_linear_253_19555"
        x1="8.00469"
        x2="8.00469"
        y1="11.7599"
        y2="7.88373"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint760_linear_253_19555"
        x1="8.01867"
        x2="8.01867"
        y1="11.6544"
        y2="7.88373"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint761_linear_253_19555"
        x1="8.02955"
        x2="8.02955"
        y1="11.5458"
        y2="7.88373"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint762_linear_253_19555"
        x1="8.04238"
        x2="8.04238"
        y1="11.4402"
        y2="7.88373"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint763_linear_253_19555"
        x1="8.0549"
        x2="8.0549"
        y1="11.3316"
        y2="7.88373"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint764_linear_253_19555"
        x1="8.06724"
        x2="8.06724"
        y1="11.226"
        y2="7.88374"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint765_linear_253_19555"
        x1="8.08008"
        x2="8.08008"
        y1="11.1174"
        y2="7.88374"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint766_linear_253_19555"
        x1="8.09438"
        x2="8.09438"
        y1="11.0119"
        y2="7.88374"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint767_linear_253_19555"
        x1="8.10543"
        x2="8.10543"
        y1="10.9033"
        y2="7.88374"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint768_linear_253_19555"
        x1="8.11582"
        x2="8.11582"
        y1="10.7977"
        y2="7.88374"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint769_linear_253_19555"
        x1="8.13208"
        x2="8.13208"
        y1="10.6891"
        y2="7.88374"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint770_linear_253_19555"
        x1="8.14442"
        x2="8.14442"
        y1="10.5835"
        y2="7.88375"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint771_linear_253_19555"
        x1="8.15547"
        x2="8.15547"
        y1="10.4749"
        y2="7.88375"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint772_linear_253_19555"
        x1="8.16977"
        x2="8.16977"
        y1="10.3694"
        y2="7.88375"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint773_linear_253_19555"
        x1="3.60038"
        x2="3.60072"
        y1="12.5036"
        y2="11.9932"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint774_linear_253_19555"
        x1="3.64851"
        x2="3.64921"
        y1="12.5642"
        y2="11.54"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint775_linear_253_19555"
        x1="3.69811"
        x2="3.69915"
        y1="12.6238"
        y2="11.0859"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint776_linear_253_19555"
        x1="3.74624"
        x2="3.74764"
        y1="12.6844"
        y2="10.6328"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint777_linear_253_19555"
        x1="3.79584"
        x2="3.79758"
        y1="12.745"
        y2="10.1797"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint778_linear_253_19555"
        x1="3.84398"
        x2="3.84607"
        y1="12.8046"
        y2="9.7256"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint779_linear_253_19555"
        x1="3.89357"
        x2="3.896"
        y1="12.8648"
        y2="9.2754"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint780_linear_253_19555"
        x1="3.94171"
        x2="3.94449"
        y1="12.9245"
        y2="8.8213"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint781_linear_253_19555"
        x1="3.9913"
        x2="3.99443"
        y1="12.9851"
        y2="8.36818"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint782_linear_253_19555"
        x1="4.03944"
        x2="4.04288"
        y1="13.042"
        y2="7.94142"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint783_linear_253_19555"
        x1="4.091"
        x2="4.09414"
        y1="13.042"
        y2="7.94142"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint784_linear_253_19555"
        x1="4.19062"
        x2="4.19377"
        y1="13.042"
        y2="7.94142"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint785_linear_253_19555"
        x1="4.28778"
        x2="4.29092"
        y1="13.042"
        y2="7.94142"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint786_linear_253_19555"
        x1="4.38691"
        x2="4.39005"
        y1="13.042"
        y2="7.94142"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint787_linear_253_19555"
        x1="4.48407"
        x2="4.48721"
        y1="13.042"
        y2="7.94142"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint788_linear_253_19555"
        x1="4.58515"
        x2="4.5883"
        y1="13.042"
        y2="7.94142"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint789_linear_253_19555"
        x1="4.68084"
        x2="4.68398"
        y1="13.042"
        y2="7.94142"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint790_linear_253_19555"
        x1="4.77997"
        x2="4.78312"
        y1="13.042"
        y2="7.94142"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint791_linear_253_19555"
        x1="4.88055"
        x2="4.88369"
        y1="13.042"
        y2="7.94142"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint792_linear_253_19555"
        x1="4.97675"
        x2="4.9799"
        y1="13.042"
        y2="7.94142"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint793_linear_253_19555"
        x1="5.07733"
        x2="5.08047"
        y1="13.042"
        y2="7.94142"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint794_linear_253_19555"
        x1="5.17499"
        x2="5.17814"
        y1="13.042"
        y2="7.94142"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint795_linear_253_19555"
        x1="5.27362"
        x2="5.27676"
        y1="13.042"
        y2="7.94142"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint796_linear_253_19555"
        x1="5.37274"
        x2="5.37588"
        y1="13.042"
        y2="7.94142"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint797_linear_253_19555"
        x1="5.46844"
        x2="5.47158"
        y1="13.042"
        y2="7.94142"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint798_linear_253_19555"
        x1="5.56952"
        x2="5.57266"
        y1="13.042"
        y2="7.94142"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint799_linear_253_19555"
        x1="5.66522"
        x2="5.66836"
        y1="13.042"
        y2="7.94142"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint800_linear_253_19555"
        x1="5.76581"
        x2="5.76895"
        y1="13.042"
        y2="7.94142"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint801_linear_253_19555"
        x1="5.86151"
        x2="5.86465"
        y1="13.042"
        y2="7.94142"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint802_linear_253_19555"
        x1="5.96258"
        x2="5.96572"
        y1="13.042"
        y2="7.94142"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint803_linear_253_19555"
        x1="6.05829"
        x2="6.06143"
        y1="13.042"
        y2="7.94142"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint804_linear_253_19555"
        x1="6.15741"
        x2="6.16055"
        y1="13.042"
        y2="7.94142"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint805_linear_253_19555"
        x1="6.25653"
        x2="6.25968"
        y1="13.042"
        y2="7.94142"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint806_linear_253_19555"
        x1="6.3537"
        x2="6.35684"
        y1="13.042"
        y2="7.94142"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint807_linear_253_19555"
        x1="6.45331"
        x2="6.45646"
        y1="13.042"
        y2="7.94142"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint808_linear_253_19555"
        x1="6.55047"
        x2="6.55361"
        y1="13.042"
        y2="7.94142"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint809_linear_253_19555"
        x1="6.6496"
        x2="6.65275"
        y1="13.042"
        y2="7.94142"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint810_linear_253_19555"
        x1="6.74676"
        x2="6.7499"
        y1="13.042"
        y2="7.94142"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint811_linear_253_19555"
        x1="6.84442"
        x2="6.84757"
        y1="13.042"
        y2="7.94142"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint812_linear_253_19555"
        x1="6.945"
        x2="6.94814"
        y1="13.042"
        y2="7.94142"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint813_linear_253_19555"
        x1="7.0412"
        x2="7.04435"
        y1="13.042"
        y2="7.94142"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint814_linear_253_19555"
        x1="7.14178"
        x2="7.14492"
        y1="13.042"
        y2="7.94142"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint815_linear_253_19555"
        x1="7.23944"
        x2="7.24259"
        y1="13.042"
        y2="7.94142"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint816_linear_253_19555"
        x1="7.33661"
        x2="7.33975"
        y1="13.042"
        y2="7.94142"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint817_linear_253_19555"
        x1="7.43573"
        x2="7.43888"
        y1="13.042"
        y2="7.94142"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint818_linear_253_19555"
        x1="7.51393"
        x2="7.51719"
        y1="13.042"
        y2="7.94142"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint819_linear_253_19555"
        x1="7.56541"
        x2="7.56875"
        y1="12.8552"
        y2="7.94142"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint820_linear_253_19555"
        x1="7.61298"
        x2="7.61597"
        y1="12.3415"
        y2="7.94142"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint821_linear_253_19555"
        x1="7.66592"
        x2="7.66857"
        y1="11.8277"
        y2="7.94142"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint822_linear_253_19555"
        x1="7.71154"
        x2="7.71383"
        y1="11.314"
        y2="7.94142"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint823_linear_253_19555"
        x1="7.76301"
        x2="7.76496"
        y1="10.8003"
        y2="7.94142"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint824_linear_253_19555"
        x1="7.81058"
        x2="7.81218"
        y1="10.2899"
        y2="7.94141"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint825_linear_253_19555"
        x1="7.86157"
        x2="7.86282"
        y1="9.77616"
        y2="7.94141"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint826_linear_253_19555"
        x1="7.91256"
        x2="7.91345"
        y1="9.26243"
        y2="7.94141"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint827_linear_253_19555"
        x1="7.96062"
        x2="7.96117"
        y1="8.7487"
        y2="7.94141"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint828_linear_253_19555"
        x1="8.0116"
        x2="8.0118"
        y1="8.23497"
        y2="7.94141"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint829_linear_253_19555"
        x1="1.32969"
        x2="1.33364"
        y1="16.3383"
        y2="10.5205"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint830_linear_253_19555"
        x1="1.37783"
        x2="1.38213"
        y1="16.3989"
        y2="10.0674"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint831_linear_253_19555"
        x1="1.42742"
        x2="1.43207"
        y1="16.4596"
        y2="9.61428"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint832_linear_253_19555"
        x1="1.47556"
        x2="1.48056"
        y1="16.5192"
        y2="9.16018"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint833_linear_253_19555"
        x1="1.52567"
        x2="1.53101"
        y1="16.5798"
        y2="8.70706"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint834_linear_253_19555"
        x1="1.57384"
        x2="1.57953"
        y1="16.639"
        y2="8.25589"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint835_linear_253_19555"
        x1="1.62347"
        x2="1.6295"
        y1="16.6996"
        y2="7.80276"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint836_linear_253_19555"
        x1="1.67164"
        x2="1.67803"
        y1="16.7602"
        y2="7.34964"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint837_linear_253_19555"
        x1="1.72127"
        x2="1.728"
        y1="16.8198"
        y2="6.89554"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint838_linear_253_19555"
        x1="1.76944"
        x2="1.77652"
        y1="16.8805"
        y2="6.44242"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint839_linear_253_19555"
        x1="1.81907"
        x2="1.8265"
        y1="16.9401"
        y2="5.98832"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint840_linear_253_19555"
        x1="1.86724"
        x2="1.87501"
        y1="17.0003"
        y2="5.53812"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint841_linear_253_19555"
        x1="1.91687"
        x2="1.92434"
        y1="17.0031"
        y2="5.51762"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint842_linear_253_19555"
        x1="2.01208"
        x2="2.01957"
        y1="17.006"
        y2="5.49711"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint843_linear_253_19555"
        x1="2.1107"
        x2="2.1182"
        y1="17.0088"
        y2="5.4766"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint844_linear_253_19555"
        x1="2.20298"
        x2="2.2105"
        y1="17.0117"
        y2="5.45609"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint845_linear_253_19555"
        x1="2.29965"
        x2="2.30718"
        y1="17.0145"
        y2="5.43558"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint846_linear_253_19555"
        x1="2.39681"
        x2="2.40437"
        y1="17.0164"
        y2="5.4141"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint847_linear_253_19555"
        x1="2.49397"
        x2="2.50154"
        y1="17.0192"
        y2="5.39359"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint848_linear_253_19555"
        x1="2.58918"
        x2="2.59677"
        y1="17.0221"
        y2="5.37308"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint849_linear_253_19555"
        x1="2.68439"
        x2="2.69198"
        y1="17.0249"
        y2="5.35258"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint850_linear_253_19555"
        x1="2.78008"
        x2="2.7877"
        y1="17.0277"
        y2="5.33207"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint851_linear_253_19555"
        x1="2.87871"
        x2="2.88633"
        y1="17.0306"
        y2="5.31156"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint852_linear_253_19555"
        x1="2.97245"
        x2="2.9801"
        y1="17.0334"
        y2="5.29105"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint853_linear_253_19555"
        x1="3.06912"
        x2="3.07678"
        y1="17.0363"
        y2="5.27055"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint854_linear_253_19555"
        x1="3.16482"
        x2="3.1725"
        y1="17.0391"
        y2="5.25004"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint855_linear_253_19555"
        x1="3.26149"
        x2="3.26918"
        y1="17.042"
        y2="5.22953"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint856_linear_253_19555"
        x1="3.35719"
        x2="3.3649"
        y1="17.0438"
        y2="5.20805"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint857_linear_253_19555"
        x1="3.45385"
        x2="3.46158"
        y1="17.0467"
        y2="5.18754"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint858_linear_253_19555"
        x1="3.54955"
        x2="3.5573"
        y1="17.0495"
        y2="5.16703"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint859_linear_253_19555"
        x1="3.64622"
        x2="3.65398"
        y1="17.0524"
        y2="5.14652"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint860_linear_253_19555"
        x1="3.74338"
        x2="3.75115"
        y1="17.0552"
        y2="5.12602"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint861_linear_253_19555"
        x1="3.83859"
        x2="3.84638"
        y1="17.058"
        y2="5.10551"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint862_linear_253_19555"
        x1="3.93575"
        x2="3.94355"
        y1="17.0609"
        y2="5.085"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint863_linear_253_19555"
        x1="4.03096"
        x2="4.03877"
        y1="17.0633"
        y2="5.06742"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint864_linear_253_19555"
        x1="4.12616"
        x2="4.13399"
        y1="17.0652"
        y2="5.04594"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint865_linear_253_19555"
        x1="4.22332"
        x2="4.23117"
        y1="17.068"
        y2="5.02543"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint866_linear_253_19555"
        x1="4.31853"
        x2="4.32639"
        y1="17.0709"
        y2="5.00492"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint867_linear_253_19555"
        x1="4.41423"
        x2="4.42211"
        y1="17.0737"
        y2="4.98441"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint868_linear_253_19555"
        x1="4.51285"
        x2="4.52074"
        y1="17.0766"
        y2="4.96391"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint869_linear_253_19555"
        x1="4.60806"
        x2="4.61597"
        y1="17.0794"
        y2="4.9434"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint870_linear_253_19555"
        x1="4.70326"
        x2="4.71119"
        y1="17.0823"
        y2="4.92289"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint871_linear_253_19555"
        x1="4.79896"
        x2="4.80691"
        y1="17.0851"
        y2="4.90238"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint872_linear_253_19555"
        x1="4.89563"
        x2="4.90359"
        y1="17.0879"
        y2="4.88188"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint873_linear_253_19555"
        x1="4.99279"
        x2="5.00077"
        y1="17.0908"
        y2="4.86137"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint874_linear_253_19555"
        x1="5.08995"
        x2="5.09794"
        y1="17.0927"
        y2="4.83988"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint875_linear_253_19555"
        x1="5.18174"
        x2="5.18975"
        y1="17.0955"
        y2="4.81938"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint876_linear_253_19555"
        x1="5.28036"
        x2="5.28837"
        y1="17.0983"
        y2="4.79887"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint877_linear_253_19555"
        x1="5.37411"
        x2="5.38214"
        y1="17.1012"
        y2="4.77836"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint878_linear_253_19555"
        x1="5.47077"
        x2="5.47882"
        y1="17.104"
        y2="4.75785"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint879_linear_253_19555"
        x1="5.56647"
        x2="5.57451"
        y1="17.1048"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint880_linear_253_19555"
        x1="5.66559"
        x2="5.67364"
        y1="17.1048"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint881_linear_253_19555"
        x1="5.76276"
        x2="5.7708"
        y1="17.1048"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint882_linear_253_19555"
        x1="5.86384"
        x2="5.87188"
        y1="17.1048"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint883_linear_253_19555"
        x1="5.95613"
        x2="5.96418"
        y1="17.1048"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint884_linear_253_19555"
        x1="6.05575"
        x2="6.06379"
        y1="17.0848"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint885_linear_253_19555"
        x1="6.14999"
        x2="6.15801"
        y1="17.0615"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint886_linear_253_19555"
        x1="6.24814"
        x2="6.25616"
        y1="17.0381"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint887_linear_253_19555"
        x1="6.34385"
        x2="6.35184"
        y1="17.0148"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint888_linear_253_19555"
        x1="6.44005"
        x2="6.44803"
        y1="16.9914"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint889_linear_253_19555"
        x1="6.53625"
        x2="6.54421"
        y1="16.9681"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint890_linear_253_19555"
        x1="6.6305"
        x2="6.63845"
        y1="16.9447"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint891_linear_253_19555"
        x1="6.72816"
        x2="6.73609"
        y1="16.9214"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint892_linear_253_19555"
        x1="6.82436"
        x2="6.83228"
        y1="16.898"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint893_linear_253_19555"
        x1="6.92056"
        x2="6.92845"
        y1="16.8747"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint894_linear_253_19555"
        x1="7.01676"
        x2="7.02465"
        y1="16.8546"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint895_linear_253_19555"
        x1="7.11247"
        x2="7.12034"
        y1="16.8313"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint896_linear_253_19555"
        x1="7.20867"
        x2="7.21653"
        y1="16.8079"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint897_linear_253_19555"
        x1="7.30291"
        x2="7.31075"
        y1="16.7846"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint898_linear_253_19555"
        x1="7.40058"
        x2="7.4084"
        y1="16.7612"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint899_linear_253_19555"
        x1="7.49531"
        x2="7.50312"
        y1="16.7379"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint900_linear_253_19555"
        x1="7.59298"
        x2="7.60077"
        y1="16.7145"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint901_linear_253_19555"
        x1="7.68771"
        x2="7.69548"
        y1="16.6912"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint902_linear_253_19555"
        x1="7.78538"
        x2="7.79314"
        y1="16.6678"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint903_linear_253_19555"
        x1="7.88109"
        x2="7.88882"
        y1="16.6445"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint904_linear_253_19555"
        x1="7.97582"
        x2="7.98355"
        y1="16.6211"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint905_linear_253_19555"
        x1="8.07348"
        x2="8.08119"
        y1="16.5978"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint906_linear_253_19555"
        x1="8.16773"
        x2="8.17543"
        y1="16.5744"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint907_linear_253_19555"
        x1="8.26539"
        x2="8.27307"
        y1="16.5511"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint908_linear_253_19555"
        x1="8.3616"
        x2="8.36926"
        y1="16.5277"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint909_linear_253_19555"
        x1="8.45779"
        x2="8.46543"
        y1="16.5044"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint910_linear_253_19555"
        x1="8.55399"
        x2="8.56162"
        y1="16.481"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint911_linear_253_19555"
        x1="8.64824"
        x2="8.65585"
        y1="16.4577"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint912_linear_253_19555"
        x1="8.7459"
        x2="8.7535"
        y1="16.4343"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint913_linear_253_19555"
        x1="8.84015"
        x2="8.84773"
        y1="16.411"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint914_linear_253_19555"
        x1="8.9383"
        x2="8.94587"
        y1="16.3876"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint915_linear_253_19555"
        x1="9.03254"
        x2="9.04009"
        y1="16.3643"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint916_linear_253_19555"
        x1="9.13021"
        x2="9.13775"
        y1="16.3409"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint917_linear_253_19555"
        x1="9.22837"
        x2="9.23589"
        y1="16.3176"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint918_linear_253_19555"
        x1="9.32261"
        x2="9.33011"
        y1="16.2942"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint919_linear_253_19555"
        x1="9.42028"
        x2="9.42777"
        y1="16.2709"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint920_linear_253_19555"
        x1="9.51452"
        x2="9.52199"
        y1="16.2475"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint921_linear_253_19555"
        x1="9.61268"
        x2="9.62013"
        y1="16.2242"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint922_linear_253_19555"
        x1="9.70692"
        x2="9.71436"
        y1="16.2008"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint923_linear_253_19555"
        x1="9.80458"
        x2="9.81201"
        y1="16.1775"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint924_linear_253_19555"
        x1="9.90078"
        x2="9.90819"
        y1="16.1541"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint925_linear_253_19555"
        x1="9.99503"
        x2="10.0024"
        y1="16.1308"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint926_linear_253_19555"
        x1="10.0927"
        x2="10.1001"
        y1="16.1107"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint927_linear_253_19555"
        x1="10.1685"
        x2="10.176"
        y1="16.0874"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint928_linear_253_19555"
        x1="10.2179"
        x2="10.2255"
        y1="15.8572"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint929_linear_253_19555"
        x1="10.2674"
        x2="10.2746"
        y1="15.3435"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint930_linear_253_19555"
        x1="10.3164"
        x2="10.3233"
        y1="14.8297"
        y2="4.75199"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint931_linear_253_19555"
        x1="10.3659"
        x2="10.3724"
        y1="14.316"
        y2="4.75198"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint932_linear_253_19555"
        x1="10.4135"
        x2="10.4196"
        y1="13.8023"
        y2="4.75198"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint933_linear_253_19555"
        x1="10.4649"
        x2="10.4707"
        y1="13.2919"
        y2="4.75198"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint934_linear_253_19555"
        x1="10.5124"
        x2="10.5179"
        y1="12.7782"
        y2="4.75198"
      >
        <stop stopColor="#6E3264" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
    </defs>
  </svg>
)

export default GameControllerLight
